<template>
  <span>
    <b-button variant="edit" @click="showTaskModal(task)" qid="delete-s-cancel-button" v-if="!fromHomepage">
      <span v-if="task">
        <font-awesome-icon icon="pen" />
      </span>
      <span v-if="!task">
        {{ $t('tasks.open_first_task') }}
      </span>
    </b-button>

    <b-button class="mr-2" variant="success" @click="showTaskModal(task)" qid="delete-s-cancel-button"
      v-if="fromHomepage">

      <span v-if="task">
        {{ $t('tasks.open_button') }}
      </span>
      <span v-if="!task">
        {{ $t('tasks.open_first_task') }}
      </span>
    </b-button>
    <!-- Task modal -->
    <b-modal ref="task-modal" @hide="hideTaskModal" size="xl" modal-class="bottom-left task-modal multi-color-modal">

      <!-- HEADER -->
      <template #modal-header="{ close }" class="alert-menu-color text-white">
        <div style="width: 100%;">
          <span @click="minimizeTask" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="window-minimize" />
          </span>
          <span @click="showEditQModal(selectedTask)" class="btn btn-secondary cursor-pointer float-right"
            v-if="isOwner(selectedTask)">
            <font-awesome-icon icon="cog" />
          </span>
          <h5 class="mb-1 text-center text-white"
            v-if="currentView != 'data_collection' && selectedTask && selectedTask.id && selectedTask.model && selectedTask.code != 'system_impact_assessment'">
            {{ selectedTask.full_title }}
          </h5>
          <h5 class="mb-1 text-center text-white"
            v-if="currentView == 'data_collection' && selectedTask && selectedTask.id && selectedTask.model && selectedTask.code != 'system_impact_assessment'">
            {{ selectedTask.full_title }}
          </h5>
          <h5 class="mb-1 text-center text-white"
            v-if="selectedTask && selectedTask.id && selectedTask.model && selectedTask.scope && selectedTask.code == 'system_impact_assessment'">
            {{ $t('system.assess_how') }}
            <span v-if="selectedTask.model.who_am_i == 'App\\System\\Models\\System'">
              {{ $t('system.the_system') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'">
              {{ $t('system.the_activity') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'">
              {{ $t('system.the_process') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.the_contract') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
              {{ $t('system.the_policy') }}
            </span>
            <span class="breadcrumb-item">
              <a @click="navigateToTask(selectedTask)" :class="{ 'not-clickable': !isOwner(selectedTask.model) }">
                <font-awesome-icon icon="desktop" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\System\\Models\\System'" />
                <font-awesome-icon icon="cubes" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'" />
                <font-awesome-icon icon="cube" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'" />
                <font-awesome-icon icon="file-signature" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'" />
                <font-awesome-icon icon="file-invoice" class="mr-1"
                  v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'" />

                {{ selectedTask.model.name }}
              </a>
            </span>

            {{ $t('system.impacts') }}
            <span v-if="selectedTask.scope.who_am_i == 'App\\System\\Models\\System'">
              {{ $t('system.the_system') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'">
              {{ $t('system.the_activity') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'">
              {{ $t('system.the_process') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.the_contract') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
              {{ $t('system.the_policy') }}
            </span>
            <span class="breadcrumb-item">
              <a @click="navigateToTaskScope(selectedTask)" :class="{ 'not-clickable': !isOwner(selectedTask.scope) }">
                <font-awesome-icon icon="desktop" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\System\\Models\\System'" />
                <font-awesome-icon icon="cubes" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'" />
                <font-awesome-icon icon="cube" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'" />
                <font-awesome-icon icon="file-signature" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'" />
                <font-awesome-icon icon="file-invoice" class="mr-1"
                  v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'" />

                {{ selectedTask.scope.name }}
              </a>
            </span>
          </h5>

          <!-- Header text Types-->

          <div class="row mt-3 pt-4 pb-1"
            v-if="selectedTask && selectedTask.id && selectedTask.code != 'update_measures'">
            <div class="col-md-12"
              v-if="(isOwner(selectedTask.project) || isOwner(selectedTask)) && currentView == 'data_collection'">
              <span class="text-success breadcrumb-item cursor-pointer" @click="switchCurrentView('default')">
                <font-awesome-icon icon="angle-left" class="mr-1" />
                {{ $t('tasks.modal.back_to_main_task') }}
              </span>
            </div>
            <div class="col-sm-6" v-if="selectedTask.scope.name">
              <b-form-group>
                <div class="">


                  <label qid="task-name" v-if="selectedTask.code == 'system_impact_assessment'">
                    {{ $t('tasks.modal.system_impact_title') }}
                  </label>
                  <div v-if="selectedTask.code == 'system_impact_assessment'" class="text-formatted">
                    <span v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'">
                      {{ $t('tasks.modal.system_impact_description_process') }}
                    </span>
                    <span v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'">
                      {{ $t('tasks.modal.system_impact_description_activity') }}
                    </span>
                  </div>

                  <!-- Type 1 main task-->
                  <div v-if="selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'">
                    <div class="type-header">{{ $t('system.type_one') }}</div>
                    <div v-if="selectedTask.description && selectedTask.description.length > 300">
                      <p v-if="showFullMainTaskDescriptionOne" class="text-formatted">
                        {{ selectedTask.description }}
                      </p>
                      <p v-if="!showFullMainTaskDescriptionOne" class="text-formatted">
                        {{ selectedTask.description | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                        @click="showFullMainTaskDescriptionOne = !showFullMainTaskDescriptionOne">
                        <span class="cursor-pointer" v-if="!showFullMainTaskDescriptionOne">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" class="text-white" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullMainTaskDescriptionOne">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" class="text-white" />
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.description && selectedTask.description.length <= 300" class="text-formatted">
                      {{ selectedTask.description }}
                    </p>
                  </div>

                  <!-- Type 1 documentation task -->
                  <div v-if="selectedTask.code != 'system_impact_assessment' && currentView == 'data_collection'">
                    <div style="margin-top:5px;" class="type-header">{{ $t('system.type_one') }}</div>
                    <div
                      v-if="selectedTask.data_collection_description && selectedTask.data_collection_description.length > 300">
                      <p v-if="showFullMainTaskDescriptionOne" class="text-formatted">
                        {{ selectedTask.data_collection_description }}
                      </p>
                      <p v-if="!showFullMainTaskDescriptionOne" class="text-formatted">
                        {{ selectedTask.data_collection_description | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                        @click="showFullMainTaskDescriptionOne = !showFullMainTaskDescriptionOne">
                        <span class="cursor-pointer" v-if="!showFullMainTaskDescriptionOne">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" class="text-white" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullMainTaskDescriptionOne">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" class="text-white" />
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.data_collection_description && selectedTask.data_collection_description.length <= 300"
                      class="text-formatted">
                      {{ selectedTask.data_collection_description }}
                    </p>
                  </div>


                </div>

                <!-- Question media -->
                <div class="mt-2 mb-1" v-if="getMedia('question') && currentView != 'data_collection'">
                  <p v-for="(file, media_index) in getMedia('question')" :key="media_index">
                    <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                      qid="download-media">
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>
                <div class="mt-2 mb-1" v-if="getMedia('data_collection') && currentView == 'data_collection'">
                  <p v-for="(file, media_index) in getMedia('data_collection')" :key="media_index">
                    <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                      qid="download-media">
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>

                <div class="" v-if="getLinks('question') && currentView != 'data_collection'">
                  <p v-for="(link, link_index) in getLinks('question')" :key="link_index">
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
                <div class="" v-if="getLinks('data_collection') && currentView == 'data_collection'">
                  <p v-for="(link, link_index) in getLinks('data_collection')" :key="link_index">
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </b-form-group>

            </div>
            <!-- Type 2 main task -->
            <div :class="{ 'col-sm-6': selectedTask.scope && selectedTask.scope.name, 'col-sm-12': !selectedTask.scope }">
              <b-form-group>
                <div class="">
                  <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openWelcomePage()"
                    v-if="welcomeGuide && welcomeGuide.id">
                    <font-awesome-icon icon="eye" />
                    {{ $t('system.welcome_page_button') }}
                  </span>
                  <div
                    v-if="selectedTask.code != 'system_impact_assessment' && selectedTask.project && selectedTask.project.project_type == 'type two' && currentView != 'data_collection'">
                    <div class="type-header">{{ $t('system.type_two') }}</div>
                    <div v-if="selectedTask.description_two && selectedTask.description_two.length > 300">
                      <p v-if="showFullMainTaskDescriptionTwo" class="text-formatted">
                        {{ selectedTask.description_two }}
                      </p>
                      <p v-if="!showFullMainTaskDescriptionTwo" class="text-formatted">
                        {{ selectedTask.description_two | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                        @click="showFullMainTaskDescriptionTwo = !showFullMainTaskDescriptionTwo">
                        <span class="cursor-pointer" v-if="!showFullMainTaskDescriptionTwo">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" class="text-white" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullMainTaskDescriptionTwo">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" class="text-white" />
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.description_two && selectedTask.description_two.length <= 300"
                      class="text-formatted">
                      {{ selectedTask.description_two }}
                    </p>
                  </div>
                  <div
                    v-if="selectedTask.code != 'system_impact_assessment' && selectedTask.project && selectedTask.project.project_type == 'type two' && currentView == 'data_collection'">
                    <div style="margin-top:5px;" class="type-header">{{ $t('system.type_two') }}</div>
                    <div
                      v-if="selectedTask.data_collection_description_two && selectedTask.data_collection_description_two.length > 300">
                      <p v-if="showFullMainTaskDescriptionTwo" class="text-formatted">
                        {{ selectedTask.data_collection_description_two }}
                      </p>
                      <p v-if="!showFullMainTaskDescriptionTwo" class="text-formatted">
                        {{ selectedTask.data_collection_description_two | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                        @click="showFullMainTaskDescriptionTwo = !showFullMainTaskDescriptionTwo">
                        <span class="cursor-pointer" v-if="!showFullMainTaskDescriptionTwo">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" class="text-white" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullMainTaskDescriptionTwo">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" class="text-white" />
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.data_collection_description_two && selectedTask.data_collection_description_two.length <= 300"
                      class="text-formatted">
                      {{ selectedTask.data_collection_description_two }}
                    </p>
                  </div>
                  <div
                    v-if="getGuide('assessment_task') && currentView == 'default' && selectedTask.code != 'update_measures'"
                    style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label"
                      v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription = !showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" />
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Data collection guide -->
                  <div v-if="getGuide('data_collection_task') && currentView == 'data_collection'"
                    style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label"
                      v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuideData && wpGuideData.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuideData.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuideData.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription = !showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" />
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- System description guide -->
                  <div
                    v-if="getGuide('system_description_task') && currentView == 'default' && selectedTask.code == 'update_measures'"
                    style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label"
                      v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuideSystem && wpGuideSystem.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuideSystem.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuideSystem.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription = !showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" />
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="mt-2 mb-1" v-if="getReportMedia && getReportMedia.length">
                  <p v-for="(file, media_index) in getReportMedia" :key="media_index">
                    <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                      qid="download-media">
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>

                <div class="" v-if="getReportLinks && getReportLinks.length">
                  <p v-for="(link, link_index) in getReportLinks" :key="link_index">
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-p-error">
        {{ error }}
      </b-alert>

      <!-- BODY MAIN TASK -->
      <b-form qid="create-p-form" @submit.prevent="() => { }"
        v-if="selectedTask && selectedTask.model && currentView == 'default' && selectedTask.code != 'update_measures'">
        <div class="form-container mt-0 mb-2">
          <div class="row mt-1">
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">

              <!--Documentation collection && Control Description-->
              <div class="card"
                v-if="!(selectedTask.data_collection_on && (selectedTask.add_control_description && selectedTask.add_control_description == 'No') && selectedTask.add_attachments == 'No')">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-2">
                    <div class="row">
                      <div class="col-md-6">
                        {{ $t('tasks.modal.data_collection_title') }}
                      </div>
                      <div class="col-md-6">
                        <span class="btn float-right btn-ai ml-3 pl-3 mt-0 cursor-pointer"
                          v-if="getClient.aiModule && selectedTask.status != 'completed'"
                          @click="toggleControlDescriptionDrawer">
                          <font-awesome-icon icon="sparkles" />
                          <span>{{ $t('tasks.modal.write_control_description') }}</span>
                        </span>
                      </div>
                      <!-- Sliding div -->
                      <div :class="{ 'drawer-open': isControlDescriptionDrawerOpen }" class="drawer">
                        <div class="mt-2">
                          <div class="col-md-12 text-right m-2">
                            <font-awesome-icon icon="times" class="text-light cursor-pointer"
                              @click="toggleControlDescriptionDrawer" />
                          </div>
                        </div>
                        <div class=" mt-3">
                          <div class="col-md-12 text-center">
                            <font-awesome-icon icon="sparkles" />
                            {{ $t('tasks.modal.write_control_description') }}
                          </div>
                        </div>

                        <div class="text-center mt-5" v-if="ailoading">
                          <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2" />
                          {{ $t('system.loading') }}
                          <p class="text-muted text-center m-3" style="font-size: medium;">
                            {{ $t('tasks.modal.please_wait_while_processing') }} ({{ timeLeft }}s)
                          </p>
                        </div>

                        <b-alert v-if="errorDescriptionDrawer.length" show variant="danger" qid="create-ai-error"
                          class="m-3">
                          {{ errorDescriptionDrawer }}
                        </b-alert>

                        <ul class="mt-3" style="list-style-type: none; padding-left: 0;font-size:14px;color:#000000;">
                          <li v-if="!ailoading" v-for="(choice, index) in controlDescriptionAi" :key="index"
                            class="p-3">
                            <div class="drawer-textbox formatted-text p-3">
                              <WordByWord :text="choice.message.content" :speed="60" :wordsPerStep="1"
                                :startDelay="index * 120" :trim="true" />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </h5>

                  <div v-if="selectedTask.data_collection_on">
                    <div class="mt-3 mb-3">
                      <div>
                        <label style="font-size: medium;">Status</label>
                        <span class="btn btn-secondary btn-sm float-right" @click="reopenFormSubmit"
                          v-if="selectedTask.data_status && selectedTask.data_status === 'completed'">
                          {{ $t('tasks.modal.data_collection_reopen_button') }}
                        </span>
                      </div>

                      <span
                        v-if="(selectedTask.data_status && selectedTask.data_status === 'completed') || selectedTask.status == 'completed'">
                        <font-awesome-icon icon="check-circle" class="icon-success" />
                      </span>
                      <span
                        v-if="selectedTask.data_status && selectedTask.data_status === 'pending' && selectedTask.status != 'completed'"
                        class="pr-1">
                        <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                      </span>
                      <span v-if="selectedTask.status == 'completed'">
                        {{ $t('system.' + $options.filters.slugify(selectedTask.status)) }}
                      </span>
                      <span v-else>
                        <span v-if="selectedTask.data_status">
                          {{ $t('system.' + $options.filters.slugify(selectedTask.data_status)) }}
                        </span>
                        <span v-if="!selectedTask.data_status">
                          <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                          {{ $t('system.pending') }}
                        </span>
                      </span>

                    </div>
                    <div class="mt-3 mb-3">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="text-bold" style="font-size: medium;">
                            {{ $t('tasks.table.data_collection_assignee') }}:
                            <span class="btn float-right ml-3 pl-3 mt-0 pt-0 text-success cursor-pointer"
                              @click="switchCurrentView('data_collection')">
                              {{ $t('tasks.modal.open_data_collection') }}
                            </span>
                          </div>
                          <div class="mt-1">
                            <span v-if="selectedTask.data_users && selectedTask.data_users.length">
                              <span class="mr-1 text-normal" v-for="(user, user_index) in selectedTask.data_users"
                                :key="user_index">
                                <span qid="profile-photo">
                                  <Avatar :object="user" size="xs"></Avatar>
                                </span>
                              </span>
                            </span>
                            <span v-if="!selectedTask.data_users.length" class="mr-1">
                              <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-1" />
                              {{ $t('risk.missing_input') }}
                            </span>
                            <span class="pl-2 cursor-pointer" @click="showReopenDataCollectionModal"
                              v-if="selectedTask.status != 'completed'">
                              <font-awesome-icon icon="pen" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>


                    <!--Conclusion card: Response-->
                    <b-form-group
                      v-if="selectedTask && selectedTask.add_response_doc && (selectedTask.add_response_doc == 'Optional' || selectedTask.add_response_doc == 'Mandatory' || selectedTask.add_response_doc == 'Auditor')">
                      <label qid="assessment-form-response-label" style="font-size: medium;" class="mt-3">
                        {{ $t('tasks.modal.response_label_documentation') }}
                        <span class="text-red"
                          v-if="selectedTask && (selectedTask.add_response_doc == 'Mandatory' || selectedTask.add_response_doc == 'Auditor')">*</span>
                      </label>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="editModeResponseDocMain = !editModeResponseDocMain"
                        v-if="selectedTask.add_response_doc == 'Auditor' && !editModeResponseDocMain && selectedTask.status != 'completed'">
                        <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                      </span>

                      <span class="btn section-btn text-danger cursor-pointer float-right"
                        @click="discardResponseDoc(selectedTask)"
                        v-if="editModeResponseDocMain && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.discard') }}
                      </span>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="updateResponseDoc(selectedTask)"
                        v-if="editModeResponseDocMain && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.save') }}
                      </span>

                      <div v-if="selectedTask.add_response_doc != 'Datepicker'">
                        <multiselect v-if="editModeResponseDocMain && selectedTask.status != 'completed'"
                          v-model="selectedAnswerDoc" qid="assessment-form-response-drop-down" :options="allAnswersDoc"
                          :multiple="false" :taggable="false" label="title"
                          :select-label="$t('system.dropdown_select_label')"
                          :selected-label="$t('system.dropdown_selected_label')"
                          :deselect-label="$t('system.dropdown_deselect_label')"
                          :placeholder="$t('tasks.modal.response_placeholder')">
                          <template slot="option" slot-scope="props">
                            <font-awesome-icon icon="check-circle" class="icon-success"
                              v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                            <font-awesome-icon icon="info-circle" class="icon-info"
                              v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                            <font-awesome-icon icon="times-circle" class="icon-danger"
                              v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                              v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                              v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                              v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                              v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                            <span class="ml-2">
                              {{ props.option.title }}
                            </span>
                          </template>
                          <template slot="singleLabel" slot-scope="props">
                            <font-awesome-icon icon="check-circle" class="icon-success"
                              v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                            <font-awesome-icon icon="info-circle" class="icon-info"
                              v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                            <font-awesome-icon icon="times-circle" class="icon-danger"
                              v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                              v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                              v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                              v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                              v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                            <span class="ml-2">
                              {{ props.option.title }}
                            </span>
                          </template>
                        </multiselect>

                        <p v-if="(!editModeResponseDocMain && selectedAnswerDoc && selectedAnswerDoc.title) || selectedTask.status == 'completed'"
                          class="">
                          <font-awesome-icon icon="check-circle" class="icon-success"
                            v-if="getIconDoc(selectedTask) == 'Positive'" />
                          <font-awesome-icon icon="times-circle" class="icon-danger"
                            v-if="getIconDoc(selectedTask) == 'Negative'" />
                          <font-awesome-icon icon="info-circle" class="icon-info"
                            v-if="getIconDoc(selectedTask) == 'Neutral'" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                            v-if="getIconDoc(selectedTask) == 'Very low'" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                            v-if="getIconDoc(selectedTask) == 'Low'" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                            v-if="getIconDoc(selectedTask) == 'High'" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                            v-if="getIconDoc(selectedTask) == 'Very high'" />
                          {{ selectedAnswerDoc.title }}
                        </p>

                        <p v-if="!editModeResponseDocMain && !selectedAnswerDoc" qid="no-results-row-rr"
                          class="text-muted">
                          {{ $t('system.no_results') }}
                        </p>
                      </div>

                      <div v-if="selectedTask.add_response_doc == 'Datepicker'">
                        <datepicker v-if="editModeResponseDocMain && selectedTask.status != 'completed'"
                          class="date-picker" qid="assessment-form-response-datepicker" calendar-class="right"
                          v-model="selectedDateDoc" :clear-button="true"
                          :placeholder="$t('tasks.modal.response_label')"></datepicker>

                        <p v-if="!editModeResponseDocMain && selectedDateDoc" class="">
                          <font-awesome-icon icon="calendar-alt" class="mr-1" />
                          {{ selectedDate | formatDate }}
                        </p>

                        <p v-if="!editModeResponseDocMain && !selectedDateDoc" qid="no-results-row-rr"
                          class="text-muted">
                          {{ $t('system.no_results') }}
                        </p>
                      </div>
                    </b-form-group>

                    <label qid="assessment-form-documentation-collection-control-description-label"
                      style="font-size: medium;">
                      {{ $t('tasks.modal.data_collection_comment') }}
                    </label>
                    <div class="pb-2 border-bottom" style="margin-top: -20px;"
                      v-if="selectedTask.data_remarks && selectedTask.data_remarks.length">
                      <div v-if="selectedTask.data_remarks && selectedTask.data_remarks.length > 300">
                        <p v-if="showFullDataCollectionDescription" class="text-formatted">
                          {{ selectedTask.data_remarks }}
                        </p>
                        <p v-if="!showFullDataCollectionDescription" class="text-formatted">
                          {{ selectedTask.data_remarks | truncate(300) }}
                        </p>
                        <div class="text-center mt-3"
                          @click="showFullDataCollectionDescription = !showFullDataCollectionDescription">
                          <span class="cursor-pointer" v-if="!showFullDataCollectionDescription">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="showFullDataCollectionDescription">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="selectedTask.data_remarks && selectedTask.data_remarks.length <= 300"
                        class="text-formatted">
                        {{ selectedTask.data_remarks }}
                      </p>
                    </div>
                    <div v-else class="text-muted pb-2 border-bottom">{{ $t('system.no_results') }}</div>
                  </div>

                  <!--Control description-->
                  <div class="mt-3">
                    <b-form-group
                      v-if="selectedTask && selectedTask.add_control_description && selectedTask.add_control_description == 'Optional' || selectedTask.add_control_description == 'Mandatory'">
                      <label qid="assessment-form-control-description-label" class="mt-3" style="font-size: medium;">
                        {{ $t('tasks.modal.control_description_label') }}
                        <span class="text-red"
                          v-if="selectedTask && selectedTask.add_control_description == 'Mandatory'">*</span>
                        <span qid="profile-photo" v-b-tooltip.hover class="pl-2" title="Output to report">
                          <font-awesome-icon icon="file" style="color:#081F26" />
                        </span>
                      </label>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="editModeControlDescription = !editModeControlDescription"
                        v-if="!editModeControlDescription && selectedTask.status != 'completed'">
                        <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                      </span>

                      <span class="btn section-btn text-danger cursor-pointer float-right"
                        @click="discardControlDescription(selectedTask)"
                        v-if="editModeControlDescription && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.discard') }}
                      </span>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="updateControlDescription(selectedTask)"
                        v-if="editModeControlDescription && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.save') }}
                      </span>

                      <b-form-textarea qid="assessment-form-control-description" v-model="taskForm.control_description"
                        v-if="editModeControlDescription && selectedTask.status != 'completed'" rows="6" max-rows="6"
                        :required="selectedTask.add_control_description == 'Mandatory'"
                        :placeholder="$t('tasks.modal.control_description_placeholder')"></b-form-textarea>

                      <div v-if="!editModeControlDescription || selectedTask.status == 'completed'"
                        style="margin-top: -20px;">
                        <div v-if="taskForm.control_description && taskForm.control_description.length > 300">
                          <p v-if="showFullTextControlDescription" class="text-formatted" style="margin-top: -20px;">
                            {{ taskForm.control_description }}
                          </p>

                          <p v-if="!showFullTextControlDescription" class="text-formatted">
                            {{ taskForm.control_description | truncate(300) }}
                          </p>

                          <div class="text-center mt-3"
                            @click="showFullTextControlDescription = !showFullTextControlDescription">
                            <span class="cursor-pointer" v-if="!showFullTextControlDescription">
                              <span class="mr-2">
                                {{ $t('system.view_more') }}
                              </span>
                              <font-awesome-icon icon="chevron-down" />
                            </span>
                            <span class="cursor-pointer" v-if="showFullTextControlDescription">
                              <span class="mr-2">
                                {{ $t('system.view_less') }}
                              </span>
                              <font-awesome-icon icon="chevron-up" />
                            </span>
                          </div>
                        </div>

                        <p v-if="taskForm.control_description && taskForm.control_description.length <= 300"
                          class="text-formatted">
                          {{ taskForm.control_description }}
                        </p>
                        <p v-if="!taskForm.control_description" qid="no-results-row-rr" class="text-muted"
                          style="margin-top: 20px;">
                          {{ $t('system.no_results') }}
                        </p>
                      </div>
                    </b-form-group>
                  </div>

                  <div class="w-100" @dragover.prevent @drop.prevent="handleDrop">
                    <div v-show="showDropActive" class="drop-active">
                      <h3>Drop files to upload</h3>
                    </div>
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                      {{ $t('attachments.label') }}
                    </label>
                    <span class="float-right">
                      <file-upload v-if="selectedTask.status != 'completed'" ref="uploader" v-model="files" :drop="true"
                        :multiple="true" input-id="task-file" @input="onFileChangeEdit"
                        @dropActive="showDropActiveFunction" @dropInactive="hideDropActiveFunction"
                        class="text-success cursor-pointer float:right mt-3">
                        {{ $t('tasks.modal.add_attachment_label') }}
                      </file-upload>
                    </span>
                  </div>

                  <ul class="compact-list" style="list-style-type: none; padding-left: 0;">
                    <li v-for="(item, index) in getMedia('task_and_data_collection')" :key="index"
                      class="text-bold list-item mb-2">
                      <div class="row" style="height:20px;">
                        <div class="col-md-8">
                          <a :href="item.url" target="_blank" class="btn btn-link p-0" qid="download-media">
                            {{ item.full_title }}
                          </a>
                        </div>
                        <div class="actions col-md-4">
                          <div class="float-right">
                            <a :href="item.url" target="_blank" class="btn" qid="download-media">
                              <font-awesome-icon icon="eye" />
                            </a>
                            <a class="btn" @click="downloadMedia(item)" qid="download-media">
                              <font-awesome-icon icon="cloud-download-alt" />
                            </a>
                            <a class="btn" @click="openDeleteAttachmentModal(item)" qid="remove-media-item"
                              v-if="selectedTask.status != 'completed'">
                              <font-awesome-icon icon="trash-alt" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li v-if="!getMedia('task_and_data_collection').length && !selectedTask.linked_media.length"
                      qid="no-results-row-rr" class="">
                      <div class="text-muted">{{ $t('system.no_results') }}</div>
                    </li>
                  </ul>

                  <ul class="compact-list" style="list-style-type: none; padding-left: 0;">
                    <li v-for="(item, index) in selectedTask.linked_media" :key="index"
                      class="text-bold list-item mb-2">
                      <div class="row" style="height:20px;">
                        <div class="col-md-8">
                          <a :href="item.url" target="_blank" class="btn btn-link p-0" qid="download-media">
                            {{ item.full_title }}
                          </a>
                        </div>

                        <div class="actions col-md-4">
                          <div class="float-right">
                            <a :href="item.url" target="_blank" class="btn" qid="download-media">
                              <font-awesome-icon icon="eye" />
                            </a>
                            <a class="btn" @click="downloadMedia(item)" qid="download-media">
                              <font-awesome-icon icon="cloud-download-alt" />
                            </a>
                            <a class="btn" @click="openDeleteLinkedAttachmentModal(item)" qid="remove-media-item"
                              v-if="selectedTask.status != 'completed'">
                              <font-awesome-icon icon="trash-alt" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>

                  <div class="w-100" v-if="allLinkedMediaFiles.length && selectedTask.status != 'completed'">
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                      {{ $t('attachments.suggested_label') }}

                    </label>
                    <span class="btn text-success cursor-pointer float-right pt-2"
                      @click="updateLinkedMedia(selectedTask)" v-if="selectedTask.status != 'completed'">
                      Add selected
                    </span>
                  </div>
                  <ul class="compact-list" style="list-style-type: none; padding-left: 0;"
                    v-if="allLinkedMediaFiles.length && selectedTask.status != 'completed'">
                    <li v-for="(item, index) in allLinkedMediaFiles" :key="index" class="text-bold list-item mb-2">
                      <div class="row">
                        <span class="col-md-10 pr-0">
                          <a :href="item.url" target="_blank" class="btn btn-link p-0 text-muted" qid="download-media">
                            {{ item.full_title }}
                          </a>
                        </span>
                        <span class="actions pt-1 pl-0 pr-4 col-md-2 text-right" style="float: right;">
                          <input type="checkbox" v-model="selectedLinkedMedia" :value="item" />
                        </span>
                      </div>
                    </li>
                    <li qid="no-results-row-rr" class=""
                      v-if="!allLinkedMediaFiles.length && selectedTask.status != 'completed'">
                      <div class="text-muted">{{ $t('system.no_results') }}</div>
                    </li>
                  </ul>
                </div>
              </div>

              <!--Testing card-->
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-2">
                    <div class="row">
                      <div class="col-md-6">
                        {{ $t('tasks.modal.testing') }}
                      </div>
                      <div class="col-md-6">
                        <span class="btn btn-ai float-right ml-3 pl-3 mt-0 cursor-pointer" @click="toggleTestingDrawer"
                          v-if="getClient.aiModule && selectedTask.status != 'completed'">
                          <font-awesome-icon icon="sparkles" />
                          <span>{{ $t('tasks.modal.write_test_plan') }}</span>
                        </span>
                      </div>
                      <!-- Sliding div -->
                      <div :class="{ 'drawer-open': isTestingDrawerOpen }" class="drawer">
                        <div class="mt-2">
                          <div class="col-md-12 text-right m-2">
                            <font-awesome-icon icon="times" class="text-light cursor-pointer"
                              @click="toggleTestingDrawer" />
                          </div>
                        </div>
                        <div class=" mt-3">
                          <div class="col-md-12 text-center">
                            <font-awesome-icon icon="sparkles" />
                            {{ $t('tasks.modal.write_test_plan') }}
                          </div>
                        </div>

                        <div class="text-center mt-5" v-if="ailoading">
                          <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2" />
                          {{ $t('system.loading') }}
                          <p class="text-muted text-center m-3" style="font-size: medium;">
                            {{ $t('tasks.modal.please_wait_while_processing') }} ({{ timeLeft }}s)
                          </p>
                        </div>

                        <b-alert v-if="errorTestingDrawer.length" show variant="danger" qid="create-ai-error"
                          class="m-3">
                          {{ errorTestingDrawer }}
                        </b-alert>

                        <ul class="mt-3" style="list-style-type: none; padding-left: 0;font-size:14px;color:#000000;">
                          <li v-if="!ailoading" v-for="(choice, index) in testPlanAi" :key="index" class="p-3">
                            <div class="drawer-textbox formatted-text p-3">
                              <WordByWord :text="choice.message.content" :speed="60" :wordsPerStep="1"
                                :startDelay="index * 120" :trim="true" />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </h5>
                  <b-form-group v-if="selectedTask && selectedTask.add_testing_notes != 'No'">

                    <label qid="assessment-form-performed-test-label" style="font-size: medium;" class="mt-1">
                      {{ $t('tasks.modal.testing_notes_label') }}
                      <span class="text-red"
                        v-if="selectedTask && selectedTask.add_testing_notes == 'Mandatory'">*</span>
                    </label>

                    <span class="btn text-success cursor-pointer float-right"
                      @click="editModeTestingNotes = !editModeTestingNotes"
                      v-if="!editModeTestingNotes && selectedTask.status != 'completed'">
                      <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                    </span>

                    <span class="btn text-danger cursor-pointer float-right" @click="discardTestingNotes(selectedTask)"
                      v-if="editModeTestingNotes && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.discard') }}
                    </span>

                    <span class="btn text-success cursor-pointer float-right" @click="updateTestingNotes(selectedTask)"
                      v-if="editModeTestingNotes && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.save') }}
                    </span>

                    <b-form-textarea qid="assessment-form-performed-test" v-model="taskForm.testing_notes"
                      v-if="editModeTestingNotes && selectedTask.status != 'completed'" rows="6" max-rows="6"
                      :required="selectedTask.add_performed_text == 'Mandatory'"
                      :placeholder="$t('tasks.modal.testing_notes_placeholder')"></b-form-textarea>

                    <div v-if="!editModeTestingNotes || selectedTask.status == 'completed'" style="margin-top: -20px;">
                      <div v-if="taskForm.testing_notes && taskForm.testing_notes.length > 300">
                        <p v-if="showFullTextTestingNotes" class="text-formatted">
                          {{ taskForm.testing_notes }}
                        </p>

                        <p v-if="!showFullTextTestingNotes" class="text-formatted">
                          {{ taskForm.testing_notes | truncate(300) }}
                        </p>

                        <div class="text-center mt-3" @click="showFullTextTestingNotes = !showFullTextTestingNotes">
                          <span class="cursor-pointer" v-if="!showFullTextTestingNotes">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="showFullTextTestingNotes">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="taskForm.testing_notes && taskForm.testing_notes.length <= 300" class="text-formatted">
                        {{ taskForm.testing_notes }}
                      </p>
                      <p v-if="!taskForm.testing_notes" qid="no-results-row-rr" class="text-muted"
                        style="margin-top: 20px;">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>
                  </b-form-group>

                  <div class="w-100" v-if="selectedTask.status != 'completed' || tests.length">
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;">
                      {{ $t('testing.title') }}
                    </label>
                    <span class="float-right">
                      <button class="btn ml-3 pl-3 text-success" @click="showTestCreateModal()"
                        v-if="selectedTask.status != 'completed'">
                        <font-awesome-icon icon="plus" /> {{ $t('testing.form.create_new_test') }}
                      </button>
                    </span>
                  </div>

                  <ul class="list-secondary mt-2" style="list-style-type: none; padding-left: 0;"
                    v-if="selectedTask.status != 'completed' || tests.length">
                    <li v-for="object in tests" class="text-bold list-item testing-list-item mb-2">
                      <span class="status-container">
                        <div class="status-icon">
                          <span v-if="object.status == 'pending'">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                          </span>
                          <span v-if="object.status == 'documentation_collection_completed'">
                            <font-awesome-icon icon="info-circle" class="icon-info" />
                          </span>
                          <span v-if="object.status == 'passed'">
                            <font-awesome-icon icon="check-circle" class="icon-success" />
                          </span>
                          <span v-if="object.status == 'failed'">
                            <font-awesome-icon icon="times-circle" class="icon-danger" />
                          </span>
                        </div>
                        <div class="status-button">
                          <button v-if="object" @click="openTestModal(object)" qid="observation-name-link"
                            class="btn btn-link text-left">
                            {{ object.name }}
                          </button>
                        </div>
                      </span>
                      <span class="testing-actions" v-if="selectedTask.status != 'completed'">
                        <span class="btn cursor-pointer" @click="showEditTestModal(object)"
                          qid="delete-s-cancel-button">
                          <span>
                            <font-awesome-icon icon="pen" />
                          </span>
                        </span>
                        <span class="btn cursor-pointer" @click="showTestConfirmDeleteModal(object)">
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                      </span>
                    </li>

                    <li v-if="!loadingTests && tests && !tests.length" qid="no-results-row-rr" class="">
                      <div class="text-muted">{{ $t('system.no_results') }}</div>
                    </li>

                    <li v-if="loadingTests">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </li>
                  </ul>

                  <b-form-group
                    v-if="selectedTask && selectedTask.add_performed_text && selectedTask.add_performed_text == 'Optional' || selectedTask.add_performed_text == 'Mandatory'">

                    <label qid="assessment-form-performed-test-label" style="font-size: medium;" class="mt-3">
                      {{ $t('tasks.modal.performed_test_label') }}
                      <span class="text-red"
                        v-if="selectedTask && selectedTask.add_performed_text == 'Mandatory'">*</span>
                      <span qid="profile-photo" v-b-tooltip.hover class="pl-2" title="Output to report">
                        <font-awesome-icon icon="file" style="color:#081F26" />
                      </span>
                    </label>

                    <span class="btn text-success cursor-pointer float-right"
                      @click="editModePerformedTest = !editModePerformedTest"
                      v-if="!editModePerformedTest && selectedTask.status != 'completed'">
                      <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                    </span>

                    <span class="btn text-danger cursor-pointer float-right" @click="discardPerformedTest(selectedTask)"
                      v-if="editModePerformedTest && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.discard') }}
                    </span>

                    <span class="btn text-success cursor-pointer float-right" @click="updatePerformedTest(selectedTask)"
                      v-if="editModePerformedTest && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.save') }}
                    </span>

                    <b-form-textarea qid="assessment-form-performed-test" v-model="taskForm.performed_text"
                      v-if="editModePerformedTest && selectedTask.status != 'completed'" rows="6" max-rows="6"
                      :required="selectedTask.add_performed_text == 'Mandatory'"
                      :placeholder="$t('tasks.modal.performed_test_placeholder')"></b-form-textarea>

                    <div v-if="!editModePerformedTest || selectedTask.status == 'completed'" style="margin-top: -20px;">
                      <div v-if="taskForm.performed_text && taskForm.performed_text.length > 300">
                        <p v-if="showFullTextPerformedTest" class="text-formatted">
                          {{ taskForm.performed_text }}
                        </p>

                        <p v-if="!showFullTextPerformedTest" class="text-formatted">
                          {{ taskForm.performed_text | truncate(300) }}
                        </p>

                        <div class="text-center mt-3" @click="showFullTextPerformedTest = !showFullTextPerformedTest">
                          <span class="cursor-pointer" v-if="!showFullTextPerformedTest">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="showFullTextPerformedTest">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="taskForm.performed_text && taskForm.performed_text.length <= 300" class="text-formatted">
                        {{ taskForm.performed_text }}
                      </p>
                      <p v-if="!taskForm.performed_text" qid="no-results-row-rr" class="text-muted"
                        style="margin-top: 20px;">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>
                  </b-form-group>

                </div>
              </div>
            </div>

            <!-- Chat and notes card-->
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">
              <div v-if="selectedTask.data_collection_on">

                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title border-bottom pb-2"> {{ $t('tasks.modal.chat_notes') }}</h5>

                    <!-- Chat and notes card: Chat-->
                    <div class="mt-3 mb-3">
                      <div class="row"
                        v-if="selectedTask.data_status != 'completed' && selectedTask.status != 'completed'">
                        <div class="col-sm-10 chat-box-col-text">
                          <b-form-textarea qid="create-s-form-description" v-model="comment" class="chat-box-text"
                            rows="2" max-rows="2"
                            :placeholder="$t('tasks.modal.question_to_recipient_label')"></b-form-textarea>
                        </div>
                        <div class="col-sm-2 chat-box-col-button cursor-pointer">
                          <div class="chat-box-button" @click="addCommentSubmit">
                            {{ $t('tasks.modal.send_button_label') }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-control scrollable-height-260 pt-3" style="background-color: white;">
                      <div v-if="previousComments && previousComments.length">
                        <div v-for="(comment, comment_index) in previousComments" class="mt-2 chat-message"
                          :key="comment_index">
                          <p>
                            <span class="cursor-pointer float-right" @click="openDeleteCommentModal(comment)"
                              v-if="isCommentOwner(comment) && selectedTask.status != 'completed'"
                              qid="view-p-remove-link">
                              <font-awesome-icon icon="trash-alt" />
                            </span>
                            <Avatar :object="comment.user" size="xs"></Avatar>
                            <span class="ml-1">
                              {{ comment.user.name }}
                            </span>
                            {{ $t('system.on') }}
                            <span class="text-normal">
                              {{ comment.updated_at | formatDateTime }}
                            </span>
                          </p>
                          <div v-if="comment.comment && comment.comment.length > 300">
                            <p v-if="comment.expanded" class="text-formatted">{{ comment.comment }}</p>

                            <p v-if="!comment.expanded" class="text-formatted">{{ comment.comment | truncate(300) }}</p>

                            <div class="text-center mt-3" @click="comment.expanded = !comment.expanded">
                              <span class="cursor-pointer" v-if="!comment.expanded">
                                <span class="mr-2">
                                  {{ $t('system.view_more') }}
                                </span>
                                <font-awesome-icon icon="chevron-down" />
                              </span>
                              <span class="cursor-pointer" v-if="comment.expanded">
                                <span class="mr-2">
                                  {{ $t('system.view_less') }}
                                </span>
                                <font-awesome-icon icon="chevron-up" />
                              </span>
                            </div>
                          </div>

                          <p v-if="comment.comment && comment.comment.length <= 300" class="text-formatted">{{
                            comment.comment
                            }}</p>
                        </div>
                      </div>
                      <div v-if="!previousComments.length" class="text-center">
                        <h5 class="mt-3">
                          {{ $t('system.no_results') }}
                        </h5>
                      </div>
                    </div>

                    <!-- Chat and notes card: Notes-->
                    <b-form-group
                      v-if="selectedTask && selectedTask.add_notes && selectedTask.add_notes == 'Optional' || selectedTask.add_notes == 'Mandatory'"
                      class="mb-3">
                      <label qid="assessment-form-notes-label" style="font-size: medium;" class="mt-3">
                        {{ $t('tasks.modal.notes_label') }}
                        <span class="text-red" v-if="selectedTask && selectedTask.add_notes == 'Mandatory'">*</span>
                      </label>

                      <span class="btn section-btn text-success cursor-pointer float-right mt-2"
                        @click="editModeNotes = !editModeNotes"
                        v-if="!editModeNotes && selectedTask.status != 'completed'">
                        <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                      </span>

                      <span class="btn section-btn text-danger cursor-pointer float-right"
                        @click="discardNotes(selectedTask)" v-if="editModeNotes && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.discard') }}
                      </span>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="updateNotes(selectedTask)" v-if="editModeNotes && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.save') }}
                      </span>

                      <b-form-textarea qid="assessment-form-notes" v-model="taskForm.notes"
                        v-if="editModeNotes && selectedTask.status != 'completed'" rows="6" max-rows="6"
                        :required="selectedTask.add_notes == 'Mandatory'"
                        :placeholder="$t('tasks.modal.notes_placeholder')"></b-form-textarea>

                      <div v-if="!editModeNotes || selectedTask.status == 'completed'" style="margin-top: -20px;">
                        <div v-if="taskForm.notes && taskForm.notes.length > 300">
                          <p v-if="showFullTextNotes" class="text-formatted">
                            {{ taskForm.notes }}
                          </p>

                          <p v-if="!showFullTextNotes" class="text-formatted">
                            {{ taskForm.notes | truncate(300) }}
                          </p>

                          <div class="text-center mt-3" @click="showFullTextNotes = !showFullTextNotes">
                            <span class="cursor-pointer" v-if="!showFullTextNotes">
                              <span class="mr-2">
                                {{ $t('system.view_more') }}
                              </span>
                              <font-awesome-icon icon="chevron-down" />
                            </span>
                            <span class="cursor-pointer" v-if="showFullTextNotes">
                              <span class="mr-2">
                                {{ $t('system.view_less') }}
                              </span>
                              <font-awesome-icon icon="chevron-up" />
                            </span>
                          </div>
                        </div>

                        <p v-if="taskForm.notes && taskForm.notes.length <= 300" class="text-formatted">
                          {{ taskForm.notes }}
                        </p>

                        <p v-if="!taskForm.notes" qid="no-results-row-rr" class="text-muted" style="margin-top: 20px;">
                          {{ $t('system.no_results') }}
                        </p>
                      </div>
                    </b-form-group>

                  </div>
                </div>

              </div>


              <!--Conclusion card-->
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-2">
                    <div class="row">
                      <div class="col-md-6">
                        {{ $t('tasks.modal.conclusion_and_observatons') }}
                      </div>
                      <div class="col-md-6">
                        <span class="btn btn-ai float-right ml-3 pl-3 mt-0 cursor-pointer"
                          @click="toggleFullAnalystDrawer" v-if="getClient.aiModule">
                          <font-awesome-icon icon="sparkles" />
                          <span>{{ $t('tasks.modal.full_analyst') }}</span>
                        </span>


                        <!-- Sliding div -->
                        <div :class="{ 'drawer-open': isFullAnalystDrawerOpen }" class="drawer">
                          <div class="mt-2">
                            <div class="col-md-12 text-right m-2">
                              <font-awesome-icon icon="times" class="text-light cursor-pointer"
                                @click="toggleFullAnalystDrawer" />
                            </div>
                          </div>
                          <div class=" mt-3">
                            <div class="col-md-12 text-center">
                              <font-awesome-icon icon="sparkles" />
                              {{ $t('tasks.modal.full_analyst') }}
                            </div>
                          </div>

                          <div class="text-center mt-5" v-if="ailoading">
                            <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2" />
                            {{ $t('system.loading') }}
                            <p class="text-muted text-center m-3" style="font-size: medium;">
                              {{ $t('tasks.modal.please_wait_while_processing') }} ({{ timeLeft }}s)
                            </p>
                          </div>

                          <b-alert v-if="errorFullAnalystDrawer.length" show variant="danger" qid="create-ai-error"
                            class="m-3">
                            {{ errorFullAnalystDrawer }}
                          </b-alert>

                          <ul class="mt-3" style="list-style-type: none; padding-left: 0;font-size:14px;color:#000000;">
                            <li v-if="!ailoading" v-for="(choice, index) in fullAnalystAi" :key="index" class="p-3">
                              <div class="drawer-textbox formatted-text p-3">
                                <WordByWord :text="choice.message.content" :speed="60" :wordsPerStep="1"
                                  :startDelay="index * 120" :trim="true" />
                              </div>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </h5>

                  <!--Conclusion card: Response-->
                  <b-form-group
                    v-if="selectedTask && selectedTask.add_response && selectedTask.add_response == 'Optional' || selectedTask.add_response == 'Mandatory'">
                    <label qid="assessment-form-response-label" style="font-size: medium;" class="mt-3">
                      {{ $t('tasks.modal.response_label') }}
                      <span class="text-red" v-if="selectedTask && selectedTask.add_response == 'Mandatory'">*</span>
                    </label>

                    <span class="btn section-btn text-success cursor-pointer float-right"
                      @click="editModeResponse = !editModeResponse"
                      v-if="!editModeResponse && selectedTask.status != 'completed'">
                      <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                    </span>

                    <span class="btn section-btn text-danger cursor-pointer float-right"
                      @click="discardResponse(selectedTask)"
                      v-if="editModeResponse && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.discard') }}
                    </span>

                    <span class="btn section-btn text-success cursor-pointer float-right"
                      @click="updateResponse(selectedTask)"
                      v-if="editModeResponse && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.save') }}
                    </span>

                    <div v-if="selectedTask.response_type != 'Datepicker'">
                      <multiselect v-if="editModeResponse && selectedTask.status != 'completed'"
                        v-model="selectedAnswer" qid="assessment-form-response-drop-down" :options="allAnswers"
                        :multiple="false" :taggable="false" label="title"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        :placeholder="$t('tasks.modal.response_placeholder')">
                        <template slot="option" slot-scope="props">
                          <font-awesome-icon icon="check-circle" class="icon-success"
                            v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                          <font-awesome-icon icon="info-circle" class="icon-info"
                            v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                          <font-awesome-icon icon="times-circle" class="icon-danger"
                            v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                            v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                            v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                            v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                            v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                          <span class="ml-2">
                            {{ props.option.title }}
                          </span>
                        </template>
                        <template slot="singleLabel" slot-scope="props">
                          <font-awesome-icon icon="check-circle" class="icon-success"
                            v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                          <font-awesome-icon icon="info-circle" class="icon-info"
                            v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                          <font-awesome-icon icon="times-circle" class="icon-danger"
                            v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                            v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                            v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                            v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                            v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                          <span class="ml-2">
                            {{ props.option.title }}
                          </span>
                        </template>
                      </multiselect>

                      <p v-if="(!editModeResponse && selectedAnswer && selectedAnswer.title) || selectedTask.status == 'completed'"
                        class="">
                        <font-awesome-icon icon="check-circle" class="icon-success"
                          v-if="getIcon(selectedTask) == 'Positive'" />
                        <font-awesome-icon icon="times-circle" class="icon-danger"
                          v-if="getIcon(selectedTask) == 'Negative'" />
                        <font-awesome-icon icon="info-circle" class="icon-info"
                          v-if="getIcon(selectedTask) == 'Neutral'" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                          v-if="getIcon(selectedTask) == 'Very low'" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                          v-if="getIcon(selectedTask) == 'Low'" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                          v-if="getIcon(selectedTask) == 'High'" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                          v-if="getIcon(selectedTask) == 'Very high'" />
                        {{ selectedAnswer.title }}
                      </p>

                      <p v-if="!editModeResponse && !selectedAnswer" qid="no-results-row-rr" class="text-muted">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>

                    <div v-if="selectedTask.response_type == 'Datepicker'">
                      <datepicker v-if="editModeResponse && selectedTask.status != 'completed'" class="date-picker"
                        qid="assessment-form-response-datepicker" calendar-class="right" v-model="selectedDate"
                        :clear-button="true" :placeholder="$t('tasks.modal.response_label')"></datepicker>

                      <p v-if="!editModeResponse && selectedDate" class="">
                        <font-awesome-icon icon="calendar-alt" class="mr-1" />
                        {{ selectedDate | formatDate }}
                      </p>

                      <p v-if="!editModeResponse && !selectedDate" qid="no-results-row-rr" class="text-muted">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>
                  </b-form-group>
                  <!--Conclusion card: Conclusion-->
                  <b-form-group
                    v-if="selectedTask && selectedTask.add_description && selectedTask.add_description == 'Optional' || selectedTask.add_description == 'Mandatory'">
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                      {{ $t('tasks.modal.remarks_label') }}
                      <span class="text-red" v-if="selectedTask && selectedTask.add_description == 'Mandatory'">*</span>
                      <span qid="profile-photo" v-b-tooltip.hover class="pl-2" title="Output to report">
                        <font-awesome-icon icon="file" style="color:#081F26" />
                      </span>
                    </label>

                    <span class="btn section-btn text-success cursor-pointer float-right mt-2"
                      @click="editModeConclusion = !editModeConclusion"
                      v-if="!editModeConclusion && selectedTask.status != 'completed'">
                      <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                    </span>

                    <span class="btn section-btn text-danger cursor-pointer float-right"
                      @click="discardConclusion(selectedTask)"
                      v-if="editModeConclusion && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.discard') }}
                    </span>

                    <span class="btn section-btn text-success cursor-pointer float-right"
                      @click="updateConclusion(selectedTask)"
                      v-if="editModeConclusion && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.save') }}
                    </span>

                    <b-form-textarea qid="assessment-form-conclusion" v-model="taskForm.remarks"
                      v-if="editModeConclusion && selectedTask.status != 'completed'" rows="6" max-rows="6"
                      :placeholder="$t('tasks.modal.remarks_placeholder')"></b-form-textarea>

                    <div v-if="!editModeConclusion" style="margin-top: -20px;">
                      <div v-if="taskForm.remarks && taskForm.remarks.length > 300">
                        <p v-if="showFullTextConclusion" class="text-formatted">
                          {{ taskForm.remarks }}
                        </p>

                        <p v-if="!showFullTextConclusion" class="text-formatted">
                          {{ taskForm.remarks | truncate(300) }}
                        </p>

                        <div class="text-center mt-3" @click="showFullTextConclusion = !showFullTextConclusion">
                          <span class="cursor-pointer" v-if="!showFullTextConclusion">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="showFullTextConclusion">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="taskForm.remarks && taskForm.remarks.length <= 300" class="text-formatted">
                        {{ taskForm.remarks }}
                      </p>

                      <p v-if="!editModeConclusion && !taskForm.remarks" qid="no-results-row-rr" class="text-muted"
                        style="margin-top: 20px;">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>
                  </b-form-group>

                  <div class="w-100" v-if="selectedTask.status != 'completed' || sTableItems.length">
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                      {{ $t('projects.observations.title') }}
                    </label>
                    <span class="float-right">
                      <CreateObservationModal :object="selectedTask.project" :task="selectedTask" type="global"
                        @updated="loadObservations(selectedTask.id)"
                        v-if="currentView != 'data_collection' && selectedTask.code != 'update_measures' && selectedTask.status != 'completed'">
                      </CreateObservationModal>
                    </span>
                  </div>
                  <ObservationViewModal :object="selectedObservation" :project="selectedTask.project"
                    :showModal="viewObservationModal" @closeViewModal="handleCloseViewModal"></ObservationViewModal>
                  <ul class="list-secondary" style="list-style-type: none; padding-left: 0;">
                    <li v-for="object in sTableItems" class="text-bold list-item mb-2">
                      <span>
                        <button v-if="object" @click="openViewModal(object)" qid="observation-name-link"
                          class="btn btn-link text-left">
                          <font-awesome-icon size="lg" icon="binoculars" class="mr-1" />
                          {{ object.name }}
                        </button>

                      </span>
                      <span class="actions" style="float: right;">
                        <span class="btn" @click="showEditModal(object)" qid="delete-s-cancel-button"
                          v-if="selectedTask.status != 'completed' && (selectedTask.project.status != 'closed' && selectedTask.project.status != 'completed')">
                          <span>
                            <font-awesome-icon icon="pen" />
                          </span>
                        </span>
                        <span class="btn" @click="showSConfirmDeleteModal(object)"
                          v-if="selectedTask.status != 'completed' && (selectedTask.project.status != 'closed' && selectedTask.project.status != 'completed')">
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                      </span>
                    </li>
                    <li qid="no-results-row-rr" class=""
                      v-if="!loadingObservations && sTableItems && !sTableItems.length">
                      <div class="text-muted">{{ $t('system.no_results') }}</div>
                    </li>

                    <li v-if="loadingObservations">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </li>
                  </ul>

                </div>
              </div>

              <!--Quality control card-->
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-2">
                    <div class="row">
                      <div class="col-md-6">
                        {{ $t('system.quality_control') }}
                      </div>
                      <div class="col-md-6">
                        <b-button class="float-right" variant="link"
                          v-if="selectedTask.qa_status != '' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                          @click="showQaLog" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                          {{ $t('system.quality_control_log') }}
                        </b-button>
                      </div>
                    </div>
                  </h5>
                  <div>
                    <div v-if="qaComments && qaComments.length" class="pt-3">
                      <div v-for="(comment, comment_index) in qaComments" :key="comment_index" class="mb-4">
                        <div class="row">
                          <div class="col-md-6">
                            {{ comment.user.name }}
                          </div>
                          <div class="col-md-6 text-right">
                            <span v-if="comment.type == 'accepted'"><font-awesome-icon icon="check-circle"
                                class="icon-success" /> {{ $t('system.accepted') }}</span>
                            <span v-if="comment.type == 'rejected'"><font-awesome-icon icon="times-circle"
                                class="icon-danger" /> {{ $t('system.rejected') }}</span>
                            <span v-if="comment.type == 'completed'"><font-awesome-icon icon="info-circle"
                                class="icon-info" /> {{ $t('system.completed') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="!loadingQaComments && qaComments && !qaComments.length" qid="no-results-row-rr"
                      class="text-muted">
                      {{ $t('system.no_results') }}
                    </div>

                    <div v-if="loadingQaComments">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </div>
                  </div>
                </div>
              </div>


            </div>

            <!-- System risk task form -->
            <div class="col-sm-6" v-if="selectedTask.code == 'system_impact_assessment'">
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.confidentiality.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect v-model="selectedConfidentialityImpact" :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')" label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')" qid="confidentiality-form-impact">
                </multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.integrity.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect v-model="selectedIntegrityImpact" :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')" label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')" qid="confidentiality-form-impact">
                </multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.availability.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect v-model="selectedAvailabilityImpact" :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')" label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')" qid="confidentiality-form-impact">
                </multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.rto_label') }}
                  <span class="text-red">*</span>
                </label>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-input qid="create-s-form-name" type="number" min="0"
                      :placeholder="$t('projects.schedule.every_placeholder')" v-model="taskForm.rto"></b-form-input>
                  </div>
                  <div class="col-sm-6">
                    <multiselect v-model="rtoInterval" :options="intervalOptions"
                      :placeholder="$t('projects.schedule.interval_placeholder')" label="text"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')" qid="create-p-form-pg"></multiselect>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.rpo_label') }}
                  <span class="text-red">*</span>
                </label>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-input qid="create-s-form-name" type="number" min="0"
                      :placeholder="$t('projects.schedule.every_placeholder')" v-model="taskForm.rpo"></b-form-input>
                  </div>
                  <div class="col-sm-6">
                    <multiselect v-model="rpoInterval" :options="intervalOptions"
                      :placeholder="$t('projects.schedule.interval_placeholder')" label="text"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')" qid="create-p-form-pg"></multiselect>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.remarks_label') }}
                  <span class="text-red">*</span>
                </label>
                <b-form-textarea qid="create-s-form-description" v-model="taskForm.remarks" rows="6" max-rows="6"
                  :required="selectedTask.add_description == 'Mandatory'"
                  :placeholder="$t('tasks.modal.remarks_placeholder')"></b-form-textarea>
              </b-form-group>
            </div>

          </div>
        </div>
      </b-form>

      <!--Documentation collection modal: First column-->
      <div class="form-container mt-0 mb-2"
        v-if="selectedTask && selectedTask.model && currentView == 'data_collection' && selectedTask.code != 'update_measures'">
        <div class="row mt-1">
          <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">

            <!-- Documentation collection modal: Documentation collection card -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title border-bottom pb-2"> {{ $t('tasks.modal.data_collection_title') }}</h5>


                <!--Conclusion card: Response-->
                <b-form-group
                  v-if="selectedTask && selectedTask.add_response_doc && (selectedTask.add_response_doc == 'Optional' || selectedTask.add_response_doc == 'Mandatory')">
                  <label qid="assessment-form-response-label" style="font-size: medium;" class="mt-3">
                    {{ $t('tasks.modal.response_label') }}
                    <span class="text-red" v-if="selectedTask && selectedTask.add_response_doc == 'Mandatory'">*</span>
                  </label>

                  <span class="btn section-btn text-success cursor-pointer float-right"
                    @click="editModeResponseDoc = !editModeResponseDoc"
                    v-if="!editModeResponseDoc && selectedTask.status != 'completed'">
                    <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                  </span>

                  <span class="btn section-btn text-danger cursor-pointer float-right"
                    @click="discardResponseDoc(selectedTask)"
                    v-if="editModeResponseDoc && selectedTask.status != 'completed'">
                    {{ $t('tasks.modal.discard') }}
                  </span>

                  <span class="btn section-btn text-success cursor-pointer float-right"
                    @click="updateResponseDoc(selectedTask)"
                    v-if="editModeResponseDoc && selectedTask.status != 'completed'">
                    {{ $t('tasks.modal.save') }}
                  </span>

                  <div v-if="selectedTask.add_response_doc != 'Datepicker'">
                    <multiselect v-if="editModeResponseDoc && selectedTask.status != 'completed'"
                      v-model="selectedAnswerDoc" qid="assessment-form-response-drop-down" :options="allAnswersDoc"
                      :multiple="false" :taggable="false" label="title"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      :placeholder="$t('tasks.modal.response_placeholder')">
                      <template slot="option" slot-scope="props">
                        <font-awesome-icon icon="check-circle" class="icon-success"
                          v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                        <font-awesome-icon icon="info-circle" class="icon-info"
                          v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                        <font-awesome-icon icon="times-circle" class="icon-danger"
                          v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                          v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                          v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                          v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                          v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                        <span class="ml-2">
                          {{ props.option.title }}
                        </span>
                      </template>
                      <template slot="singleLabel" slot-scope="props">
                        <font-awesome-icon icon="check-circle" class="icon-success"
                          v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                        <font-awesome-icon icon="info-circle" class="icon-info"
                          v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                        <font-awesome-icon icon="times-circle" class="icon-danger"
                          v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                          v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                          v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                          v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                          v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                        <span class="ml-2">
                          {{ props.option.title }}
                        </span>
                      </template>
                    </multiselect>

                    <p v-if="(!editModeResponseDoc && selectedAnswerDoc && selectedAnswerDoc.title) || selectedTask.status == 'completed'"
                      class="">
                      <font-awesome-icon icon="check-circle" class="icon-success"
                        v-if="getIconDoc(selectedTask) == 'Positive'" />
                      <font-awesome-icon icon="times-circle" class="icon-danger"
                        v-if="getIconDoc(selectedTask) == 'Negative'" />
                      <font-awesome-icon icon="info-circle" class="icon-info"
                        v-if="getIconDoc(selectedTask) == 'Neutral'" />
                      <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                        v-if="getIconDoc(selectedTask) == 'Very low'" />
                      <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                        v-if="getIconDoc(selectedTask) == 'Low'" />
                      <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                        v-if="getIconDoc(selectedTask) == 'High'" />
                      <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                        v-if="getIconDoc(selectedTask) == 'Very high'" />
                      {{ selectedAnswerDoc.title }}
                    </p>

                    <p v-if="!editModeResponseDoc && !selectedAnswerDoc" qid="no-results-row-rr" class="text-muted">
                      {{ $t('system.no_results') }}
                    </p>
                  </div>

                  <div v-if="selectedTask.add_response_doc == 'Datepicker'">
                    <datepicker v-if="editModeResponseDoc && selectedTask.status != 'completed'" class="date-picker"
                      qid="assessment-form-response-datepicker" calendar-class="right" v-model="selectedDateDoc"
                      :clear-button="true" :placeholder="$t('tasks.modal.response_label')"></datepicker>

                    <p v-if="!editModeResponseDoc && selectedDateDoc" class="">
                      <font-awesome-icon icon="calendar-alt" class="mr-1" />
                      {{ selectedDate | formatDate }}
                    </p>

                    <p v-if="!editModeResponseDoc && !selectedDateDoc" qid="no-results-row-rr" class="text-muted">
                      {{ $t('system.no_results') }}
                    </p>
                  </div>
                </b-form-group>

                <!-- Documentation collection modal: Control description -->
                <b-form-group
                  v-if="selectedTask && selectedTask.data_collection_add_description && selectedTask.data_collection_add_description == 'Optional' || selectedTask.data_collection_add_description == 'Mandatory'">
                  <label qid="assessment-form-documentation-collection-control-description-label"
                    style="font-size: medium;" class="mt-3">
                    {{ $t('tasks.modal.comment_label') }}
                    <span class="text-red"
                      v-if="selectedTask && selectedTask.data_collection_add_description == 'Mandatory'">*</span>
                  </label>

                  <span class="btn section-btn text-success cursor-pointer float-right"
                    @click="editModeControlDescriptionDocumentationCollection = !editModeControlDescriptionDocumentationCollection"
                    v-if="!editModeControlDescriptionDocumentationCollection && selectedTask.status != 'completed'">
                    <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                  </span>

                  <span class="btn section-btn text-danger cursor-pointer float-right"
                    @click="discardDataRemarks(selectedTask)"
                    v-if="editModeControlDescriptionDocumentationCollection && selectedTask.status != 'completed'">
                    {{ $t('tasks.modal.discard') }}
                  </span>

                  <span class="btn section-btn text-success cursor-pointer float-right"
                    @click="updateDataRemarks(selectedTask)"
                    v-if="editModeControlDescriptionDocumentationCollection && selectedTask.status != 'completed'">
                    {{ $t('tasks.modal.save') }}
                  </span>


                  <b-form-textarea qid="assessment-form-documentation-collection-control-description"
                    v-model="taskForm.data_remarks"
                    v-if="editModeControlDescriptionDocumentationCollection && selectedTask.status != 'completed'"
                    rows="6" max-rows="6" :placeholder="$t('tasks.modal.comment_label')"></b-form-textarea>

                  <div v-if="!editModeControlDescriptionDocumentationCollection" style="margin-top: -20px;">
                    <div v-if="taskForm.data_remarks && taskForm.data_remarks.length > 300">
                      <p v-if="showFullTextControlDescriptionDocumentationCollection" class="text-formatted">
                        {{ taskForm.data_remarks }}
                      </p>

                      <p v-if="!showFullTextControlDescriptionDocumentationCollection" class="text-formatted">
                        {{ taskForm.data_remarks | truncate(300) }}
                      </p>

                      <div class="text-center mt-3"
                        @click="showFullTextControlDescriptionDocumentationCollection = !showFullTextControlDescriptionDocumentationCollection">
                        <span class="cursor-pointer" v-if="!showFullTextControlDescriptionDocumentationCollection">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullTextControlDescriptionDocumentationCollection">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" />
                        </span>
                      </div>
                    </div>

                    <p v-if="taskForm.data_remarks && taskForm.data_remarks.length <= 300" class="text-formatted">
                      {{ taskForm.data_remarks }}
                    </p>
                    <p v-if="!taskForm.data_remarks" qid="no-results-row-rr" class="text-muted"
                      style="margin-top: 20px;">
                      {{ $t('system.no_results') }}
                    </p>
                  </div>
                </b-form-group>

                <!-- Documentation collection modal: Attachments -->
                <div class="w-100" @dragover.prevent @drop.prevent="handleDropDocumentation">
                  <div v-show="showDropActive" class="drop-active">
                    <h3>Drop files to upload</h3>
                  </div>
                  <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                    {{ $t('attachments.label') }}
                  </label>
                  <span class="float-right">
                    <file-upload ref="uploader" v-model="data_collection_files" :drop="true" :multiple="true"
                      input-id="task-file" @input="onDataFileChange" @dropActive="showDropActiveFunction"
                      @dropInactive="hideDropActiveFunction" v-if="selectedTask.status != 'completed'"
                      class="text-success cursor-pointer float:right mt-3">
                      {{ $t('tasks.modal.add_attachment_label') }}
                    </file-upload>
                  </span>
                </div>

                <ul class="compact-list" style="list-style-type: none; padding-left: 0;">
                  <li v-for="(item, index) in getMedia('data_documents')" :key="index" class="text-bold list-item mb-2">
                    <div class="row" style="height:20px;">
                      <div class="col-md-8">
                        <a :href="item.url" target="_blank" class="btn btn-link p-0" qid="download-media">
                          {{ item.full_title }}
                        </a>
                      </div>
                      <div class="actions col-md-4">
                        <div class="float-right">
                          <a :href="item.url" target="_blank" class="btn" qid="download-media">
                            <font-awesome-icon icon="eye" />
                          </a>
                          <a class="btn" @click="downloadMedia(item)" qid="download-media">
                            <font-awesome-icon icon="cloud-download-alt" />
                          </a>
                          <a class="btn" @click="openDeleteAttachmentModal(item)" qid="remove-media-item"
                            v-if="selectedTask.status != 'completed'">
                            <font-awesome-icon icon="trash-alt" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li v-if="!getMedia('data_documents').length && !selectedTask.linked_media.length"
                    qid="no-results-row-rr" class="">
                    <div class="text-muted">{{ $t('system.no_results') }}</div>
                  </li>
                </ul>

                <ul class="compact-list" style="list-style-type: none; padding-left: 0;">
                  <li v-for="(item, index) in selectedTask.linked_media" :key="index" class="text-bold list-item mb-2">
                    <div class="row" style="height:20px;">
                      <div class="col-md-8">
                        <a :href="item.url" target="_blank" class="btn btn-link p-0" qid="download-media">
                          {{ item.full_title }}
                        </a>
                      </div>

                      <div class="actions col-md-4">
                        <div class="float-right">
                          <a :href="item.url" target="_blank" class="btn" qid="download-media">
                            <font-awesome-icon icon="eye" />
                          </a>
                          <a class="btn" @click="downloadMedia(item)" qid="download-media">
                            <font-awesome-icon icon="cloud-download-alt" />
                          </a>
                          <a class="btn" @click="openDeleteLinkedAttachmentModal(item)" qid="remove-media-item"
                            v-if="selectedTask.data_status != 'completed'">
                            <font-awesome-icon icon="trash-alt" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>

                <div class="w-100" v-if="allLinkedDataMediaFiles.length && selectedTask.data_status != 'completed'">
                  <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                    {{ $t('attachments.suggested_label') }}
                  </label>
                  <span class="btn text-success cursor-pointer float-right pt-2"
                    @click="updateLinkedDataMedia(selectedTask)" v-if="selectedTask.data_status != 'completed'">
                    Add selected
                  </span>
                </div>
                <ul class="list-secondary" style="list-style-type: none; padding-left: 0;"
                  v-if="allLinkedDataMediaFiles.length && selectedTask.data_status != 'completed'">
                  <li v-for="(item, index) in allLinkedDataMediaFiles" :key="index" class="text-bold list-item mb-2">
                    <div class="row">
                      <span class="col-md-10 pr-0">
                        <a :href="item.url" target="_blank" class="btn btn-link p-0 text-muted" qid="download-media">
                          {{ item.full_title }}
                        </a>
                      </span>
                      <span class="actions pt-1 pl-0 pr-4 col-md-2 text-right" style="float: right;">
                        <input type="checkbox" v-model="selectedLinkedDataMedia" :value="item" />
                      </span>
                    </div>
                  </li>
                  <li qid="no-results-row-rr" class=""
                    v-if="!allLinkedDataMediaFiles.length && selectedTask.data_status != 'completed'">
                    <div class="text-muted">{{ $t('system.no_results') }}</div>
                  </li>
                </ul>
              </div>
            </div>

            <!--Documentation collection modal: Testing card-->
            <div class="card" v-if="tests.length">
              <div class="card-body">
                <h5 class="card-title border-bottom pb-2">
                  <div class="row">
                    <div class="col-md-6">
                      {{ $t('tasks.modal.testing') }}
                    </div>
                  </div>
                </h5>

                <div class="w-100">
                  <label qid="assessment-form-conclusion-label" style="font-size: medium;">
                    {{ $t('testing.title') }}
                  </label>

                </div>
                <ul class="list-secondary mt-2" style="list-style-type: none; padding-left: 0;">
                  <li v-for="object in tests" class="text-bold list-item testing-list-item mb-2">
                    <span class="status-container">
                      <div class="status-icon">
                        <span v-if="object.status == 'pending'">
                          <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                        </span>
                        <span v-if="object.status == 'documentation_collection_completed'">
                          <font-awesome-icon icon="check-circle" class="icon-success" />
                        </span>
                        <span v-if="object.status == 'passed'">
                          <font-awesome-icon icon="check-circle" class="icon-success" />
                        </span>
                        <span v-if="object.status == 'failed'">
                          <font-awesome-icon icon="check-circle" class="icon-success" />
                        </span>
                      </div>
                      <div class="status-button">
                        <button v-if="object" @click="openTestModal(object, 'data')" qid="observation-name-link"
                          class="btn btn-link text-left">
                          {{ object.name }}
                        </button>
                      </div>
                    </span>
                  </li>
                  <li qid="no-results-row-rr" class="" v-if="!tests.length">
                    <div class="text-muted">{{ $t('system.no_results') }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!--Documentation collection modal: Second column-->
          <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">
            <!--Documentation collection modal: Chat Card-->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title border-bottom pb-2"> {{ $t('tasks.modal.data_collection_chat_title') }}</h5>

                <div class="mt-3 mb-3" v-if="selectedTask.status != 'completed'">
                  <div class="row">
                    <div class="col-sm-10 chat-box-col-text">
                      <b-form-textarea qid="create-s-form-description" v-model="comment" class="chat-box-text" rows="2"
                        max-rows="2" :placeholder="$t('tasks.modal.question_to_recipient_label')"></b-form-textarea>
                    </div>
                    <div class="col-sm-2 chat-box-col-button cursor-pointer">
                      <div class="chat-box-button" @click="addCommentSubmit">
                        {{ $t('tasks.modal.send_button_label') }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-control scrollable-height-260 pt-3" style="background-color: white;">
                  <div v-if="previousComments && previousComments.length">
                    <div v-for="(comment, comment_index) in previousComments" :key="comment_index"
                      class="mt-2 chat-message">
                      <p>
                        <span class="cursor-pointer float-right" @click="openDeleteCommentModal(comment)"
                          v-if="isCommentOwner(comment) && selectedTask.status != 'completed'" qid="view-p-remove-link">
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                        <Avatar :object="comment.user" size="xs"></Avatar>
                        <span class="ml-1">
                          {{ comment.user.name }}
                        </span>
                        {{ $t('system.on') }}
                        <span class="text-normal">
                          {{ comment.updated_at | formatDateTime }}
                        </span>
                      </p>
                      <div v-if="comment.comment && comment.comment.length > 300">
                        <p v-if="comment.expanded" class="text-formatted">{{ comment.comment }}</p>

                        <p v-if="!comment.expanded" class="text-formatted">{{ comment.comment | truncate(300) }}</p>

                        <div class="text-center mt-3" @click="comment.expanded = !comment.expanded">
                          <span class="cursor-pointer" v-if="!comment.expanded">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="comment.expanded">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="comment.comment && comment.comment.length <= 300" class="text-formatted">{{
                        comment.comment }}
                      </p>
                    </div>
                  </div>
                  <div v-if="!previousComments.length" class="text-center">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Update measures task -->
      <div class="form-container mt-0 mb-2" v-if="selectedTask && selectedTask.code == 'update_measures'">
        <div class="row mt-1">

          <!-- Tables container -->
          <div class="col-sm-12" v-if="selectedTask.project">
            <MeasuresTable :object="selectedTask.project" :showOnTask="true"></MeasuresTable>
          </div>

        </div>
      </div>
      <!-- FOOTER -->
      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="task-modal-info" v-if="selectedTask && selectedTask.id">
            <div class="row">
              <div class="col text-center pt-3 pb-3" v-if="currentView != 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>

                <span v-if="selectedTask.users && selectedTask.users.length">
                  <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.users)"
                    :key="user_index">
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                </span>
                <span v-if="selectedTask.users && selectedTask.users.length && selectedTask.users.length > 3"
                  class="badge cursor-pointer" @click="openUsersModal(selectedTask)">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.users.length - 3 }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>
                <span v-if="selectedTask.data_users && selectedTask.data_users.length">
                  <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.data_users)"
                    :key="user_index">
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                </span>
                <span
                  v-if="selectedTask.data_users && selectedTask.data_users.length && selectedTask.data_users.length > 3"
                  class="badge cursor-pointer" @click="openUsersModal(selectedTask)">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.data_users.length - 3 }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.due_date') }}</strong>
                </div>
                <span class="text-normal" v-if="currentView != 'data_collection'">
                  <span v-if="getDifference(selectedTask.project.end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span
                    v-if="getDifference(selectedTask.project.end_date) <= 3 && getDifference(selectedTask.project.end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12" />
                    {{ Math.abs(getDifference(selectedTask.project.end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                </span>
                <span class="text-normal" v-if="currentView == 'data_collection'">
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.data_collection_end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span
                    v-if="getDifference(selectedTask.project.data_collection_end_date) <= 3 && getDifference(selectedTask.project.data_collection_end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.data_collection_end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12" />
                    {{ Math.abs(getDifference(selectedTask.project.data_collection_end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                  <span v-if="!selectedTask.project.data_collection_end_date">
                    {{ $t('system.n_a') }}
                  </span>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView != 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('system.task_status') }}</strong>
                </div>
                <span v-if="selectedTask.status === 'completed'">
                  <span class="text-normal" v-if="selectedTask.qa_status === 'accepted'">
                    <font-awesome-icon icon="check-circle" class="icon-success" />
                  </span>
                  <span class="text-normal" v-else-if="selectedTask.qa_status === 'rejected'">
                    <font-awesome-icon icon="times-circle" class="icon-danger" />
                  </span>
                  <span class="text-normal" v-else>
                    <font-awesome-icon icon="check-circle" class="icon-success" />
                  </span>

                </span>
                <span v-if="selectedTask.status === 'pending'" class="pr-1">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                </span>
                <span class="text-normal"
                  v-if="selectedTask.status === 'completed' && selectedTask.qa_status === 'accepted'">
                  {{ $t('system.accepted') }}
                </span>
                <span class="text-normal"
                  v-else-if="selectedTask.status === 'completed' && selectedTask.qa_status === 'rejected'">
                  {{ $t('system.rejected') }}
                </span>
                <span class="text-normal" v-else>
                  {{ $t('system.' + $options.filters.slugify(selectedTask.status)) }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('tasks.table.data_collection_status') }}</strong>
                </div>
                <span v-if="selectedTask.data_status && selectedTask.data_status === 'completed'">
                  <font-awesome-icon icon="check-circle" class="icon-success" />
                </span>
                <span v-if="selectedTask.data_status && selectedTask.data_status === 'pending'" class="pr-1">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                </span>
                <span v-if="selectedTask.data_status">
                  {{ $t('system.' + $options.filters.slugify(selectedTask.data_status)) }}
                </span>
                <span v-if="!selectedTask.data_status">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                  {{ $t('system.pending') }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.project') }}</strong>
                </div>
                <span v-if="isOwner(selectedTask.project)" class="text-success breadcrumb-item cursor-pointer"
                  @click="navigateToProject(selectedTask)">
                  <font-awesome-icon icon="calendar-alt" class="mr-1" />
                  {{ selectedTask.project.title }}
                </span>
                <span v-if="!isOwner(selectedTask.project)" class="text-success breadcrumb-item"
                  style="pointer-events:none;">
                  <font-awesome-icon icon="calendar-alt" class="mr-1" />
                  {{ selectedTask.project.title }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.owners_label') }}</strong>
                </div>
                <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.project.users)"
                  :key="user_index">
                  <span qid="profile-photo">
                    <Avatar :object="user" size="xs"></Avatar>
                  </span>
                </span>
                <span v-if="selectedTask.project.users.length > 3" class="badge cursor-pointer"
                  @click="openUsersModal(selectedTask.project)">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.project.users.length - 3 }}
                </span>
              </div>
            </div>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
              </div>
              <div class="col-sm-6 text-right">

                <b-modal ref="qa-log" modal-class="task-modal">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideQaLog" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0 ">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.quality_control_log') }}
                      </h5>
                    </div>
                  </template>
                  <div class="pt-3">
                    <div v-if="qaComments && qaComments.length">
                      <div v-for="(comment, comment_index) in qaComments" :key="comment_index" class="mb-4">
                        <p>
                          <span v-if="comment.type == 'accepted'"><font-awesome-icon icon="check-circle"
                              class="icon-success" /> {{
                            $t('system.accepted') }}</span>
                          <span v-if="comment.type == 'rejected'"><font-awesome-icon icon="times-circle"
                              class="icon-danger" /> {{
                            $t('system.rejected') }}</span>
                          <span v-if="comment.type == 'completed'"><font-awesome-icon icon="info-circle"
                              class="icon-info" /> {{
                            $t('system.completed') }}</span>
                          {{ $t('system.by') }}
                          <span class="">
                            {{ comment.user.name }}
                          </span>
                          {{ $t('system.on') }}
                          <span class="text-normal">
                            {{ comment.updated_at | formatDateTime }}
                          </span>
                        </p>
                        <div v-if="comment.comment && comment.comment != 'accepted' && comment.comment.length > 0"
                          class="text-formatted chat-message pb-3">{{ comment.comment }}</div>
                      </div>
                    </div>
                  </div>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideQaLog" qid="edit-p-cancel-button">
                            {{ $t('system.close') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>

                <b-button class="ml-3 mt-2" variant="danger"
                  v-if="selectedTask.status == 'completed' && selectedTask.qa_status != 'rejected' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="showReopenQaTask" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.reject_and_reopen') }}
                </b-button>
                <b-modal ref="reopen-qa-task" modal-class="task-modal">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideReopenQaTask" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.reject_and_reopen') }}
                      </h5>
                    </div>
                  </template>
                  <b-form @submit="reOpenQaTask" qid="create-framework-control-form">
                    <div class="form-container">
                      <b-form-group>
                        <label qid="create-framewor-control-pg-label">
                          {{ $t('system.rejection_comment') }}
                        </label>
                      </b-form-group>
                      <b-form-textarea qid="create-q-data_collection-form-description" v-model="qa_comment" rows="6"
                        max-rows="6" required></b-form-textarea>
                    </div>
                  </b-form>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideReopenQaTask" qid="edit-p-cancel-button">
                            {{ $t('maintenance.measures.create.cancel') }}
                          </b-button>
                          <b-button class="ml-3" variant="danger" :disabled="buttonDisabled" @click="reOpenQaTask()"
                            qid="edit-p-submit-button">
                            <span v-if="buttonDisabled" class="mr-1">
                              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                            </span>
                            {{ $t('system.reject_and_reopen') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>
                <b-modal ref="reopen-qa-task-complete" modal-class="task-modal">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideReopenQaTask" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.complete_rejected_task') }}
                      </h5>
                    </div>
                  </template>
                  <b-form @submit="reOpenQaTask" qid="create-framework-control-form">
                    <div class="form-container">
                      <b-form-group>
                        <label qid="create-framewor-control-pg-label">
                          {{ $t('system.completion_comment') }}
                        </label>
                      </b-form-group>
                      <b-form-textarea qid="create-q-data_collection-form-description" v-model="qa_comment" rows="6"
                        max-rows="6" required></b-form-textarea>
                    </div>
                  </b-form>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideReopenQaTask" qid="edit-p-cancel-button">
                            {{ $t('maintenance.measures.create.cancel') }}
                          </b-button>
                          <b-button class="ml-3" variant="success" :disabled="buttonDisabled"
                            @click="completeOpenQaTask()" qid="edit-p-submit-button">
                            <span v-if="buttonDisabled" class="mr-1">
                              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                            </span>
                            {{ $t('tasks.modal.complete') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status == 'completed' && selectedTask.qa_status != 'accepted' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="acceptQaTask" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.accept_and_complete') }}
                </b-button>


                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.status != 'completed' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success" @click="completeTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_task-button"
                  v-if="selectedTask.qa_status != 'rejected' && selectedTask.status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="success" @click="showReopenQaTaskComplete()"
                  :disabled="buttonDisabled" qid="task-modal-complete_task-button"
                  v-if="selectedTask.qa_status == 'rejected' && selectedTask.status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <!--<b-button class="ml-3 mt-2"-->
                <!--variant="secondary"-->
                <!--v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'"-->
                <!--@click="reOpenTask()"-->
                <!--:disabled="buttonDisabled"-->
                <!--qid="task-modal-cancel-button"-->
                <!--&gt;-->
                <!--{{ $t('tasks.modal.task_reopen_button') }}-->
                <!--</b-button>-->
                <!--<b-button class="ml-3 mt-2"-->
                <!--variant="success"-->
                <!--v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'"-->
                <!--@click="saveTask()"-->
                <!--:disabled="buttonDisabled"-->
                <!--qid="task-modal-save-button"-->
                <!--&gt;-->
                <!--{{ $t('system.save') }}-->
                <!--</b-button>-->


                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="saveDataTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success" @click="completeDataTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_data_task-button"
                  v-if="selectedTask.data_status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.data_status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="reOpenDataTask()" :disabled="buttonDisabled" qid="task-modal-cancel-button">
                  {{ $t('tasks.modal.data_collection_reopen_button') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save-button">
                  {{ $t('system.save') }}
                </b-button>


                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.status != 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status != 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="completeSystemRiskTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_system_risk-button">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.status == 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="reOpenTask()" :disabled="buttonDisabled" qid="task-modal-cancel-button">
                  {{ $t('tasks.modal.task_reopen_button') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status == 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save-button">
                  {{ $t('system.save') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Add new link modal -->
    <b-modal ref="add-link" @hide="hideCreateLinkModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateLinkModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="update-user-title">
            {{ $t('tasks.modal.add_links_button') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="edit-user-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <b-form-group>
          <div>
            <label class="mt-2">{{ $t('system.link') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLink"
              :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
              qid="create-p-links"></b-form-input>
            <label class="mt-2">{{ $t('table.name') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkName"
              :placeholder="inputLink ? inputLink : $t('table.name')" qid="create-p-links"></b-form-input>
          </div>
        </b-form-group>
      </div>
      <div class="proxy-footer">
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="hideCreateLinkModal" qid="edit-user-cancel-button">
                  {{ $t('administration.users.create.cancel') }}
                </b-button>
                <b-button @click="handleLink" class="ml-3" variant="success" :disabled="buttonDisabled"
                  qid="edit-user-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.users.merge_users_submit') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>


    <!-- Change user modal template -->
    <b-modal ref="reopen-task" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideReopenDataCollectionModal" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center">
            {{ $t('tasks.table.data_collection_assignee') }}
          </h5>
        </div>
      </template>

      <div class="form-container">

        <b-alert v-if="reopenError.length" show variant="danger" qid="create-p-error">
          {{ reopenError }}
        </b-alert>

        <b-form-group>
          <label qid="create-p-users-label">
            {{ $t('tasks.modal.recipient_label') }}
          </label>

          <div class="multiselect-row">
            <multiselect v-model="selectedAssignUsers" :options="userList" :multiple="true" :taggable="false"
              :disabled="buttonDisabled" track-by="slug" :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" :placeholder="$t('tasks.modal.recipient_label')"
              label="name" qid="create-p-users-select">
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>

            <UserInviteModal :buttonType="'small'" :buttonDisabled=buttonDisabled @reloadUserList="reloadUserList">
            </UserInviteModal>
          </div>
        </b-form-group>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="text-right">
              <b-button class="" variant="secondary" @click="hideReopenDataCollectionModal" qid="edit-p-cancel-button">
                {{ $t('maintenance.measures.create.cancel') }}
              </b-button>
              <b-button class="ml-3" variant="success" :disabled="buttonDisabled" @click="changeUsersSubmit()"
                qid="edit-p-submit-button">
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                </span>
                {{ $t('maintenance.measure_categories.create.submit') }}
              </b-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Edit Assessment Control modals -->
    <b-modal ref="edit-question-1" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.question_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.question_description') }}
          </span>
        </div>

        <b-form-group>
          <label qid="create-q-name-label">
            {{ $t('maintenance.questions.create.name_label') }}
            <span class="text-red">*</span>
          </label>
          <b-form-input qid="create-q-form-name" type="text" v-model="form.name" required :maxLength="255"
            :placeholder="$t('maintenance.questions.create.name_placeholder')"></b-form-input>
        </b-form-group>

        <b-form-group>
          <label qid="create-q-reference-label">
            {{ $t('maintenance.questions.create.reference_label') }}
          </label>
          <b-form-input qid="create-q-form-reference" type="text" v-model="form.reference" :maxLength="255"
            :class="{ 'is-invalid': referenceInvalid }"
            :placeholder="$t('maintenance.questions.create.reference_placeholder')"></b-form-input>
          <b-form-invalid-feedback v-if="referenceInvalid" qid="pasword-requirement-notice" class="d-block">
            {{ $t('maintenance.questions.create.reference_error') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <label qid="create-assessment-control-objective-label">
            {{ $t('maintenance.control_objective.title') }}<span class="mandatory"> *</span>
          </label>
          <div class="multiselect-row">
            <multiselect v-model="selectedControlObjective" :options="controlObjectives"
              :placeholder="$t('maintenance.control_objective.title_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" required :allow-empty="false"
              @search-change="loadCO" track-by="id" qid="create-assessment-control-form-control-objective">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="book" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="book" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
            <b-button class="btn btn-secondary float-right" @click="showCreateControlObjectiveModal()"
              qid="control-objective-create-button-fc-modal" v-if="isGranted(permissions.CONTROL_OBJECTIVE_CREATE)"
              v-b-tooltip.hover :title="$t('maintenance.control_objective.add_new')">
              <font-awesome-icon icon="plus-circle" />
            </b-button>
          </div>
          <p v-if="form.control_objective && form.control_objective.name">
            <font-awesome-icon icon="book" />
            {{ form.control_objective.name }}
          </p>
        </b-form-group>
      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-active">1</li>
            <li class="progress-uncompleted">2</li>
            <li class="progress-uncompleted">3</li>
            <li class="progress-uncompleted">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}
            </li>
            <li class="text-center progress-uncompleted">{{
              $t('maintenance.questions.create.documentation_collection_task')
              }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="hideEditQModal" qid="create-q-cancel-button">
                  {{ $t('maintenance.questions.create.cancel') }}
                </b-button>
                <b-button class="ml-3" variant="success" :disabled="buttonDisabled" @click="showEditQForm2('forward')"
                  qid="create-q-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="edit-question-2" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.linked_controls_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.linked_controls_description') }}
          </span>
        </div>

        <div class="">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6 text-right">
              <button class="btn btn-success" qid="frameworkControl-create-button" @click="showAddLinkedControlModal">
                <font-awesome-icon icon="plus" /> {{ $t('generic_controls.linked_controls.create_button') }}
              </button>
            </div>
          </div>
          <table class="table table-responsive-md table-list-secondary">
            <thead>
              <tr>
                <th scope="col">
                  {{ $t('generic_controls.linked_controls.name') }}
                </th>
                <th width="100"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in selectedLinkedControls" :key="'table-row-' + index"
                :id="'table-row-' + index">
                <td scope="row">
                  <span v-if="item.assessment && item.assessment.name" class="text-muted">
                    {{ item.assessment.name }}
                  </span>
                  <br>
                  <span v-if="item && item.name">
                    <span v-if="item.reference">{{ item.reference }}:</span> {{ item.name }}
                  </span>
                  <br>
                </td>
                <td>
                  <button class="btn btn-delete float-right" qid="delete-framework_control-modal"
                    @click="removeLinkedControlItem(index)">
                    <font-awesome-icon icon="trash-alt" />
                  </button>
                </td>
              </tr>
              <tr v-for="(item, index) in selectedLinkedControlsAsTarget" :key="'table-row-' + index"
                :id="'table-row-' + index">
                <td scope="row">
                  <span v-if="item.assessment_name" class="text-muted">
                    {{ item.assessment_name }}
                  </span>
                  <br>
                  <span v-if="item && item.name">
                    <span v-if="item.reference">{{ item.reference }}:</span> {{ item.name }}
                  </span>
                  <br>
                </td>
                <td>
                </td>
              </tr>
              <tr v-if="!selectedLinkedControls.length && !selectedLinkedControlsAsTarget.length" qid="no-results-row"
                class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-completed">1</li>
            <li class="progress-active">2</li>
            <li class="progress-uncompleted">3</li>
            <li class="progress-uncompleted">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}
            </li>
            <li class="text-center progress-uncompleted">{{
              $t('maintenance.questions.create.documentation_collection_task')
              }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="showEditQForm1" qid="create-q-cancel-button">
                  {{ $t('maintenance.questions.create.back') }}
                </b-button>
                <b-button @click="showEditQForm3('forward')" class="ml-3" variant="success" :disabled="buttonDisabled"
                  qid="create-q-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="edit-question-3" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.framework_controls_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.framework_controls_description') }}
          </span>
        </div>

        <div class="">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6 text-right">
              <button class="btn btn-success" qid="frameworkControl-create-button"
                @click="showAddFrameworkControlModal">
                <font-awesome-icon icon="plus" /> {{ $t('generic_controls.framework_controls.create_button') }}
              </button>
            </div>
          </div>
          <table class="table table-responsive-md table-list-secondary">
            <thead>
              <tr>
                <th scope="col">
                  {{ $t('generic_controls.framework_controls.name') }}
                </th>
                <th width="100"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in selectedFrameworkControls" :key="'table-row-' + index"
                :id="'table-row-' + index">
                <b-popover :target="'table-row-' + index" boundary="viewport" triggers="hover" placement="topleft"
                  :delay="{ show: 500, hide: 0 }">
                  <div v-if="item.active_framework && item.active_framework.name" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.questions.create.active_framework_name_label') }}:
                    </span>
                    <br>
                    {{ item.active_framework.name }}
                    <br>
                  </div>
                  <div v-if="item.control_objective && item.control_objective.name" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.questions.create.control_objective_name_label') }}:
                    </span>
                    <br>
                    {{ item.control_objective.name }}
                    <br>
                  </div>
                  <div v-if="item.control_objective && item.control_objective.description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.questions.create.control_objective_description_label') }}:
                    </span>
                    <br>
                    {{ item.control_objective.description | truncate(200) }}
                    <br>
                  </div>
                  <div v-if="item && item.name" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.framework_control.table.name') }}:
                    </span>
                    <br>
                    {{ item.name }}
                    <br>
                  </div>
                  <div v-if="item.description" class="mt-2">
                    <span class="text-bold">
                      {{ $t('maintenance.framework_control.create.description_label') }}:
                    </span>
                    <br>
                    {{ item.description | truncate(200) }}
                    <br>
                  </div>
                </b-popover>
                <td scope="row">
                  <span v-if="item.active_framework && item.active_framework.name" class="text-muted">
                    {{ item.active_framework.name }}
                  </span>
                  <br>
                  <span>
                    {{ item.full_name }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-delete float-right" qid="delete-framework_control-modal"
                    @click="removeFrameworkControlItem(index)">
                    <font-awesome-icon icon="trash-alt" />
                  </button>
                </td>
              </tr>
              <tr v-if="!selectedFrameworkControls.length" qid="no-results-row" class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-completed">1</li>
            <li class="progress-completed">2</li>
            <li class="progress-active">3</li>
            <li class="progress-uncompleted">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}
            </li>
            <li class="text-center progress-uncompleted">{{
              $t('maintenance.questions.create.documentation_collection_task')
              }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="showEditQForm2" qid="create-q-cancel-button">
                  {{ $t('maintenance.questions.create.back') }}
                </b-button>
                <b-button @click="showEditQForm4('forward')" class="ml-3" variant="success" :disabled="buttonDisabled"
                  qid="create-q-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="edit-question-4" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.question_data_collection_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.question_data_collection_description') }}
          </span>
        </div>

        <div v-if="selectedTask.project && selectedTask.project.assessment.type == 'risk'">
          <h5>
            Data collection step is available only for global assessments. Press next to continue.
          </h5>
        </div>

        <div class="form-group" v-if="selectedTask.project && selectedTask.project.assessment.type != 'risk'">
          <label qid="create-q-data_collection-radio-label">
            {{ $t('maintenance.questions.create.data_collection_label') }}
          </label>
          <b-form-radio-group v-model="data_collection_on" :options="dataCollectionOptions"
            @change="lockSwitch(data_collection_on)" qid="create-q-data_collection-radio-option"></b-form-radio-group>
        </div>

        <div v-if="data_collection_on && selectedTask.project && selectedTask.project.assessment.type != 'risk'">
          <b-form-group>
            <label qid="create-q-data_collection-description-label">
              {{ $t('maintenance.questions.create.data_collection_description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea qid="create-q-data_collection-form-description" v-model="form.data_collection_description"
              rows="6" max-rows="6" required
              :placeholder="$t('maintenance.questions.create.data_collection_description_placeholder')"></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <div v-show="showDropActive" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>

            <label> {{ $t('maintenance.questions.create.data_collection_attachment_label') }}</label>

            <div class="form-control auto-height pt-3 pb-3">
              <div class="text-center">
                <p>
                  Drag and drop files in here or
                  <file-upload ref="uploader" v-model="data_collection_files" :drop="true" :multiple="true"
                    input-id="uploader" name="uploader" @input="onFileChangeDataCollectionEdit"
                    @dropActive="showDropActiveFunction" class="text-success cursor-pointer">
                    click here
                  </file-upload>
                  to upload files you wish to display together with the description. You may also
                  <span class="text-success cursor-pointer" @click="showLinksSection = true">add links</span>
                </p>
              </div>

              <p v-for="(file, media_index) in selectedTask.media" :key="media_index">
                <span v-if="file.collection_name == 'data_collection'">
                  <span class="float-right text-muted cursor-pointer" @click="openDeleteAttachmentModal(file)"
                    qid="remove-media-item">
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                    qid="download-media">
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
              </p>

              <div v-if="selectedTask.links">
                <p v-for="(link, link_index) in getDataCollectionLinks" :key="link_index">
                  <span class="float-right text-muted cursor-pointer" @click="openDeleteLinkModal(link)"
                    qid="view-q-remove-link">
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-q-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
            </div>
          </b-form-group>

          <b-form-group v-if="showLinksSection">
            <label qid="create-q-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>

            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkDataCollection"
                :placeholder="$t('system.link')" qid="create-q-links"></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkNameDataCollection"
                :placeholder="inputLinkDataCollection ? inputLinkDataCollection : $t('table.name')"
                qid="create-q-links"></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0" id="inputGroup1" @click="handleEditDataCollectionLink"
                  qid="handle-link-save">
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-data_collection-description-label">
              {{ $t('maintenance.questions.create.data_collection_description_two_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea qid="create-q-data_collection-form-description"
              v-model="form.data_collection_description_two" rows="6" max-rows="6" required
              :placeholder="$t('maintenance.questions.create.data_collection_description_two_placeholder')"></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <div v-show="showDropActive" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>

            <label> {{ $t('maintenance.questions.create.data_collection_two_attachment_label') }}</label>

            <div class="form-control auto-height pt-3 pb-3">
              <div class="text-center">
                <p>
                  Drag and drop files in here or
                  <file-upload ref="uploaderTwo" v-model="data_collection_two_files" :drop="true" :multiple="true"
                    input-id="uploaderTwo" name="uploaderTwo" @input="onFileChangeDataCollectionTwoEdit"
                    @dropActive="showDropActiveFunction" class="text-success cursor-pointer">
                    click here
                  </file-upload>
                  to upload files you wish to display together with the description. You may also
                  <span class="text-success cursor-pointer" @click="showLinksSectionTwo = true">add links</span>
                </p>
              </div>

              <p v-for="(file, media_index) in selectedTask.media" :key="media_index">
                <span v-if="file.collection_name == 'data_collection_two'">
                  <span class="float-right text-muted cursor-pointer" @click="openDeleteAttachmentModal(file)"
                    qid="remove-media-item">
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                    qid="download-media">
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
              </p>

              <div v-if="selectedTask.links">
                <p v-for="(link, link_index) in getDataCollectionTwoLinks" :key="link_index">
                  <span class="float-right text-muted cursor-pointer" @click="openDeleteLinkModal(link)"
                    qid="view-q-remove-link">
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-q-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
            </div>
          </b-form-group>


          <b-form-group v-if="showLinksSectionTwo">
            <label qid="create-q-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>

            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkDataCollection"
                :placeholder="$t('system.link')" qid="create-q-links"></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkNameDataCollection"
                :placeholder="inputLinkDataCollection ? inputLinkDataCollection : $t('table.name')"
                qid="create-q-links"></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0" id="inputGroup2"
                  @click="handleEditDataCollectionTwoLink" qid="handle-link-save">
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
          </b-form-group>

          <!--Documentation Response-->
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_response_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="addResponseDoc" :options="allowTypesDoc"
              :placeholder="$t('maintenance.questions.create.add_response_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>

          <b-form-group v-if="addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>

            <multiselect v-model="responseTypeDoc" :options="responseTypes" group-values="items" group-label="group"
              :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
              @select="handleTypeDoc" :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>

          <b-form-group
            v-if="responseTypeDoc && responseTypeDoc.value === 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptionsDoc" :key="index" class="mt-1 mb-1 pb-3 pt-3">
              <span class="float-right btn btn-delete" @click="removeOptionItemDoc(index, option)"
                qid="create-p-link-remove">
                <font-awesome-icon icon="trash-alt" />
              </span>
              <multiselect v-model="option.value" :options="answerTypes" group-values="items" group-label="group"
                :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
                :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2"
                style="width:220px;" :allow-empty="false" qid="create-p-form-pg">
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="pt-2">{{ option.title }}</span>
            </p>
            <div class="input-group pt-2">
              <b-form-input qid="create-p-form-link" type="text" v-if="showInputDoc"
                v-on:keydown.enter="handleOptionDoc" v-model="inputOptionDoc"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"></b-form-input>
              <div class="input-group-append" v-if="showInputDoc">
                <span class="input-group-text cursor-pointer" id="inputGroupDoc" @click="handleOptionDoc"
                  qid="handle-link-save">
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right" @click="showInputDoc = true" v-if="!showInputDoc"
              qid="create-p-add-link">
              <font-awesome-icon icon="plus" /> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>

          <b-form-group
            v-if="responseTypeDoc && responseTypeDoc.value === 'Yes/No' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect v-model="yesValueDoc" :options="answerTypes" group-values="items" group-label="group"
                :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
                :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2"
                style="width:220px;" :allow-empty="false" qid="create-p-form-pg">
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="mt-2">Yes</span>
            </p>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect v-model="noValueDoc" :options="answerTypes" group-values="items" group-label="group"
                :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
                :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2"
                style="width:220px;" :allow-empty="false" qid="create-p-form-pg">
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value === 'Positive'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value === 'Negative'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value === 'Neutral'"
                    style="background:white;border-radius:50%;" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                    v-if="props.option.value === 'Very low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                    v-if="props.option.value === 'Low'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                    v-if="props.option.value === 'High'" />
                  <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                    v-if="props.option.value === 'Very high'" />
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="mt-2">No</span>
            </p>
          </b-form-group>

          <div class="text-muted mt-2 mb-3"
            v-if="responseTypeDoc && responseTypeDoc.value === 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            * {{ $t('maintenance.questions.create.helper_text_label') }}
          </div>
          <div class="text-muted mt-2 mb-3"
            v-if="responseTypeDoc && responseTypeDoc.value !== 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
            * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
          </div>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_comment_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="dataCollectionAddDescription" :options="allowTypesShort"
              :placeholder="$t('maintenance.questions.create.add_comment_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_attachments_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="dataCollectionAddAttachments" :options="allowTypes"
              :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>
        </div>
      </div>

      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-completed">1</li>
            <li class="progress-completed">2</li>
            <li class="progress-completed">3</li>
            <li class="progress-active">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.framework_controls') }}</li>
            <li class="text-center progress-completed">{{
              $t('maintenance.questions.create.documentation_collection_task')
              }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class="" variant="secondary" @click="showEditQForm3('back')"
                  qid="create-q-data_collection-back-button">
                  {{ $t('maintenance.questions.create.back') }}
                </b-button>
                <b-button class="ml-3" variant="success" @click="showEditQForm5('forward')" :disabled="buttonDisabled"
                  qid="create-q-data_collection-submit-button">
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>


    <b-modal ref="edit-question-5" @hide="hideEditQModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="create-q-error">
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.question_description_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.question_description_description') }}
          </span>
        </div>

        <b-form-group>
          <label qid="create-q-description-label">
            {{ $t('maintenance.questions.create.description_label') }}
            <span class="text-red">*</span>
          </label>
          <b-form-textarea qid="create-q-form-description" v-model="form.description" rows="6" max-rows="6" required
            :placeholder="$t('maintenance.questions.create.description_placeholder')"></b-form-textarea>
        </b-form-group>
        <b-form-group>
          <div v-show="showDropActive" class="drop-active">
            <h3>
              {{ $t('tasks.modal.drop_files_to_upload_label') }}</h3>
          </div>
          <label> {{ $t('maintenance.questions.create.data_collection_attachment_label') }}</label>
          <div class="form-control auto-height pt-3 pb-3">
            <div class="text-center">
              <p>
                {{ $t('tasks.modal.drop_files_here_label') }}
                <file-upload ref="uploaderData" v-model="files" :drop="true" :multiple="true" input-id="uploaderData"
                  name="uploaderData" @input="onFileChangeEdit" @dropActive="showDropActiveFunction"
                  class="text-success cursor-pointer">
                  {{ $t('system.click_here') }}
                </file-upload>
                {{ $t('tasks.modal.upload_files_second_text') }}
                <span class="text-success cursor-pointer" @click="showQuestionLinksSection = true">add links</span>
              </p>
            </div>

            <p v-for="(file, media_index) in selectedTask.media" :key="media_index">
              <span v-if="file.collection_name == 'question' || file.collection_name == 'documents'">
                <span class="float-right text-muted cursor-pointer" @click="openDeleteAttachmentModal(file)"
                  qid="remove-media-item">
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                  qid="download-media">
                  <font-awesome-icon icon="cloud-download-alt" />
                </span>
                <a @click="downloadMedia(file)" qid="create-q-media-item">
                  {{ file.file_name }}
                </a>
              </span>
            </p>

            <div v-if="selectedTask.links">
              <p v-for="(link, link_index) in selectedTask.links" :key="link_index">
                <span class="float-right text-muted cursor-pointer" @click="openDeleteLinkModal(link)"
                  qid="view-q-remove-link">
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <a :href="link.url" target="_blank" qid="create-q-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="showQuestionLinksSection">
          <label qid="create-q-link-label">
            {{ $t('maintenance.third_parties.create.links_label') }}
          </label>

          <div>
            <label class="mt-2">{{ $t('system.link') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLink" :placeholder="$t('system.link')"
              qid="create-q-links"></b-form-input>
            <label class="mt-2">{{ $t('table.name') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkName"
              :placeholder="inputLink ? inputLink : $t('table.name')" qid="create-q-links"></b-form-input>
            <div class="text-right mt-2">
              <span class="btn btn-success cursor-pointer mr-0" id="inputGroup3" qid="handle-link-save">
                {{ $t('system.save') }}
              </span>
            </div>
          </div>
        </b-form-group>


        <b-form-group>
          <label qid="create-q-description-label">
            {{ $t('maintenance.questions.create.description_two_label') }}
            <span class="text-red">*</span>
          </label>
          <b-form-textarea qid="create-q-form-description" v-model="form.description_two" rows="6" max-rows="6" required
            :placeholder="$t('maintenance.questions.create.description_two_placeholder')"></b-form-textarea>
        </b-form-group>
        <b-form-group>
          <div v-show="showDropActive" class="drop-active">
            <h3>
              {{ $t('tasks.modal.drop_files_to_upload_label') }}</h3>
          </div>
          <label> {{ $t('maintenance.questions.create.data_collection_two_attachment_label') }}</label>
          <div class="form-control auto-height pt-3 pb-3">
            <div class="text-center">
              <p>
                {{ $t('tasks.modal.drop_files_here_label') }}
                <file-upload ref="uploaderDataTwo" v-model="files_two" :drop="true" :multiple="true"
                  input-id="uploaderDataTwo" name="uploaderDataTwo" @input="onFileChangeEdit"
                  @dropActive="showDropActiveFunction" class="text-success cursor-pointer">
                  {{ $t('system.click_here') }}
                </file-upload>
                {{ $t('tasks.modal.upload_files_second_text') }}
                <span class="text-success cursor-pointer" @click="showQuestionTwoLinksSection = true">add links</span>
              </p>
            </div>

            <p v-for="(file, media_index) in selectedTask.media" :key="media_index">
              <span v-if="file.collection_name == 'question_two'">
                <span class="float-right text-muted cursor-pointer" @click="openDeleteAttachmentModal(file)"
                  qid="remove-media-item">
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <span class="mr-3 float-right text-muted cursor-pointer" @click="downloadMedia(file)"
                  qid="download-media">
                  <font-awesome-icon icon="cloud-download-alt" />
                </span>
                <a @click="downloadMedia(file)" qid="create-q-media-item">
                  {{ file.file_name }}
                </a>
              </span>
            </p>

            <div v-if="selectedTask.links">
              <p v-for="(link, link_index) in selectedTask.links_two" :key="link_index">
                <span class="float-right text-muted cursor-pointer" @click="openDeleteLinkModal(link)"
                  qid="view-q-remove-link">
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <a :href="link.url" target="_blank" qid="create-q-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="showQuestionTwoLinksSection">
          <label qid="create-q-link-label">
            {{ $t('maintenance.third_parties.create.links_label') }}
          </label>

          <div>
            <label class="mt-2">{{ $t('system.link') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLink" :placeholder="$t('system.link')"
              qid="create-q-links"></b-form-input>
            <label class="mt-2">{{ $t('table.name') }}</label>
            <b-form-input type="text" aria-describedby="inputGroup" v-model="inputLinkName"
              :placeholder="inputLink ? inputLink : $t('table.name')" qid="create-q-links"></b-form-input>
            <div class="text-right mt-2">
              <span class="btn btn-success cursor-pointer mr-0" id="inputGroup4" qid="handle-link-save">
                {{ $t('system.save') }}
              </span>
            </div>
          </div>
        </b-form-group>





        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_response_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addResponse" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_response_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>

        <b-form-group v-if="addResponse && addResponse.value && addResponse.value != 'No'">
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.type_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="responseType" :options="responseTypes" group-values="items" group-label="group"
            :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>

        <b-form-group
          v-if="responseType && responseType.value == 'Dropdown' && addResponse && addResponse.value && addResponse.value != 'No'">
          <label qid="create-p-link-label">
            {{ $t('maintenance.questions.create.options_label') }}
            <span class="text-red">*</span>
          </label>
          <p v-for="(option, index) in selectedOptions" class="mt-1 mb-1 pb-3 pt-3" :key="index">
            <span class="float-right btn btn-delete" @click="removeOptionItem(index, option)"
              qid="create-p-link-remove">
              <font-awesome-icon icon="trash-alt" />
            </span>
            <multiselect v-model="option.value" :options="answerTypes" group-values="items" group-label="group"
              :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
              :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2" style="width:220px;"
              :allow-empty="false" qid="create-p-form-pg">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>
            <span class="pt-2">{{ option.title }}</span>
          </p>
          <div class="input-group pt-2">
            <b-form-input qid="create-p-form-link" type="text" v-if="showInput" v-on:keydown.enter="handleOption"
              v-model="inputOption"
              :placeholder="$t('maintenance.questions.create.options_placeholder')"></b-form-input>
            <div class="input-group-append" v-if="showInput">
              <span class="input-group-text cursor-pointer" id="inputGroup5" @click="handleOption"
                qid="handle-link-save">
                {{ $t('system.save') }}
              </span>
            </div>
          </div>
          <span class="btn btn-link cursor-pointer float-right" @click="showInput = true" v-if="!showInput"
            qid="create-p-add-link">
            <font-awesome-icon icon="plus" /> {{ $t('maintenance.questions.create.add_option_label') }}
          </span>
        </b-form-group>

        <b-form-group
          v-if="responseType && responseType.value == 'Yes/No' && addResponse && addResponse.value && addResponse.value != 'No'">
          <label qid="create-p-link-label">
            {{ $t('maintenance.questions.create.options_label') }}
            <span class="text-red">*</span>
          </label>
          <p class="mt-1 mb-1 pb-3 pt-3">
            <multiselect v-model="yesValue" :options="answerTypes" group-values="items" group-label="group"
              :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
              :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2" style="width:220px;"
              :allow-empty="false" qid="create-p-form-pg">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>
            <span class="mt-2">Yes</span>
          </p>
          <p class="mt-1 mb-1 pb-3 pt-3">
            <multiselect v-model="noValue" :options="answerTypes" group-values="items" group-label="group"
              :group-select="false" :placeholder="$t('maintenance.questions.create.type_placeholder')" label="name"
              :select-label="''" :selected-label="''" :deselect-label="''" class="float-right mr-2" style="width:220px;"
              :allow-empty="false" qid="create-p-form-pg">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'Positive'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'Negative'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'Neutral'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                  v-if="props.option.value == 'Very low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="props.option.value == 'Low'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="props.option.value == 'High'" />
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                  v-if="props.option.value == 'Very high'" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>
            <span class="mt-2">No</span>
          </p>
        </b-form-group>

        <div class="text-muted mt-2 mb-3"
          v-if="responseType && responseType.value == 'Dropdown' && addResponse && addResponse.value && addResponse.value != 'No'">
          * {{ $t('maintenance.questions.create.helper_text_label') }}
        </div>
        <div class="text-muted mt-2 mb-3"
          v-if="responseType && responseType.value != 'Dropdown' && addResponse && addResponse.value && addResponse.value != 'No'">
          * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
        </div>

        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_notes_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addNotes" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_notes_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_testing_notes_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addTestingNotes" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_testing_notes_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_control_description_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addControlDescription" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_control_description_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_performed_text_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addPerformedText" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_performed_text_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_description_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addDescription" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_description_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-q-pg-label">
            {{ $t('maintenance.questions.create.add_attachments_label') }}
            <span class="text-red">*</span>
          </label>
          <multiselect v-model="addAttachments" :options="allowTypes"
            :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')" label="name"
            :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
            :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
        </b-form-group>
      </div>
      <b-form @submit="editFormSubmit" qid="create-q-form">
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-completed">1</li>
              <li class="progress-completed">2</li>
              <li class="progress-completed">3</li>
              <li class="progress-completed">4</li>
              <li class="progress-active">5</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.framework_controls') }}
              </li>
              <li class="text-center progress-completed">{{
                $t('maintenance.questions.create.documentation_collection_task')
                }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="" variant="secondary" @click="showEditQForm4('back')"
                    qid="create-q-data_collection-back-button">
                    {{ $t('maintenance.questions.create.back') }}
                  </b-button>
                  <b-button type="submit" class="ml-3" variant="success" :disabled="buttonDisabled"
                    qid="create-q-submit-button">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('maintenance.questions.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>

    <!-- Add new linked control -->
    <b-modal ref="add-linked-control" hide-footer @hide="hideAddLinkedControlModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title text-white">
          {{ $t('generic_controls.linked_controls.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length" show variant="danger" qid="create-io-error">
        {{ error }}
      </b-alert>
      <b-form @submit="linkedControlFormSubmit" qid="create-framework-control-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-framework-control-pg-label ">
              {{ $t('generic_controls.linked_controls.create.framework_label') }}
            </label>
            <multiselect v-model="selectedAssessment" :options="assessmentItems"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('generic_controls.linked_controls.create.framework_placeholder')" label="name"
              @search-change="loadAssessmentItems" @select="handleAssessmentChange" track-by="slug"
              qid="create-lb-form-pg">
            </multiselect>
          </b-form-group>
          <b-form-group v-if="selectedAssessment && selectedAssessment.id">
            <label qid="create-framework-control-pg-label">
              {{ $t('generic_controls.linked_controls.create.framework_control_label') }}
            </label>
            <multiselect v-model="selectedLinkedControl" :options="assessmentControlItems"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('generic_controls.linked_controls.create.framework_control_placeholder')"
              :custom-label="formatOptionLabel" @search-change="loadAssessmentControlItems" track-by="slug"
              qid="create-lb-form-pg"></multiselect>
          </b-form-group>
          <div class="text-muted mt-2 mb-3">
            {{ $t('generic_controls.linked_controls.create.framework_control_tip') }}
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3" variant="secondary" @click="hideAddLinkedControlModal" qid="create-p-cancel-button">
            {{ $t('generic_controls.framework_controls.create.cancel') }}
          </b-button>
          <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
            qid="create-p-submit-button">
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
            </span>
            {{ $t('generic_controls.framework_controls.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Add new framework control -->
    <b-modal ref="add-framework-control" hide-footer @hide="hideAddFrameworkControlModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title">
          {{ $t('generic_controls.framework_controls.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length" show variant="danger" qid="create-io-error">
        {{ error }}
      </b-alert>
      <b-form @submit="frameworkControlFormSubmit" qid="create-framework-control-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-framewor-control-pg-label">
              {{ $t('generic_controls.framework_controls.create.framework_label') }}
            </label>
            <multiselect v-model="selectedFramework" :options="frameworkItems"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('generic_controls.framework_controls.create.framework_placeholder')" label="name"
              @search-change="loadFrameworkItems" @select="handleFrameworkChange" track-by="slug"
              qid="create-lb-form-pg">
            </multiselect>
          </b-form-group>
          <b-form-group v-if="selectedFramework && selectedFramework.id">
            <label qid="create-framewor-control-pg-label">
              {{ $t('generic_controls.framework_controls.create.framework_control_label') }}
            </label>
            <multiselect v-model="selectedFrameworkControl" :options="frameworkControlItems"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('generic_controls.framework_controls.create.framework_control_placeholder')"
              label="full_name" @search-change="loadFrameworkControlItems" track-by="id" qid="create-lb-form-pg">
            </multiselect>
          </b-form-group>
          <div class="text-muted mt-2 mb-3">
            {{ $t('generic_controls.framework_controls.create.framework_control_tip') }}
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3" variant="secondary" @click="hideAddFrameworkControlModal" qid="create-p-cancel-button">
            {{ $t('generic_controls.framework_controls.create.cancel') }}
          </b-button>
          <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
            qid="create-p-submit-button">
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
            </span>
            {{ $t('generic_controls.framework_controls.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Add new control objective -->
    <b-modal ref="add-control-objective" @hide="hideCreateControlObjectiveModal" modal-class="task-modal" hide-footer>

      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateControlObjectiveModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="add-co-title">
            {{ $t('maintenance.control_objective.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length" show variant="danger" qid="add-co-error">
        {{ error }}
      </b-alert>

      <b-form @submit="coFormSubmit" qid="create-co-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-control-objective-name-label">
              {{ $t('maintenance.control_objective.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input qid="create-control-objective-form-name" type="text" v-model="coForm.name" :maxLength="255"
              required :placeholder="$t('maintenance.control_objective.create.name_placeholder')"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-control-objective-description-label">
              {{ $t('maintenance.control_objective.create.description_label') }}
            </label>
            <b-form-textarea qid="create-control-objective-form-description" v-model="coForm.description" rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.control_objective.create.description_placeholder')"></b-form-textarea>
          </b-form-group>
        </div>

        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="" variant="secondary" @click="hideCreateControlObjectiveModal"
                    qid="create-control-objective-cancel-button">
                    {{ $t('maintenance.control_objective.create.cancel') }}
                  </b-button>
                  <b-button type="submit" class="ml-3" variant="success" :disabled="buttonDisabled"
                    qid="create-control-objective-submit-button">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('maintenance.control_objective.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>

    <ConfirmRemoveAttachment :object="selectedFile" :show="showDeleteAttachmentModal" type="file"
      @closeConfirmModal="closeDeleteAttachmentModal"></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment :object="selectedFile" :task="selectedTask" :show="showDeleteLinkedAttachmentModal"
      type="linked_file" @closeConfirmModal="closeDeleteLinkedAttachmentModal"></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment :object="selectedLink" :show="showDeleteLinkModal" type="link"
      @closeConfirmModal="closeDeleteLinkModal"></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment :object="selectedComment" :task="selectedTask" :show="showDeleteCommentModal"
      type="comment" @closeConfirmModal="closeDeleteCommentModal"></ConfirmRemoveAttachment>

    <GuideViewModal :guide="selectedGuide" :showModal="viewGuideModal" @closeViewModal="closeViewGuideModal">
    </GuideViewModal>

    <ShowMoreModal :items="selectedItem.users" :show="showUsersModal" @closeViewModal="closeUsersModal" type="users">
    </ShowMoreModal>

    <!-- Delete observation modal template -->
    <b-modal ref="delete-observation" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-observation-title">
          {{ $t('activities.system.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.system.delete.description') }}
        <span v-if="itemToDelete">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.system.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3" variant="secondary" @click="hideSConfirmDeleteModal"
          qid="delete-observation-cancel-button">
          {{ $t('activities.system.delete.cancel') }}
        </b-button>
        <b-button @click="deleteObservation(itemToDelete)" class="mt-3 ml-3" variant="success"
          qid="delete-observation-submit-button">
          {{ $t('activities.system.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

    <!-- Delete test modal template -->
    <b-modal ref="delete-test" hide-footer>
      <div class="d-block text-center">
        <h4>
          {{ $t('activities.system.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.system.delete.description') }}
        <span v-if="itemToDelete">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.system.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3" variant="secondary" @click="hideTestConfirmDeleteModal">
          {{ $t('activities.system.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteTest(itemToDelete)" class="mt-3 ml-3" variant="success">
          {{ $t('activities.system.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Edit observation modal -->
    <b-modal ref="edit-observation" hide-footer @hide="hideEditModal">
      <div class="d-block text-center">
        <h4 qid="delete-tp-title">
          {{ $t('projects.observations.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length" show variant="danger" qid="create-p-error">
        {{ error }}
      </b-alert>
      <b-form @submit="editObservationFormSubmit" qid="create-p-form">
        <div class="form-container">
          <b-form-group v-if="selectedTask.project && selectedTask.project.type != 'control_assessment'">
            <label qid="create-s-tags-label">
              {{ $t('projects.observations.create.scope_label') }}
            </label>
            <multiselect v-model="selectedScope" :options="scopeItems"
              :placeholder="$t('projects.observations.create.scope_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="confidentiality-form-impact"></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-name-label">
              {{ $t('projects.observations.create.name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input qid="create-v-form-name" type="text" v-model="editForm.name" required :maxLength="255"
              :placeholder="$t('projects.observations.create.name_placeholder')"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-description-label">
              {{ $t('projects.observations.create.description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea qid="create-v-form-description" v-model="editForm.description" rows="6" max-rows="6"
              required :placeholder="$t('projects.observations.create.description_placeholder')"></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-s-tags-label">
              {{ $t('projects.observations.create.impact_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="selectedImpact" :options="impactItems"
              :placeholder="$t('projects.observations.create.impact_placeholder')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="confidentiality-form-impact"></multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3" variant="secondary" @click="hideEditModal" qid="create-p-cancel-button">
            {{ $t('projects.create.cancel') }}
          </b-button>
          <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
            qid="create-p-submit-button">
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
            </span>
            {{ $t('projects.create.submit') }}
          </b-button>
        </div>
      </b-form>

    </b-modal>



    <!-- Create test modal -->
    <b-modal ref="create-test" hide-footer modal-class="task-modal" @hide="hideEditModal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="update-user-title">
            {{ $t('testing.form.create_new_test') }}
          </h5>
        </div>
      </template>
      <b-alert v-if="error.length" show variant="danger" qid="create-p-error">
        {{ error }}
      </b-alert>
      <b-form @submit="createTestFormSubmit" qid="create-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-v-name-label">
              {{ $t('testing.form.title') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input qid="create-v-form-name" type="text" v-model="testForm.name" required :maxLength="255"
              :placeholder="$t('testing.form.title')"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-description-label">
              {{ $t('testing.form.description') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea qid="create-v-form-description" v-model="testForm.description" rows="6" max-rows="6"
              required :placeholder="$t('testing.form.description')"></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('testing.form.allow_description') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="testForm.allow_description" :options="allowTypes"
              :placeholder="$t('testing.form.allow_description')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('testing.form.allow_attachments') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="testForm.allow_attachment" :options="allowTypes"
              :placeholder="$t('testing.form.allow_attachments')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-3" variant="secondary" @click="hideEditTestModal" qid="create-p-cancel-button">
                    {{ $t('projects.create.cancel') }}
                  </b-button>
                  <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
                    qid="create-p-submit-button">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('projects.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>

    </b-modal>


    <!-- Edit test modal -->
    <b-modal ref="update-test" hide-footer modal-class="task-modal" @hide="hideUpdateTestModal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="update-user-title">
            {{ $t('testing.form.update_test') }}
          </h5>
        </div>
      </template>
      <b-alert v-if="error.length" show variant="danger" qid="create-p-error">
        {{ error }}
      </b-alert>
      <b-form @submit="updateTestFormSubmit" qid="create-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-v-name-label">
              {{ $t('testing.form.title') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input qid="create-v-form-name" type="text" v-model="testForm.name" required :maxLength="255"
              :placeholder="$t('testing.form.title')"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-v-description-label">
              {{ $t('testing.form.description') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea qid="create-v-form-description" v-model="testForm.description" rows="6" max-rows="6"
              required :placeholder="$t('testing.form.description')"></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('testing.form.allow_description') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="testForm.allow_description" :options="allowTypes"
              :placeholder="$t('testing.form.allow_description')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('testing.form.allow_attachments') }}
              <span class="text-red">*</span>
            </label>
            <multiselect v-model="testForm.allow_attachment" :options="allowTypes"
              :placeholder="$t('testing.form.allow_attachments')" label="name"
              :select-label="$t('system.dropdown_select_label')" :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" qid="create-q-form-pg"></multiselect>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-3" variant="secondary" @click="hideUpdateTestModal" qid="create-p-cancel-button">
                    {{ $t('projects.create.cancel') }}
                  </b-button>
                  <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
                    qid="create-p-submit-button">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('projects.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </b-form>

    </b-modal>


    <!-- Show test modal -->
    <b-modal ref="show-test" hide-footer :title="testForm.name" modal-class="task-modal" @hide="hideShowTestModal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times" />
          </span>
          <h5 class="mb-1 text-center" qid="update-user-title">
            {{ selectedTask.reference }}: {{ selectedTest.name }}
          </h5>
          <div class="mb-2 mt-2">
            {{ testForm.description }}
          </div>
        </div>
      </template>
      <b-alert v-if="error.length" show variant="danger" qid="create-p-error">
        {{ error }}
      </b-alert>
      <b-form qid="create-p-form">

        <div class="form-container">
          <b-form-group v-if="isDataOwner(selectedTask) && selectedTest.allow_description != 'No'">
            <label qid="assessment-form-documentation-collection-control-description-label" style="font-size: medium;"
              class="mt-3">
              {{ $t('testing.form.description') }}
              <span class="text-red" v-if="selectedTask && selectedTest.allow_description == 'Mandatory'">*</span>
            </label>

            <span
              v-if="currentView != 'data_collection' || (currentView == 'data_collection' && selectedTest.status != 'passed' && selectedTest.status != 'failed')"
              class="btn btn-edit float-right"
              @click="editModeControlDescriptionDocumentationCollection = !editModeControlDescriptionDocumentationCollection">
              <font-awesome-icon icon="pen" />
            </span>

            <b-form-textarea qid="assessment-form-documentation-collection-control-description"
              v-model="testForm.description_data" v-if="editModeControlDescriptionDocumentationCollection" rows="6"
              max-rows="6" :placeholder="$t('tasks.modal.control_description_label')"></b-form-textarea>

            <div v-if="!editModeControlDescriptionDocumentationCollection" style="margin-top: -20px;">
              <div v-if="testForm.description_data && testForm.description_data.length > 300">
                <p v-if="showFullTextControlDescriptionDocumentationCollection" class="text-formatted">
                  {{ testForm.description_data }}
                </p>

                <p v-if="!showFullTextControlDescriptionDocumentationCollection" class="text-formatted">
                  {{ testForm.description_data | truncate(300) }}
                </p>

                <div class="text-center mt-3"
                  @click="showFullTextControlDescriptionDocumentationCollection = !showFullTextControlDescriptionDocumentationCollection">
                  <span class="cursor-pointer" v-if="!showFullTextControlDescriptionDocumentationCollection">
                    <span class="mr-2">
                      {{ $t('system.view_more') }}
                    </span>
                    <font-awesome-icon icon="chevron-down" />
                  </span>
                  <span class="cursor-pointer" v-if="showFullTextControlDescriptionDocumentationCollection">
                    <span class="mr-2">
                      {{ $t('system.view_less') }}
                    </span>
                    <font-awesome-icon icon="chevron-up" />
                  </span>
                </div>
              </div>

              <p v-if="testForm.description_data && testForm.description_data.length <= 300" class="text-formatted">
                {{ testForm.description_data }}
              </p>
            </div>
          </b-form-group>


          <div v-if="selectedTest.allow_attachment != 'No'" class="w-100" @dragover.prevent
            @drop.prevent="handleDropDocumentation">
            <div v-show="showDropActive" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>

            <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
              {{ $t('attachments.label') }}
              <span class="text-red" v-if="selectedTask && selectedTest.allow_attachment == 'Mandatory'">*</span>
            </label>
            <span class="float-right"
              v-if="currentView != 'data_collection' || (currentView == 'data_collection' && selectedTest.status != 'passed' && selectedTest.status != 'failed')">
              <file-upload ref="uploader" v-model="test_files" :drop="true" :multiple="true" input-id="test-file"
                @input="onTestFileChange" @dropActive="showDropActiveFunction" @dropInactive="hideDropActiveFunction"
                class="text-success cursor-pointer float:right mt-3">
                {{ $t('tasks.modal.add_attachment_label') }}
              </file-upload>
            </span>
          </div>
          <ul class="compact-list" style="list-style-type: none; padding-left: 0;"
            v-if="selectedTest && selectedTest.allow_attachment != 'No'">
            <li v-for="(item, index) in getTestMedia('documents')" :key="index" class="text-bold list-item">
              <div class="row">
                <div class="col-md-8" style="line-height: 20px;">
                  <a :href="item.url" target="_blank" class="text-success" qid="download-media">
                    {{ item.full_title }}
                  </a>
                </div>
                <div class="col-md-4 actions" style="text-align: right;">
                  <a :href="item.url" target="_blank" class="btn" qid="download-media">
                    <font-awesome-icon icon="eye" />
                  </a>
                  <a class="btn" @click="downloadMedia(item)" qid="download-media">
                    <font-awesome-icon icon="cloud-download-alt" />
                  </a>
                  <a class="btn" @click="openDeleteAttachmentModal(item)" qid="remove-media-item">
                    <font-awesome-icon icon="trash-alt" />
                  </a>
                </div>
              </div>
            </li>
            <li v-if="!getTestMedia('documents').length" qid="no-results-row-rr">
              <div class="text-muted">{{ $t('system.no_results') }}</div>
            </li>
          </ul>

          <b-form-group v-if="isOwner(selectedTask) && currentView != 'data_collection'">
            <label qid="create-q-pg-label">
              {{ $t('testing.form.status') }}
            </label>
            <multiselect v-model="testForm.status" :options="testStatus" :placeholder="$t('testing.form.status')"
              label="name" :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')" :allow-empty="false" :multiple="false"
              :taggable="false" qid="OE testing status">
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                  v-if="props.option.value == 'pending'" />
                <font-awesome-icon icon="info-circle" class="icon-info"
                  v-if="props.option.value == 'documentation_collection_completed'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'failed'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'passed'"
                  style="background:white;border-radius:50%;" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                  v-if="props.option.value == 'pending'" />
                <font-awesome-icon icon="info-circle" class="icon-info"
                  v-if="props.option.value == 'documentation_collection_completed'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="times-circle" class="icon-danger" v-if="props.option.value == 'failed'"
                  style="background:white;border-radius:50%;" />
                <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'passed'"
                  style="background:white;border-radius:50%;" />
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
                <span v-if="props.option.$groupLabel">
                  {{ props.option.$groupLabel }}
                </span>
              </template>
            </multiselect>

          </b-form-group>

          <b-form-group v-if="isOwner(selectedTask) && currentView != 'data_collection'">
            <label qid="create-v-description-label">
              {{ $t('testing.form.comment') }}
            </label>
            <b-form-textarea qid="create-v-form-description" v-model="testForm.comment" rows="6" max-rows="6"
              :placeholder="$t('testing.form.description')"></b-form-textarea>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-12">
                <div class="text-right">
                  <b-button class="mt-3" variant="secondary" @click="hideShowTestModal"
                    v-if="currentView != 'data_collection'" qid="create-p-cancel-button">
                    {{ $t('projects.create.cancel') }}
                  </b-button>
                  <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
                    qid="create-p-submit-button" v-if="currentView != 'data_collection'" @click="saveWithoutComplete">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('projects.create.submit') }}
                  </b-button>
                  <b-button type="submit" class="mt-3 ml-3" variant="secondary" :disabled="buttonDisabled"
                    qid="create-p-submit-button"
                    v-if="currentView == 'data_collection' && selectedTest.status != 'passed' && selectedTest.status != 'failed'"
                    @click="saveWithoutComplete">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('system.save_without_complete') }}
                  </b-button>
                  <b-button type="submit" class="mt-3 ml-3" variant="success" :disabled="buttonDisabled"
                    qid="create-p-submit-button"
                    v-if="currentView == 'data_collection' && selectedTest.status != 'passed' && selectedTest.status != 'failed'"
                    @click="completeSubmission">
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </span>
                    {{ $t('tasks.modal.complete') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </b-form>

    </b-modal>

  </span>

</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import Datepicker from 'vuejs-datepicker';
import { config } from '@/config.js';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import GuideViewModal from '@/components/guide/GuideViewModal.vue';
import roleCheck from '@/util/ACL/roleCheck';
import Avatar from '@/components/Avatar.vue';
import ShowMoreModal from '@/components/ShowMoreModal.vue';
// import draggable from 'vuedraggable'
import CreateObservationModal from '@/views/Projects/CreateObservationModal.vue';
import WordByWord from '@/components/WordByWord.vue';
// import AssessmentGlobalExpandable from '@/components/tasks/AssessmentGlobalExpandable.vue';
import UserInviteModal from '@/components/user/UserInviteModal.vue';
import ObservationViewModal from '@/views/Projects/ObservationViewModal.vue';
import MeasuresTable from '@/views/Projects/MeasuresTable.vue';

export default {
  name: 'AssessmentGlobalSingleTaskModal',
  data: function () {
    return {
      // Update Task variables
      taskForm: {
        remarks: '',
        notes: '',
        data_remarks: '',
        control_description: '',
        performed_text: '',
        testing_notes: '',
        rto: '',
        rpo: ''
      },
      testForm: {
        name: '',
        description: '',
        allow_description: '',
        allow_attachment: '',
        status: '',
        comment: '',
        description_data: ''
      },
      selectedTask: [],
      selectedTest: [],

      // Update Question variables
      form: {
        name: '',
        description: '',
        description_two: '',
        reference: '',
        control_objective: {},
        links: [],
        data_collection_links: [],
        data_collection_description: '',
        data_collection_description_two: ''
      },
      referenceInvalid: false,
      addControlDescription: [],
      addNotes: [],
      addTestingNotes: [],
      addPerformedText: [],
      addDescription: [],
      addResponse: [],
      addAttachments: [],
      data_collection_on: 0,
      responseType: [],
      responseTypeDoc: [],
      addResponseDoc: [],
      dataCollectionAddDescription: [],
      dataCollectionAddAttachments: [],
      showQuestionLinksSection: false,
      showQuestionTwoLinksSection: false,
      selectedTaskDependency: [],

      responseTypes: [
        {
          group: this.$t('maintenance.questions.answer_type.input_label'),
          items: [
            { name: this.$t('maintenance.questions.type.datepicker'), value: 'Datepicker' },
          ]
        },
        {
          group: this.$t('maintenance.questions.answer_type.dropdown_label'),
          items: [
            { name: this.$t('maintenance.questions.type.dropdown'), value: 'Dropdown' },
            { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No' }
          ]
        }
      ],
      allowTypes: [
        { name: this.$t('maintenance.questions.type.no'), value: 'No' },
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
      ],
      allowTypesDoc: [
        { name: this.$t('maintenance.questions.type.no'), value: 'No' },
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
        { name: this.$t('maintenance.questions.type.auditor'), value: 'Auditor' },
      ],
      testStatus: [
        { name: this.$t('testing.status.pending'), value: 'pending' },
        { name: this.$t('testing.status.documentation_collection_completed'), value: 'documentation_collection_completed' },
        { name: this.$t('testing.status.failed'), value: 'failed' },
        { name: this.$t('testing.status.passed'), value: 'passed' },
      ],
      allowTypesShort: [
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
      ],
      answerTypes: [
        {
          group: this.$t('maintenance.questions.answer_type.positive_negative_label'),
          items: [
            { name: this.$t('maintenance.questions.answer_type.neutral'), value: 'Neutral' },
            { name: this.$t('maintenance.questions.answer_type.positive'), value: 'Positive' },
            { name: this.$t('maintenance.questions.answer_type.negative'), value: 'Negative' },
          ]
        },
        {
          group: this.$t('maintenance.questions.answer_type.impact_assessment_label'),
          items: [
            { name: this.$t('maintenance.questions.answer_type.very_low'), value: 'Very low' },
            { name: this.$t('maintenance.questions.answer_type.low'), value: 'Low' },
            { name: this.$t('maintenance.questions.answer_type.high'), value: 'High' },
            { name: this.$t('maintenance.questions.answer_type.very_high'), value: 'Very high' },
          ]
        },
      ],
      yesNoOptions: [
        'Yes',
        'No'
      ],
      yesValue: [],
      noValue: [],
      dataCollectionOptions: [
        { text: this.$t('system.yes'), value: 1 },
        { text: this.$t('system.no'), value: 0 },
      ],
      selectedOptions: [],
      inputOption: '',
      positiveAnswers: [],
      negativeAnswers: [],

      // Framework Control variables
      selectedFrameworkControls: [],
      selectedFramework: [],
      selectedFrameworkControl: [],
      frameworkControlItems: [],
      frameworkItems: [],

      // Control Objective variables
      controlObjectives: [],
      selectedControlObjective: {},
      assessmentControlOpen: false,
      coForm: {
        name: '',
        description: ''
      },
      sTableItems: [],
      loadingObservations: true,
      perPage: '',
      selectedPerPage: "10",
      currentPage: 1,
      totalRows: 0,
      selectedObservation: {},
      viewObservationModal: false,
      itemToDelete: {},
      editForm: {
        name: '',
        description: '',
        scope_id: '',
        impact_assessment: ''
      },
      selectedImpact: [],
      scopeItems: [],
      selectedScope: [],
      // General variables
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      selectedComment: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkedAttachmentModal: false,
      showDeleteLinkModal: false,
      showDeleteCommentModal: false,
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      inputLinkName: '',
      descriptionLength: config.descriptionLength,
      showFullProjectMessage: false,
      showFullTaskDescription: false,
      showFullDataCollectionDescription: false,
      showFullMainTaskDescriptionOne: false,
      showFullMainTaskDescriptionTwo: false,
      showFullGenericControlDescription: false,
      error: '',
      sizeError: '',
      taskList: [],
      selectedAnswer: [],
      selectedAnswerDoc: [],
      selectedDate: '',
      selectedDateDoc: '',
      selectedDataCollectionAnswer: [],
      allAnswers: [],
      allAnswersDoc: [],
      impactItems: [
        { name: this.$t('impact.very_low'), value: 'Very low' },
        { name: this.$t('impact.low'), value: 'Low' },
        { name: this.$t('impact.high'), value: 'High' },
        { name: this.$t('impact.very_high'), value: 'Very high' }
      ],
      intervalOptions: [
        { text: this.$t('system.interval_seconds'), value: 'Seconds' },
        { text: this.$t('system.interval_minutes'), value: 'Minutes' },
        { text: this.$t('system.interval_hours'), value: 'Hours' },
        { text: this.$t('system.interval_days'), value: 'Days' },
        { text: this.$t('system.interval_months'), value: 'Months' },
        { text: this.$t('system.interval_years'), value: 'Years' },
      ],
      selectedConfidentialityImpact: [],
      selectedIntegrityImpact: [],
      selectedAvailabilityImpact: [],
      rtoInterval: [],
      rpoInterval: [],
      project_progress: 0,
      taskCompleted: false,
      welcomeGuide: {},
      selectedGuide: {},
      viewGuideModal: false,
      selectedItem: {},
      showUsersModal: false,
      currentView: 'default',
      files: [],
      files_two: [],
      data_collection_files: [],
      test_files: [],
      data_collection_two_files: [],
      showLinksSection: false,
      showLinksSectionTwo: false,
      showDataCollectionLinksSection: false,
      uploader: false,
      showDropActive: false,
      userList: [],
      comment: '',
      reopenError: '',
      selectedAssignUsers: [],
      previousComments: [],
      qaComments: [],
      loadingQaComments: true,
      tests: [],
      loadingTests: true,
      showFullGuideDescription: false,
      wpGuide: {},
      wpGuideData: {},
      wpGuideSystem: {},
      myGuides: [],
      myGuidesData: [],
      myGuidesSystem: [],

      editModeResponse: false,
      editModeResponseDoc: false,
      editModeResponseDocMain: false,
      editModeNotes: false,
      editModeControlDescription: false,
      editModePerformedTest: false,
      editModeTestingNotes: false,
      editModeConclusion: false,
      editModeControlDescriptionDocumentationCollection: false,

      showFullTextNotes: false,
      showFullTextControlDescription: false,
      showFullTextPerformedTest: false,
      showFullTextTestingNotes: false,
      showFullTextConclusion: false,
      showFullTextControlDescriptionDocumentationCollection: false,

      assessmentGlobalExpandableShow: false,
      qa_comment: '',
      linkedControls: [],
      allLinkedMediaFiles: [],
      allLinkedDataMediaFiles: [],
      selectedLinkedMedia: [],
      selectedLinkedDataMedia: [],
      isControlDescriptionDrawerOpen: false,
      isFullAnalystDrawerOpen: false,
      isTestingDrawerOpen: false,
      testPlanAi: [],
      controlDescriptionAi: [],
      fullAnalystAi: [],
      ailoading: false,
      errorDescriptionDrawer: '',
      errorTestingDrawer: '',
      errorFullAnalystDrawer: '',
      timeLeft: 120,
      timerId: null,
      selectedLinkedControls: [],
      selectedLinkedControlsAsTarget: [],
      selectedLinkedControl: [],
      selectedAssessment: [],
      assessmentItems: [],
      assessmentControlItems: [],
      yesValueDoc: [],
      noValueDoc: [],
      selectedOptionsDoc: [],
      positiveAnswersDoc: [],
      negativeAnswersDoc: [],
      allAnswersDoc: [],
      allAnswersCopyDoc: []
    }
  },
  props: {
    task: {},
    fromHomepage: {},
    controlObjective: {},
  },
  components: {
    Datepicker,
    ConfirmRemoveAttachment,
    GuideViewModal,
    Avatar,
    ShowMoreModal,
    // draggable,
    CreateObservationModal,
    UserInviteModal,
    // AssessmentGlobalExpandable,
    ObservationViewModal,
    MeasuresTable,
    WordByWord
  },
  computed: {
    getClient() {
      return this.$store.state.client;
    },
    getUser() {
      return this.$store.state.user;
    },
    getWordpressLink() {
      return this.$store.state.wordpressLink;
    },
    getReportMedia() {
      let media = [];

      if (this.selectedTask.project) {
        media = _.filter(this.selectedTask.project.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'project';
        });
      }


      return media;
    },
    getReportLinks() {
      let links = [];

      if (this.selectedTask.project) {
        links = _.filter(this.selectedTask.project.links, function (link) {
          return link.collection == null;
        });
      }

      return links;
    },
    formattedText() {
      // Replace newlines with <br><br> for HTML rendering
      return this.text.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
    },
  },
  watch: {
    getClient: function () {

    },
    includeScheduled: function () {
      this.loadCA();
    }
  },
  methods: {
    handleType(value) {
      this.positiveAnswers = [];
      this.negativeAnswers = [];
      if (value && value.value === 'Dropdown' || value.value === 'System') {
        this.allAnswers = this.selectedOptions;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      } else {
        this.noValue = this.answerTypes[0].items[0];
        this.yesValue = this.answerTypes[0].items[0];
        this.allAnswers = this.yesNoOptions;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      }
    },
    handleTypeDoc(value) {
      this.positiveAnswersDoc = [];
      this.negativeAnswersDoc = [];
      if (value && value.value === 'Dropdown' || value.value === 'System') {
        this.allAnswers = this.selectedOptionsDoc;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      } else {
        this.noValue = this.answerTypes[0].items[0];
        this.yesValue = this.answerTypes[0].items[0];
        this.allAnswers = this.yesNoOptions;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      }
    },
    formatOptionLabel(option) {
      // Ensure reference and name are handled even if one is missing
      const reference = option.reference || '';
      const name = option.name || '';
      if (reference) {
        return `${reference}: ${name}`;
      } else {
        return `${name}`;
      }
    },
    loadAssessmentControlItems(query) {
      let self = this;

      piincHttp.get('questions', {
        params:
        {
          client: self.getClient.slug,
          per_page: 100,
          assessment: self.selectedAssessment.id
        }
      }).then(function (responseQuestions) {

        const globalIdToRemove = null;

        // Filter out questions that are already selected
        self.assessmentControlItems = responseQuestions.data.items.filter(
          question => question.id !== globalIdToRemove
        );

        if (self.assessmentControlItems && !self.assessmentControlItems.length && !query) {
          self.assessmentControlItems.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () { });
    },
    linkedControlFormSubmit(evt) {
      let self = this;
      evt.preventDefault();

      let addToArray = false;

      if (self.selectedLinkedControl && self.selectedLinkedControl.id) {
        if (this.selectedLinkedControls.length) {
          _.forEach(this.selectedLinkedControls, function (item) {
            if (item.id !== self.selectedLinkedControl.id) {
              addToArray = true;
            }
          })
        } else {
          addToArray = true;
        }

        if (addToArray) {
          this.selectedLinkedControls.push(this.selectedLinkedControl);
        }

        this.hideAddLinkedControlModal();
      } else {
        this.error = this.$t('maintenance.questions.create.framework_control_error');
      }

    },
    handleAssessmentChange(item) {
      this.selectedAssessment = item;
      this.loadAssessmentControlItems();
    },
    loadAssessmentItems(query) {
      let self = this;
      piincHttp.get('assessments', {
        params:
        {
          client: this.getClient.slug,
          per_page: 100,
          keyword: query ? query : undefined
        }
      }).then(function (response) {
        self.assessmentItems = response.data.items
        if (self.assessmentItems && !self.assessmentItems.length && !query) {
          self.assessmentItems.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () { });
    },
    showAddLinkedControlModal() {
      this.assessmentLinkedControlOpen = true;
      this.selectedAssessment = [];
      this.error = '';
      this.selectedLinkedControl = [];
      this.loadAssessmentItems();
      this.$refs['add-linked-control'].show();
    },
    hideAddLinkedControlModal() {
      this.assessmentLinkedControlOpen = false;
      this.error = '';
      this.selectedAssessment = [];
      this.selectedLinkedControl = [];
      this.$refs['add-linked-control'].hide();
    },
    startCountdown() {
      // Clear any existing timer to allow it to be restarted
      if (this.timerId) {
        clearInterval(this.timerId);
      }

      this.timeLeft = 120;

      // Store a reference to the component's 'this'
      const self = this;

      this.timerId = setInterval(function () {
        if (self.timeLeft > 0) {
          self.timeLeft--;
        } else {
          clearInterval(self.timerId);
        }
      }, 1000);
    },
    toggleTestingDrawer(type) {
      const wasClosed = !this.isTestingDrawerOpen;

      this.ailoading = false;

      this.isControlDescriptionDrawerOpen = false;
      this.isFullAnalystDrawerOpen = false;

      this.errorTestingDrawer = '';
      this.isTestingDrawerOpen = !this.isTestingDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'test_plan');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {
            this.testPlanAi = response.data.choices
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorTestingDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.testPlanAi = [];
      }

    },
    toggleControlDescriptionDrawer(type) {
      const wasClosed = !this.isControlDescriptionDrawerOpen;

      this.ailoading = false;

      this.isTestingDrawerOpen = false;
      this.isFullAnalystDrawerOpen = false;

      this.errorDescriptionDrawer = '';
      this.isControlDescriptionDrawerOpen = !this.isControlDescriptionDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'control_description');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {
            this.controlDescriptionAi = response.data.choices
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorDescriptionDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.controlDescriptionAi = [];
      }
    },
    toggleFullAnalystDrawer(type) {
      const wasClosed = !this.isFullAnalystDrawerOpen;

      this.isControlDescriptionDrawerOpen = false;
      this.isTestingDrawerOpen = false;

      this.ailoading = false;
      this.errorFullAnalystDrawer = '';
      this.isFullAnalystDrawerOpen = !this.isFullAnalystDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'full_analyst');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {

            this.fullAnalystAi = response.data.choices
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorFullAnalystDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.fullAnalystAi = [];
      }

    },
    loadQaComments() {
      let self = this;
      this.qaComments = []
      this.loadingQaComments = true;

      piincHttp.get('tasks/' + this.selectedTask.id + '/comments', {
        params:
        {
          client: this.getClient.id,
          per_page: 100,
          sort: 'created_at',
          order: 'asc',
          types: 'accepted,rejected,completed'
        }
      }).then(function (response) {
        self.qaComments = []

        _.forEach(response.data.items, function (item) {
          self.qaComments.push(item);
        })

        self.loadingQaComments = false;
      }, function () {
      });
    },
    loadTests() {
      let self = this;

      this.loadingTests = true;
      piincHttp.get('tasks/' + this.selectedTask.id + '/tests', {
        params:
        {
          per_page: 100,
          sort: 'created_at',
          order: 'asc'
        }
      }).then(function (response) {
        self.tests = []

        _.forEach(response.data.items, function (item) {
          self.tests.push(item);
        })

        self.loadingTests = false;
      }, function () {
      });
    },
    loadTest(testId) {
      let self = this;
      piincHttp.get('tasks/' + this.selectedTask.id + '/tests/' + testId, {
      }).then(function (response) {
        self.selectedTest = response.data

      }, function () {
      });
    },
    showQaLog() {
      let self = this;
      self.loadQaComments();
      self.$refs['qa-log'].show();
    },
    hideQaLog() {
      let self = this;
      self.$refs['qa-log'].hide();
    },
    showReopenQaTask() {
      let self = this;
      self.qa_comment = '';
      self.$refs['reopen-qa-task'].show();
    },
    hideReopenQaTask() {
      let self = this;
      self.$refs['reopen-qa-task'].hide();
    },
    showReopenQaTaskComplete() {
      let self = this;
      self.qa_comment = '';
      self.$refs['reopen-qa-task-complete'].show();
    },
    hideReopenQaTaskComplete() {
      let self = this;
      self.$refs['reopen-qa-task-complete'].hide();
    },
    reOpenQaTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'pending',
        qa_status: 'rejected',
        qa_comment: self.qa_comment
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.loadComments()
        self.$emit('reloadContent');
        self.$refs['reopen-qa-task'].hide();
        self.loadQaComments()
      }, function (error) {

        self.buttonDisabled = false;
        self.error = error.data.message;

      })
    },
    completeOpenQaTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'completed',
        qa_status: 'completed',
        qa_comment: self.qa_comment
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.$refs['reopen-qa-task-complete'].hide();

        self.taskCompleted = true;
        self.$store.commit('storeTaskToolbarState', false);
        self.$emit('reloadContent');
        self.hideTaskModal();
      }, function (error) {

        self.buttonDisabled = false;
        self.error = error.data.message;

      })
    },
    acceptQaTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        qa_status: 'accepted',
        qa_comment: 'accepted'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.$emit('reloadContent');
        self.hideTaskModal();
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    // Edit modals
    showEditQForm1() {
      this.buttonDisabled = true;
      let self = this;
      self.$refs['edit-question-1'].show();
      self.$refs['edit-question-2'].hide();
      self.$refs['edit-question-3'].hide();
      self.$refs['edit-question-4'].hide();
      self.$refs['edit-question-5'].hide();
      self.buttonDisabled = false;
    },
    showEditQForm2(type) {
      this.buttonDisabled = true;
      let self = this;
      self.error = '';

      if (type && type == 'forward') {
        if (self.form.name && self.form.name.length && this.selectedControlObjective && this.selectedControlObjective.id && !this.referenceInvalid) {
          self.$refs['edit-question-1'].hide();
          self.$refs['edit-question-2'].show();
          self.$refs['edit-question-3'].hide();
          self.$refs['edit-question-4'].hide();
          self.$refs['edit-question-5'].hide();
        } else {
          self.error = ''
          if (!self.form.name.length) {
            this.error += ' ' + this.$t('maintenance.data_objects.create.name_error');
          }
          if (self.referenceInvalid) {
            this.error += ' ' + this.$t('maintenance.questions.create.reference_error_message');
          }
          if (!this.selectedControlObjective || (this.selectedControlObjective && !this.selectedControlObjective.id)) {
            this.error += ' ' + this.$t('maintenance.questions.create.control_objective_error_message');
          }
        }
      } else {
        self.$refs['edit-question-1'].hide();
        self.$refs['edit-question-2'].show();
        self.$refs['edit-question-3'].hide();
        self.$refs['edit-question-4'].hide();
        self.$refs['edit-question-5'].hide();
      }

      self.buttonDisabled = false;
    },
    showEditQForm3(type) {
      this.buttonDisabled = true;
      let self = this;
      self.error = '';

      self.$refs['edit-question-1'].hide();
      self.$refs['edit-question-2'].hide();
      self.$refs['edit-question-3'].show();
      self.$refs['edit-question-4'].hide();
      self.$refs['edit-question-5'].hide();

      self.buttonDisabled = false;
    },
    showEditQForm4(type) {
      this.buttonDisabled = true;
      let self = this;
      self.error = '';

      if (type && type == 'forward') {

        if ((self.data_collection_on && self.form.data_collection_description && self.form.data_collection_description.length && this.dataCollectionAddAttachments && this.dataCollectionAddDescription.value && this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) || !self.data_collection_on) {
          self.$refs['edit-question-1'].hide();
          self.$refs['edit-question-2'].hide();
          self.$refs['edit-question-3'].hide();
          self.$refs['edit-question-4'].show();
          self.$refs['edit-question-5'].hide();
        } else {
          self.error = ''
          if (!self.form.data_collection_description.length) {
            this.error += ' ' + this.$t('maintenance.questions.create.data_collection_description_error_message');
          }
          if (!this.dataCollectionAddDescription || (this.dataCollectionAddDescription && !this.dataCollectionAddDescription.value)) {
            this.error += ' ' + this.$t('maintenance.questions.create.add_description_error_message');
          }
          if (!this.dataCollectionAddAttachments || (this.dataCollectionAddAttachments && !this.dataCollectionAddAttachments.value)) {
            this.error += ' ' + this.$t('maintenance.questions.create.add_attachments_error_message');
          }
        }
      } else {
        self.$refs['edit-question-1'].hide();
        self.$refs['edit-question-2'].hide();
        self.$refs['edit-question-3'].hide();
        self.$refs['edit-question-4'].show();
        self.$refs['edit-question-5'].hide();
      }

      self.buttonDisabled = false;
    },
    showEditQForm5() {
      this.assessmentControlOpen = true;
      this.buttonDisabled = true;
      let self = this;
      let sizeError = false;
      self.error = '';

      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
      }

      if ((self.data_collection_on && self.form.data_collection_description && self.form.data_collection_description.length && this.dataCollectionAddAttachments && this.dataCollectionAddDescription.value && this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) || !self.data_collection_on) {
        self.$refs['edit-question-1'].hide();
        self.$refs['edit-question-2'].hide();
        self.$refs['edit-question-3'].hide();
        self.$refs['edit-question-4'].hide();
        self.$refs['edit-question-5'].show();
      } else {
        self.error = ''
        if (!self.form.data_collection_description.length) {
          this.error += ' ' + this.$t('maintenance.questions.create.data_collection_description_error_message');
        }
        if (!this.dataCollectionAddDescription || (this.dataCollectionAddDescription && !this.dataCollectionAddDescription.value)) {
          this.error += ' ' + this.$t('maintenance.questions.create.add_description_error_message');
        }
        if (!this.dataCollectionAddAttachments || (this.dataCollectionAddAttachments && !this.dataCollectionAddAttachments.value)) {
          this.error += ' ' + this.$t('maintenance.questions.create.add_attachments_error_message');
        }
      }

      self.buttonDisabled = false;
    },
    getDataCollectionTwoLinks() {
      let links = []

      links = _.filter(this.selectedQuestion.links, function (link) {
        return link.collection === 'data_collection_two';
      });

      return links;
    },
    handleEditDataCollectionLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLinkDataCollection.startsWith('http')) {
        this.inputLinkDataCollection = 'https://' + this.inputLinkDataCollection;
      }

      formData.append("url", this.inputLinkDataCollection);
      formData.append("name", this.inputLinkNameDataCollection);
      formData.append("collection", "data_collection");
      formData.append("model_type", this.selectedQuestion.who_am_i);
      formData.append("model_id", this.selectedQuestion.id);

      piincHttp.post('links', formData).then(function () {
        self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'));
        self.loadQuestion();
        self.inputLinkDataCollection = '';
        self.inputLinkNameDataCollection = '';
        self.showInput = false;
      }, function () {
      })
    },
    handleEditDataCollectionTwoLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLinkDataCollection.startsWith('http')) {
        this.inputLinkDataCollection = 'https://' + this.inputLinkDataCollection;
      }

      formData.append("url", this.inputLinkDataCollection);
      formData.append("name", this.inputLinkNameDataCollection);
      formData.append("collection", "data_collection_two");
      formData.append("model_type", this.selectedQuestion.who_am_i);
      formData.append("model_id", this.selectedQuestion.id);

      piincHttp.post('links', formData).then(function () {
        self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'));
        self.loadQuestion();
        self.inputLinkDataCollection = '';
        self.inputLinkNameDataCollection = '';
        self.showInput = false;
      }, function () {
      })
    },
    onFileChangeDataCollectionTwoEdit(files) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (let i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_collection_two");
      formData.append("model_type", this.selectedQuestion.who_am_i);
      formData.append("model_id", this.selectedQuestion.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = []
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'));
          self.error = '';
          self.loadQuestion()
          // reset the model array
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
        })
      }
    },
    onFileChangeDataCollectionEdit(files) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (let i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_collection");
      formData.append("model_type", this.selectedQuestion.who_am_i);
      formData.append("model_id", this.selectedQuestion.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = []
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'));
          self.error = '';
          self.loadQuestion()
          // reset the model array
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
        })
      }
    },
    getDataCollectionLinks() {
      let links = []

      links = _.filter(this.selectedQuestion.links, function (link) {
        return link.collection === 'data_collection';
      });

      return links;
    },
    hideEditQModal() {
      this.assessmentControlOpen = false;
      this.$refs['edit-question-1'].hide();
      this.$refs['edit-question-2'].hide();
      this.$refs['edit-question-3'].hide();
      this.$refs['edit-question-4'].hide();
      this.$refs['edit-question-5'].hide();
    },
    showEditQModal(object) {
      let self = this;

      // -------------------------
      // Reset state
      // -------------------------
      this.error = '';

      this.selectedOptions = [];
      this.selectedOptionsDoc = [];
      this.inputOption = '';
      this.inputOptionDoc = '';
      this.positiveAnswers = [];
      this.negativeAnswers = [];
      this.positiveAnswersDoc = [];
      this.negativeAnswersDoc = [];

      this.allAnswers = [];
      this.allAnswersDoc = [];

      this.selectedControlObjective = [];
      this.selectedLinkedControls = [];
      this.selectedLinkedControlsAsTarget = [];
      this.selectedFrameworkControls = [];

      this.responseType = [];
      this.responseTypeDoc = [];

      this.selectedFiles = [];
      this.selectedFilesDoc = [];

      this.form.links = [];
      this.form.data_collection_links = [];

      this.inputLink = '';
      this.inputLinkName = '';
      this.inputLinkDataCollection = '';
      this.inputLinkNameDataCollection = '';

      this.data_collection_on = 0;
      this.showInput = true;
      this.showInputDoc = true;
      this.showOptionInput = true;
      this.referenceInvalid = false;

      this.form.name = '';
      this.form.description = '';
      this.form.description_two = '';
      this.form.data_collection_description = '';
      this.form.data_collection_description_two = '';
      this.form.reference = '';

      this.files = [];
      this.data_collection_files = [];
      this.data_collection_two_files = [];

      this.addDescription = [];
      this.addResponse = [];
      this.addResponseDoc = [];
      this.addControlDescription = [];
      this.addNotes = [];
      this.addTestingNotes = [];
      this.addPerformedText = [];
      this.addAttachments = [];
      this.dataCollectionAddDescription = [];
      this.dataCollectionAddAttachments = [];

      this.showLinksSection = false;
      this.showLinksSectionTwo = false;
      this.showQuestionLinksSection = false;
      this.showQuestionTwoLinksSection = false;

      this.selectedTaskDependency = [];
      this.selectedAnswers = [];

      // -------------------------
      // Framework controls
      // -------------------------
      if (object.framework_controls && object.framework_controls.length) {
        this.selectedFrameworkControls = _.cloneDeep(object.framework_controls);
      }

      // -------------------------
      // Response type (MAIN)
      // -------------------------
      if (object.response_type) {
        if (object.response_type === 'Datepicker') {
          this.responseType = _.find(this.responseTypes[0].items, i => i.value === object.response_type);
        } else {
          this.responseType = _.find(this.responseTypes[1].items, i => i.value === object.response_type);
        }
      }

      // -------------------------
      // Response type (DOC)
      // -------------------------
      if (object.response_type_doc) {
        if (object.response_type_doc === 'Datepicker') {
          this.responseTypeDoc = _.find(this.responseTypes[0].items, i => i.value === object.response_type_doc);
        } else {
          this.responseTypeDoc = _.find(this.responseTypes[1].items, i => i.value === object.response_type_doc);
        }
      }

      // -------------------------
      // Allow flags
      // -------------------------
      if (object.add_description) {
        this.addDescription = _.find(this.allowTypes, i => i.value === object.add_description);
      }

      if (object.add_response) {
        this.addResponse = _.find(this.allowTypes, i => i.value === object.add_response);
      }

      if (object.add_response_doc) {
        this.addResponseDoc = _.find(this.allowTypesDoc, i => i.value === object.add_response_doc);
      }

      if (object.add_notes) {
        this.addNotes = _.find(this.allowTypes, i => i.value === object.add_notes);
      }

      if (object.add_testing_notes) {
        this.addTestingNotes = _.find(this.allowTypes, i => i.value === object.add_testing_notes);
      }

      if (object.add_control_description) {
        this.addControlDescription = _.find(this.allowTypes, i => i.value === object.add_control_description);
      }

      if (object.add_performed_text) {
        this.addPerformedText = _.find(this.allowTypes, i => i.value === object.add_performed_text);
      }

      if (object.add_attachments) {
        this.addAttachments = _.find(this.allowTypes, i => i.value === object.add_attachments);
      }

      // -------------------------
      // Data collection toggles
      // -------------------------
      if (object.data_collection_add_description) {
        this.dataCollectionAddDescription = _.find(this.allowTypes, i => i.value === object.data_collection_add_description);
      } else {
        this.dataCollectionAddDescription = this.allowTypes[1];
      }

      if (object.data_collection_add_attachments) {
        this.dataCollectionAddAttachments = _.find(this.allowTypes, i => i.value === object.data_collection_add_attachments);
      } else {
        this.dataCollectionAddAttachments = this.allowTypes[1];
      }

      // -------------------------
      // MAIN response options
      // -------------------------
      if (object.response_type === 'Dropdown' && object.response_type_options) {
        this.selectedOptions = JSON.parse(object.response_type_options);
      }

      if (object.response_type === 'Yes/No' && object.response_type_options) {
        let array = JSON.parse(object.response_type_options);

        this.yesValue = array[0] && array[0].value ? array[0].value : '';
        this.noValue = array[1] && array[1].value ? array[1].value : '';
      }

      // -------------------------
      // DOC response options
      // -------------------------
      if (object.response_type_doc === 'Dropdown' && object.response_type_options_doc) {
        this.selectedOptionsDoc = JSON.parse(object.response_type_options_doc);
      }

      if (object.response_type_doc === 'Yes/No' && object.response_type_options_doc) {
        let array = JSON.parse(object.response_type_options_doc);

        this.yesValueDoc = array[0] && array[0].value ? array[0].value : '';
        this.noValueDoc = array[1] && array[1].value ? array[1].value : '';
      }

      // -------------------------
      // Linked controls
      // -------------------------
      this.selectedLinkedControls = Array.isArray(object.linked_controls)
        ? [...object.linked_controls]
        : [];

      this.selectedLinkedControlsAsTarget = Array.isArray(object.linkedControlsAsTarget)
        ? [...object.linkedControlsAsTarget]
        : [];

      // -------------------------
      // Dependency
      // -------------------------
      if (object.dependency_question_id) {
        this.selectedTaskDependency = _.find(this.tableItems, i => i.id === object.dependency_question_id);

        this.handleAnswers(this.selectedTaskDependency);

        if (object.dependency_question_answer) {
          _.forEach(object.dependency_question_answer, function (item) {
            self.selectedAnswers.push({ title: item, value: item });
          });
        }
      }

      // -------------------------
      // Control objective
      // -------------------------
      if (object.control_objective && object.control_objective.id) {
        this.selectedControlObjective = object.control_objective;
      }

      // -------------------------
      // Assign form values
      // -------------------------
      this.form.slug = object.slug;
      this.form.name = object.title;
      this.form.description = object.description;
      this.form.description_two = object.description_two;
      this.form.data_collection_description = object.data_collection_description || '';
      this.form.data_collection_description_two = object.data_collection_description_two || '';
      this.form.reference = object.reference;

      this.data_collection_on = object.data_collection_on;

      // -------------------------
      // Show modal
      // -------------------------
      this.showEditQForm1();
    },
    editFormSubmit(evt) {
      this.buttonDisabled = true;
      let self = this;
      evt.preventDefault();

      let form = {};

      // -------------------------
      // Basic fields
      // -------------------------
      form.title = this.form.name;
      form.reference = this.form.reference;
      form.description = this.form.description;
      form.description_two = this.form.description_two;

      // -------------------------
      // Data collection
      // -------------------------
      if (this.data_collection_on) {
        form.data_collection_on = this.data_collection_on;
        form.data_collection_description = this.form.data_collection_description;
        form.data_collection_description_two = this.form.data_collection_description_two;

        if (this.dataCollectionAddDescription && this.dataCollectionAddDescription.value) {
          form.data_collection_add_description = this.dataCollectionAddDescription.value;
        }

        if (this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) {
          form.data_collection_add_attachments = this.dataCollectionAddAttachments.value;
        }
      } else {
        form.data_collection_on = 0;
      }

      // -------------------------
      // Response types
      // -------------------------
      if (this.responseType && this.responseType.value) {
        form.response_type = this.responseType.value;
      }

      if (this.responseTypeDoc && this.responseTypeDoc.value) {
        form.response_type_doc = this.responseTypeDoc.value;
      }

      // -------------------------
      // Toggles
      // -------------------------
      if (this.addDescription && this.addDescription.value) {
        form.add_description = this.addDescription.value;
      }

      if (this.addResponse && this.addResponse.value) {
        form.add_response = this.addResponse.value;
      }

      if (this.addResponseDoc && this.addResponseDoc.value) {
        form.add_response_doc = this.addResponseDoc.value;
      }

      if (this.addControlDescription && this.addControlDescription.value) {
        form.add_control_description = this.addControlDescription.value;
      }

      if (this.addNotes && this.addNotes.value) {
        form.add_notes = this.addNotes.value;
      }

      if (this.addTestingNotes && this.addTestingNotes.value) {
        form.add_testing_notes = this.addTestingNotes.value;
      }

      if (this.addPerformedText && this.addPerformedText.value) {
        form.add_performed_text = this.addPerformedText.value;
      }

      if (this.addAttachments && this.addAttachments.value) {
        form.add_attachments = this.addAttachments.value;
      }

      // -------------------------
      // Control objective
      // -------------------------
      if (this.selectedControlObjective && this.selectedControlObjective.id) {
        form.control_objective_id = this.selectedControlObjective.id;
      }

      // -------------------------
      // Response options (MAIN)
      // -------------------------
      if (this.responseType && this.responseType.value === 'Yes/No') {
        form.response_type_options = JSON.stringify([
          { title: 'Yes', value: this.yesValue },
          { title: 'No', value: this.noValue },
        ]);
      }

      if (this.responseType && this.responseType.value === 'Dropdown') {
        form.response_type_options = this.selectedOptions && this.selectedOptions.length
          ? JSON.stringify(this.selectedOptions)
          : '[]';
      }

      // -------------------------
      // Response options (DOC)
      // -------------------------
      if (this.responseTypeDoc && this.responseTypeDoc.value === 'Yes/No') {
        form.response_type_options_doc = JSON.stringify([
          { title: 'Yes', value: this.yesValueDoc },
          { title: 'No', value: this.noValueDoc },
        ]);
      }

      if (this.responseTypeDoc && this.responseTypeDoc.value === 'Dropdown') {
        form.response_type_options_doc = this.selectedOptionsDoc && this.selectedOptionsDoc.length
          ? JSON.stringify(this.selectedOptionsDoc)
          : '[]';
      }

      // -------------------------
      // Framework controls
      // -------------------------
      if (this.selectedFrameworkControls && this.selectedFrameworkControls.length) {
        form.framework_controls = this.selectedFrameworkControls.map(fc => fc.id);
      }

      // -------------------------
      // Linked controls
      // -------------------------
      form.linked_controls = [];
      if (this.selectedLinkedControls && this.selectedLinkedControls.length) {
        form.linked_controls = this.selectedLinkedControls.map(lc => lc.id);
      }

      // -------------------------
      // Dependency
      // -------------------------
      if (this.selectedTaskDependency && this.selectedTaskDependency.id) {
        form.dependency_question_id = this.selectedTaskDependency.id;
        form.dependency_question_answer = this.selectedAnswers.map(a => a.title);
      } else {
        form.dependency_question_id = '';
      }

      // -------------------------
      // Validation
      // -------------------------
      if (
        (
          (this.responseType && this.responseType.value) ||
          (this.addResponse && this.addResponse.value === 'No')
        ) &&
        this.form.description.length &&
        this.addDescription && this.addDescription.value &&
        this.addResponse && this.addResponse.value &&
        this.addControlDescription && this.addControlDescription.value &&
        this.addNotes && this.addNotes.value &&
        this.addPerformedText && this.addPerformedText.value &&
        this.addAttachments && this.addAttachments.value &&
        (
          (this.addResponse && this.addResponse.value === 'No') ||
          (this.responseType && ['Datepicker', 'Yes/No'].includes(this.responseType.value)) ||
          (this.responseType && this.responseType.value === 'Dropdown' && this.selectedOptions && this.selectedOptions.length) ||
          (this.responseTypeDoc && ['Datepicker', 'Yes/No'].includes(this.responseTypeDoc.value)) ||
          (this.responseTypeDoc && this.responseTypeDoc.value === 'Dropdown' && this.selectedOptionsDoc && this.selectedOptionsDoc.length)
        )
      ) {
        // -------------------------
        // Submit
        // -------------------------
        piincHttp.put('tasks/' + this.selectedTask.id, form).then(
          function (response) {
            self.$toastr('success', self.$t('maintenance.questions.update.success'));
            self.$emit('reloadContent');

            self.selectedTask = response.data;
            self.allAnswers = self.selectedTask.response_type_options
              ? JSON.parse(self.selectedTask.response_type_options)
              : [];
            self.allAnswersDoc = self.selectedTask.response_type_options_doc
              ? JSON.parse(self.selectedTask.response_type_options_doc)
              : [];

            self.hideEditQModal();
            self.buttonDisabled = false;
          },
          function (error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          }
        );
      } else {
        // -------------------------
        // Errors
        // -------------------------
        this.error = '';
        self.buttonDisabled = false;

        if (!this.responseType || !this.responseType.value) {
          this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message');
        }
        if (!this.addDescription || !this.addDescription.value) {
          this.error += this.$t('maintenance.questions.create.add_description_error_message');
        }
        if (!this.addResponse || !this.addResponse.value) {
          this.error += this.$t('maintenance.questions.create.add_response_error_message');
        }
        if (!this.addAttachments || !this.addAttachments.value) {
          this.error += this.$t('maintenance.questions.create.add_attachments_error_message');
        }
        if ((this.responseType && this.responseType.value === 'Select') && this.selectedOptions && !this.selectedOptions.length) {
          this.error += this.$t('maintenance.questions.create.selected_options_error_message');
        }
      }
    },
    createTestFormSubmit(evt) {
      let self = this;
      evt.preventDefault();
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("name", self.testForm.name);
      formData.append("description", self.testForm.description);
      formData.append("status", 'pending');
      formData.append("allow_description", self.testForm.allow_description.value);
      formData.append("allow_attachment", self.testForm.allow_attachment.value);

      piincHttp.post('tasks/' + self.selectedTask.id + '/tests', formData).then(function () {
        self.loadTests();
      }, function () {
      })
    },
    updateTestFormSubmit(evt) {
      let self = this;
      evt.preventDefault();
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("name", self.testForm.name);
      formData.append("description", self.testForm.description);

      formData.append("allow_description", self.testForm.allow_description.value);
      formData.append("allow_attachment", self.testForm.allow_attachment.value);
      formData.append("_method", 'put');

      piincHttp.post('tasks/' + self.selectedTask.id + '/tests/' + this.selectedTest.id, formData).then(function () {
        self.loadTests();
        self.$refs['update-test'].hide();
      }, function () {
      })
    },
    saveWithoutComplete(evt) {
      evt.preventDefault();
      this.updateSmallTestFormSubmit(false); // Pass flag if needed
    },
    completeSubmission(evt) {
      evt.preventDefault();
      this.updateSmallTestFormSubmit(true); // Pass flag if needed
    },
    updateSmallTestFormSubmit(isComplete) {
      let self = this;

      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("_method", 'put');

      if (isComplete) {
        formData.append("status", 'documentation_collection_completed');
      } else {
        if (self.testForm.status && self.testForm.status.value) {
          formData.append("status", self.testForm.status.value);
        } else {
          formData.append("status", 'pending');
        }
      }

      if (self.testForm.comment) {
        formData.append("comment", self.testForm.comment);
      }

      if (self.testForm.description_data) {
        formData.append("description_data", self.testForm.description_data);
      }


      piincHttp.post('tasks/' + self.selectedTask.id + '/tests/' + this.selectedTest.id, formData).then(function () {
        self.loadTests();
        self.$refs['show-test'].hide();
      }, function () {
      })
    },
    confirmDeleteTest(object) {
      let self = this;
      piincHttp.delete('tasks/' + self.selectedTask.id + '/tests/' + object.id).then(function (response) {
        self.hideTestConfirmDeleteModal();
        self.loadTests();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('projects.delete.success'))
      }, function () { });
    },
    showAddFrameworkControlModal() {
      this.assessmentControlOpen = true;
      this.selectedFramework = [];
      this.error = '';
      this.selectedFrameworkControl = [];
      this.loadFrameworkItems();
      this.$refs['add-framework-control'].show();
    },
    showTestCreateModal() {
      this.selectedTest = [];
      this.testForm.name = '';
      this.testForm.description = '';
      this.allow_description = [];
      this.allow_attachment = [];
      this.$refs['create-test'].show();
    },
    showEditTestModal(test) {
      this.selectedTest = test;
      this.testForm.name = test.name;
      this.testForm.description = test.description;

      this.allow_description = [];
      if (test.allow_description) {
        this.testForm.allow_description = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_description;
        });
      }
      this.allow_attachment = [];
      if (test.allow_attachment) {
        this.testForm.allow_attachment = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_attachment;
        });
      }
      this.$refs['update-test'].show();
    },
    openTestModal(test, type) {
      this.selectedTest = test;
      this.testForm.name = test.name;
      this.testForm.status = test.status;
      this.testForm.description = test.description;
      this.testForm.description_data = test.description_data;
      if (!this.testForm.description_data || !this.testForm.description_data.length) {

        if (this.currentView == 'data_collection' && (test.status == 'passed' || test.status == 'failed')) {
          this.editModeControlDescriptionDocumentationCollection = false;
        } else {
          this.editModeControlDescriptionDocumentationCollection = true;
        }

      } else {
        this.editModeControlDescriptionDocumentationCollection = false;
      }



      this.testForm.comment = test.comment;
      this.testForm.type = type;
      this.status = [];
      if (test.status) {
        this.testForm.status = _.find(this.testStatus, function (item) {
          return item.value === test.status;
        });
      }
      this.allow_description = [];
      if (test.allow_description) {
        this.testForm.allow_description = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_description;
        });
      }
      this.allow_attachment = [];
      if (test.allow_attachment) {
        this.testForm.allow_attachment = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_attachment;
        });
      }

      this.$refs['show-test'].show();
    },
    hideAddFrameworkControlModal() {
      this.assessmentControlOpen = false;
      this.error = '';
      this.selectedFramework = [];
      this.selectedFrameworkControl = [];
      this.$refs['add-framework-control'].hide();
    },
    handleFrameworkChange(item) {
      this.selectedFramework = item;
      this.loadFrameworkControlItems();
    },
    loadFrameworkItems(query) {
      let self = this;
      piincHttp.get('frameworks', {
        params:
        {
          client: this.getClient.slug,
          per_page: 100,
          keyword: query ? query : undefined
        }
      }).then(function (response) {
        self.frameworkItems = response.data.items;
        if (self.frameworkItems && !self.frameworkItems.length && !query) {
          self.frameworkItems.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () {
      });
    },
    loadFrameworkControlItems(query) {
      let self = this;
      piincHttp.get('framework-controls', {
        params:
        {
          client: this.getClient.slug,
          per_page: 100,
          framework: this.selectedFramework.id,
          keyword: query ? query : undefined
        }
      }).then(function (response) {
        self.frameworkControlItems = response.data.items;
        if (self.frameworkControlItems && !self.frameworkControlItems.length && !query) {
          self.frameworkControlItems.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () {
      });
    },
    frameworkControlFormSubmit(evt) {
      let self = this
      evt.preventDefault();

      let addToArray = false;

      if (self.selectedFrameworkControl && self.selectedFrameworkControl.id) {
        if (this.selectedFrameworkControls.length) {
          _.forEach(this.selectedFrameworkControls, function (item, index) {
            if (item.id != self.selectedFrameworkControl.id) {
              addToArray = true;
            }
          })
        } else {
          addToArray = true;
        }

        if (addToArray) {
          this.selectedFrameworkControls.push(this.selectedFrameworkControl);
        }

        this.hideAddFrameworkControlModal();
      } else {
        this.error = this.$t('maintenance.questions.create.framework_control_error');
      }

    },
    showCreateControlObjectiveModal() {
      this.coForm.name = '';
      this.coForm.description = '';
      this.error = '';
      this.$refs['add-control-objective'].show();
    },
    hideCreateControlObjectiveModal() {
      this.coForm.name = '';
      this.coForm.description = '';
      this.error = '';
      this.loadCO();
      this.$refs['add-control-objective'].hide();
    },
    coFormSubmit(evt) {
      this.buttonDisabled = true;
      // let formData = new FormData();

      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      this.coForm.client = this.getClient.slug;
      this.coForm.project_id = this.selectedTask.project.id;

      piincHttp.post('/project-control-objectives', this.coForm).then(function (response) {
        self.hideCreateControlObjectiveModal();
        self.selectedControlObjective = response.data

        self.$emit('reloadContent');
        self.buttonDisabled = false;

        self.$toastr('success', self.$t('maintenance.control_objective.create.success'))
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    loadCO() {
      let self = this;
      piincHttp.get('/assessment-control-objectives', {
        params:
        {
          client: this.getClient.slug,
          assessment: this.selectedTask.project.assessment.id,
          per_page: 100,
          // keyword: query ? query : undefined
        }
      }).then(function (response) {
        self.controlObjectives = response.data.items;

        if (self.controlObjectives && !self.controlObjectives.length && !query) {
          self.controlObjectives.push({ name: self.$t('system.no_results'), $isDisabled: true });
        }
      }, function () {
      });
    },
    lockSwitch(lockStatus) {
      let self = this;
      if (lockStatus) {
        this.data_collection_on = 0;
      } else {
        this.data_collection_on = 1;
      }
    },
    handleOption(evt) {
      evt.preventDefault();
      // If there's a link in input, add it to links array
      if (this.inputOption !== '') {
        this.selectedOptions.push({ title: this.inputOption, value: this.answerTypes[0].items[0] })
        // Reset link input form
        this.inputOption = ''
      }
      this.showOptionInput = false;
    },
    getMedia(type) {
      let media = [];
      if (type == 'task') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents';
        });
      }

      if (type == 'data_documents') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'data_documents';
        });
      }

      if (type == 'task_and_data_collection') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'data_documents';
        });
      }

      if (type == 'question') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'question';
        });
      }

      if (type == 'data_collection') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'data_collection';
        });
      }
      return media;
    },
    getTestMedia(type) {
      let media = [];

      if (this.selectedTest.media && type == 'documents') {
        media = _.filter(this.selectedTest.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents';
        });
      }
      return media;
    },
    getDifference(endDate) {
      var moment = require('moment');
      let currentDate = moment();
      endDate = moment(endDate);
      let difference = endDate.diff(currentDate, 'days');
      return difference;
    },
    openGuide() {
      if (this.wpGuide && this.wpGuide.link) {
        window.open(this.wpGuide.link, '_blank');
      }
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function (object) {
        return object.scope == code && object.type == 'Task' && object.enabled;
      });
      return existingGuide;
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuide = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    loadGuidesData(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuideData = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    loadGuidesSystem(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuideSystem = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    getLinks(type) {
      let links = [];
      if (type == 'task') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'task';
        });
      }

      if (type == 'question') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'question' || link.collection == null;
        });
      }

      if (type == 'data_documents') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_documents';
        });
      }

      if (type == 'task_and_data_collection') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_documents' || link.collection == 'task';
        });
      }

      if (type == 'data_collection') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_collection';
        });
      }
      return links;
    },
    getReducedUsers(users) {
      let reducedUsers = [];
      if (users) {
        if (users.length > 3) {
          reducedUsers = _.cloneDeep(users);
          reducedUsers = reducedUsers.slice(0, 3);
        } else {
          reducedUsers = users;
        }
      }
      return reducedUsers;
    },
    getIcon(object) {
      let foundObject = {};
      let responseOptions = JSON.parse(object.response_type_options);
      foundObject = _.find(responseOptions, function (item) {
        return item.title === object.response;
      });

      if (foundObject) {
        return foundObject.value.value;
      } else {
        return '';
      }

    },
    getIconDoc(object) {
      let foundObject = {};
      let responseOptions = JSON.parse(object.response_type_options_doc);
      foundObject = _.find(responseOptions, function (item) {
        return item.title === object.response_doc;
      });

      if (foundObject) {
        return foundObject.value.value;
      } else {
        return '';
      }

    },
    showCreateLinkModal(object) {
      let self = this;
      this.error = '';
      this.buttonDisabled = false;

      this.$refs['add-link'].show();
    },
    hideCreateLinkModal() {
      this.$refs['add-link'].hide();
    },
    reloadUserList() {
      this.loadUsers();
    },
    loadUsers(query) {
      let self = this;

      this.buttonDisabled = true;

      piincHttp.get('users', {
        params:
        {
          client: this.getClient.id,
          keyword: query ? query : undefined,
          per_page: 100
        }
      }).then(function (response) {
        self.userList = response.data.items;
        self.buttonDisabled = false;
      }, function () {
      });
    },
    showReopenDataCollectionModal(object) {
      let self = this;
      this.comment = '';
      this.reopenError = '';

      this.selectedAssignUsers = [];

      this.loadUsers();

      _.forEach(self.selectedTask.data_users, function (user) {
        self.selectedAssignUsers.push(user);
      })

      this.$refs['reopen-task'].show();
    },
    hideReopenDataCollectionModal() {
      this.selectedAssignUsers = [];
      this.$refs['reopen-task'].hide();
    },
    loadComments(taskId) {
      let self = this;
      let taskActiveId = '';
      if (taskId) {
        taskActiveId = taskId;
      } else {
        taskActiveId = self.task.id;
      }
      this.previousComments = []
      piincHttp.get('tasks/' + taskActiveId + '/comments', {
        params:
        {
          client: this.getClient.id,
          per_page: 100,
          sort: 'created_at',
          order: 'desc'
        }
      }).then(function (response) {
        self.previousComments = []

        _.forEach(response.data.items, function (item) {
          item.expanded = false;
          self.previousComments.push(item);
        })

      }, function () {
      });
    },
    openUsersModal(object) {
      this.selectedItem = object;
      this.showUsersModal = true;
    },
    closeUsersModal() {
      this.selectedItem = {};
      this.showUsersModal = false;
    },
    switchCurrentView(type) {
      this.showLinksSection = false;
      this.showDataCollectionLinksSection = false;
      this.loadComments();
      this.currentView = type;
      if (type == 'default') {
        this.loadGuides('assessment_task');
      } else {
        this.loadGuidesData('data_collection_task');
      }
    },
    showTaskModal(object) {
      let self = this;


      this.error = '';
      this.showLinksSection = false;
      this.showDataCollectionLinksSection = false;

      this.tests = [];
      this.sTableItems = [];

      this.loadTaskById(object.id);

      if (object == null && this.tasks && this.tasks.length) {
        self.selectedTask = this.tasks[0];
      }

      // Checking the type of the users so the right view is displayed
      if (this.isOwner(self.selectedTask.project)) {
        // if the user is owner on the project od admin
        this.currentView = 'default';
      } else {
        // Checking the type of the users so the right view is displayed
        if (self.isOwner(self.selectedTask)) {
          self.switchCurrentView('default');
          if (self.selectedTask.code == 'update_measures') {
            self.loadGuidesSystem('system_description_task');
          } else {
            self.loadGuides('assessment_task');
          }
        } else {
          if (self.isDataOwner(self.selectedTask)) {
            self.switchCurrentView('data_collection');
            self.loadGuidesData('data_collection_task');
          }
        }
      }


      this.loadComments(object.id);


      this.$refs['task-modal'].show();
      this.loadTaskGuide();

    },
    loadLinkedControls() {
      let self = this;

      this.buttonDisabled = false;

      piincHttp.get('projects/' + this.selectedTask.project.slug + '/tasks/linked', {
        params:
        {
          task_id: this.selectedTask.id,
          per_page: 100
        }
      }).then(function (response) {
        self.linkedControls = response.data;

        // Create an array to store all media files
        self.allLinkedMediaFiles = [];
        self.allLinkedDataMediaFiles = [];

        let existingLinkedMediaIds = self.selectedTask.linked_media.map(media => media.id);

        self.linkedControls.forEach(task => {
          if (task.media && task.media.length > 0) {
            // Filter media files by collection names and store them in respective arrays
            task.media.forEach(file => {
              if (!existingLinkedMediaIds.includes(file.id)) { // Check if media doesn't already exist in linked_media
                if (file.collection_name === 'data_documents') {
                  self.allLinkedDataMediaFiles.push(file);
                  self.allLinkedMediaFiles.push(file);
                } else if (file.collection_name === 'documents') {
                  self.allLinkedMediaFiles.push(file);
                }
              }
            });
          }
        });

        self.buttonDisabled = false;
      }, function () {
      });
    },
    hideTaskModal() {
      let self = this;
      this.error = '';

      this.editModeResponse = false;
      this.editModeResponseDoc = false;
      this.editModeResponseDocMain = false;
      this.editModeNotes = false;
      this.editModeControlDescription = false;
      this.editModePerformedTest = false;
      this.editModeTestingNotes = false;
      this.editModeConclusion = false;
      this.editModeControlDescriptionDocumentationCollection = false;

      this.taskForm.response = '';
      this.taskForm.notes = '';
      this.taskForm.control_description = '';
      this.taskForm.performed_text = '';
      this.taskForm.testing_notes = '';
      this.taskForm.remarks = '';
      this.taskForm.data_remarks = '';
      this.taskForm.rto = '';
      this.taskForm.rpo = '';
      this.selectedAnswer = [];
      this.selectedDate = '';
      this.selectedAnswerDoc = [];
      this.selectedDateDoc = '';
      this.selectedDataCollectionAnswer = [];

      setTimeout(function () {
        self.selectedTask = {};
      }, 500);

      if (this.taskCompleted) {
        self.$store.commit('storeReloadTasks');
      }

      this.$refs['task-modal'].hide();
    },
    navigateToProject(task) {
      this.$store.commit('storeTaskToolbarState', true);
      this.$store.commit('storeActiveTask', task);
      this.$router.push({ name: 'projects.view', params: { slug: task.project.slug } });
    },
    populateForm() {
      let self = this;


      self.taskForm.remarks = self.selectedTask.remarks;
      self.taskForm.notes = self.selectedTask.notes;
      self.taskForm.control_description = self.selectedTask.control_description;
      self.taskForm.performed_text = self.selectedTask.performed_text;
      self.taskForm.data_remarks = self.selectedTask.data_remarks;
      self.taskForm.testing_notes = self.selectedTask.testing_notes;
      if (self.selectedTask && self.selectedTask.response_type_options) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options);
      } else {
        self.allAnswers = []
      }

      if (self.selectedTask && self.selectedTask.response_type_options_doc) {
        self.allAnswersDoc = JSON.parse(self.selectedTask.response_type_options_doc);
      } else {
        self.allAnswersDoc = []
      }


      self.selectedAnswer = [];
      if (self.selectedTask.response) {
        if (self.selectedTask.response_type != 'Datepicker') {
          self.selectedAnswer = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response) {
              return self.selectedTask.response;
            }
          });
        } else {
          self.selectedDate = self.selectedTask.response;
        }
      }

      self.selectedAnswerDoc = [];
      if (self.selectedTask.response_doc) {
        if (self.selectedTask.response_type_doc != 'Datepicker') {
          self.selectedAnswerDoc = _.find(self.allAnswersDoc, function (item) {
            if (item.title === self.selectedTask.response_doc) {
              return self.selectedTask.response_doc;
            }
          });
        } else {
          self.selectedDateDoc = self.selectedTask.response_doc;
        }
      }

      self.selectedDataCollectionAnswer = [];
      if (self.selectedTask.data_response) {
        self.selectedDataCollectionAnswer = _.find(self.allAnswers, function (item) {
          if (item === self.selectedTask.data_response) {
            return self.selectedTask.data_response;
          }
        });
      }

      if (!self.selectedAnswer.title && !self.selectedDate.length) {
        self.editModeResponse = true;
      }
      if (!self.selectedAnswerDoc.title && !self.selectedDateDoc.length) {
        self.editModeResponseDoc = true;
      }
      if (!self.selectedAnswerDoc.title && !self.selectedDateDoc.length) {
        self.editModeResponseDocMain = false;
      }
      if (!self.taskForm.notes || !self.taskForm.notes.length) {
        self.editModeNotes = true;
      }
      if (!self.taskForm.control_description || !self.taskForm.control_description.length) {
        self.editModeControlDescription = true;
      }
      if (!self.taskForm.performed_text || !self.taskForm.performed_text.length) {
        self.editModePerformedTest = true;
      }
      if (!self.taskForm.testing_notes || !self.taskForm.testing_notes.length) {
        self.editModeTestingNotes = true;
      }
      if (!self.taskForm.remarks || !self.taskForm.remarks.length) {
        self.editModeConclusion = true;
      }
      if (!self.taskForm.data_remarks || !self.taskForm.data_remarks.length) {
        self.editModeControlDescriptionDocumentationCollection = true;
      }

      this.selectedConfidentialityImpact = [];
      if (self.selectedTask.confidentiality) {
        self.selectedConfidentialityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.confidentiality) {
            return item;
          }
        });
      }

      this.selectedIntegrityImpact = [];
      if (self.selectedTask.integrity) {
        self.selectedIntegrityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.integrity) {
            return item;
          }
        });
      }

      this.selectedAvailabilityImpact = []
      if (self.selectedTask.availability) {
        self.selectedAvailabilityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.availability) {
            return item;
          }
        });
      }

      this.rtoInterval = []
      if (self.selectedTask.rto_type) {
        self.rtoInterval = _.find(self.intervalOptions, function (item) {
          if (item.value === self.selectedTask.rto_type) {
            return item;
          }
        });
      }

      this.rpoInterval = []
      if (self.selectedTask.rpo_type) {
        self.rpoInterval = _.find(self.intervalOptions, function (item) {
          if (item.value === self.selectedTask.rpo_type) {
            return item;
          }
        });
      }

      this.taskForm.rto = this.selectedTask.rto_number;
      this.taskForm.rpo = this.selectedTask.rpo_number;

    },
    showViewGuideModal(object) {
      this.selectedGuide = object;
      this.viewGuideModal = true;
    },
    closeViewGuideModal() {
      this.selectedGuide = '';
      this.viewGuideModal = false;
    },
    openWelcomePage() {
      this.showViewGuideModal(this.welcomeGuide);
    },
    showDropActiveFunction(value) {
      this.showDropActive = value;
    },
    loadTaskGuide() {
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
      let self = this;
      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: 'assessment_task',
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.welcomeGuide = response.data.items[0];
        }
      }, function () {
      });
    },
    navigateToTask(object) {
      if (this.isOwner(object.model)) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        if (object.model_type == 'App\\Activity\\Models\\Activity') {
          this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\Process\\Models\\Process') {
          this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\System\\Models\\System') {
          this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id } });
        }
      }
    },
    isOwner(object) {
      if (!object || !object.users) {

        return false;
      }
      let self = this;
      let allow = false;
      let existingUser = _.find(object.users, function (user) {
        return user.id == self.getUser.id;
      });


      if (existingUser) {
        allow = true;
      } else {
        if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    isDataOwner(object) {
      let self = this;
      let allow = false;
      let existingUser = _.find(object.data_users, function (user) {
        return user.id == self.getUser.id;
      });

      if (existingUser) {
        allow = true;
      } else {
        if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    isCommentOwner(object) {
      let self = this;
      let allow = false;
      let existingUser = object.user.id == this.getUser.id;

      if (existingUser) {
        allow = true;
      } else {
        if (this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    minimizeTask() {
      this.saveTask();
      var element = document.getElementsByClassName('modal');
      element[0].classList.add("bottom-left");
      // this.submitForm = true
      this.$store.commit('storeActiveTask', this.selectedTask);
      this.$store.commit('storeTaskToolbarState', true);
    },
    addCommentSubmit() {
      let self = this;
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("comment", self.comment);

      piincHttp.post('tasks/' + self.selectedTask.id + '/comments', formData).then(function () {
        self.loadTaskById(self.selectedTask.id, true);
        self.loadComments();
        self.showInput = false
        self.comment = '';
      }, function () {
      })
    },
    changeUsersSubmit() {
      let self = this;
      let userIds = [];

      if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
        for (var i = 0; i < this.selectedAssignUsers.length; i++) {
          userIds.push(this.selectedAssignUsers[i].id);
        }
      }

      if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
        piincHttp.put('tasks/' + self.selectedTask.id, {
          data_users: userIds
        }).then(function (response) {
          self.buttonDisabled = false;
          self.loadTaskById(self.selectedTask.id, true);
          self.hideReopenDataCollectionModal();
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.reopenError = '';
        self.buttonDisabled = false;
        if (this.selectedAssignUsers && !this.selectedAssignUsers.length) {
          this.reopenError += ' ' + this.$t('tasks.modal.recipient_error_message');
        }
      }
    },
    reopenFormSubmit() {
      this.buttonDisabled = true;
      let self = this;

      piincHttp.put('tasks/' + self.selectedTask.id, {
        data_status: 'pending',
      }).then(function (response) {
        self.buttonDisabled = false;
        self.loadTaskById(self.selectedTask.id, true);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })

    },
    completeTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      var moment = require('moment');
      let responseAnswer = '';
      let responseAnswerDoc = '';

      if (
        // -------------------------
        // Attachments
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_attachments === 'Mandatory' &&
            (
              (this.selectedTask.media && this.selectedTask.media.length) ||
              (this.selectedTask.links && this.selectedTask.links.length)
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_attachments !== 'Mandatory')
        ) &&

        // -------------------------
        // Description
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_description === 'Mandatory' &&
            this.taskForm.remarks
          ) ||
          (this.selectedTask && this.selectedTask.add_description !== 'Mandatory')
        ) &&

        // -------------------------
        // Control description
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_control_description === 'Mandatory' &&
            this.taskForm.control_description
          ) ||
          (this.selectedTask && this.selectedTask.add_control_description !== 'Mandatory')
        ) &&

        // -------------------------
        // Notes
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_notes === 'Mandatory' &&
            this.taskForm.notes
          ) ||
          (this.selectedTask && this.selectedTask.add_notes !== 'Mandatory')
        ) &&

        // -------------------------
        // Performed text
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_performed_text === 'Mandatory' &&
            this.taskForm.performed_text
          ) ||
          (this.selectedTask && this.selectedTask.add_performed_text !== 'Mandatory')
        ) &&

        // -------------------------
        // MAIN response
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_response === 'Mandatory' &&
            (
              (this.selectedTask.response_type !== 'Datepicker' &&
                this.selectedAnswer &&
                this.selectedAnswer.title
              ) ||
              (this.selectedTask.response_type === 'Datepicker' &&
                this.selectedDate &&
                this.selectedDate !== ''
              )
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_response !== 'Mandatory')
        ) &&

        // -------------------------
        // DOC response (NEW)
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_response_doc === 'Auditor' &&
            (
              (this.selectedTask.response_type_doc !== 'Datepicker' &&
                this.selectedAnswerDoc &&
                this.selectedAnswerDoc.title
              ) ||
              (this.selectedTask.response_type_doc === 'Datepicker' &&
                this.selectedDateDoc &&
                this.selectedDateDoc !== ''
              )
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_response_doc !== 'Auditor')
        )
      ) {

        // -------------------------
        // Build MAIN response
        // -------------------------
        if (this.selectedTask.response_type !== 'Datepicker') {
          responseAnswer = this.selectedAnswer && this.selectedAnswer.title
            ? this.selectedAnswer.title
            : undefined;
        } else {
          responseAnswer = this.selectedDate
            ? moment(this.selectedDate).format('YYYY-MM-DD')
            : undefined;
        }

        // -------------------------
        // Build DOC response
        // -------------------------
        if (this.selectedTask.response_type_doc !== 'Datepicker') {
          responseAnswerDoc = this.selectedAnswerDoc && this.selectedAnswerDoc.title
            ? this.selectedAnswerDoc.title
            : undefined;
        } else {
          responseAnswerDoc = this.selectedDateDoc
            ? moment(this.selectedDateDoc).format('YYYY-MM-DD')
            : undefined;
        }

        let selectedMediaIds = this.selectedLinkedMedia.map(function (media) {
          return media.id;
        });

        let selectedDataMediaIds = this.selectedLinkedDataMedia.map(function (media) {
          return media.id;
        });

        // -------------------------
        // Submit
        // -------------------------
        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          control_description: this.taskForm.control_description,
          notes: this.taskForm.notes,
          testing_notes: this.taskForm.testing_notes,
          performed_text: this.taskForm.performed_text,
          response: responseAnswer,
          response_doc: responseAnswerDoc,
          status: 'completed',
          linked_media: selectedMediaIds,
          linked_data_media: selectedDataMediaIds
        }).then(function () {
          self.buttonDisabled = false;

          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id === self.selectedTask.id;
            });

            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }

            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.taskCompleted = true;
            self.$store.commit('storeTaskToolbarState', false);
            self.$emit('reloadContent');
            self.hideTaskModal();
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        });

      } else {
        // -------------------------
        // Errors
        // -------------------------
        this.error = '';
        self.buttonDisabled = false;

        if (this.selectedTask.add_control_description === 'Mandatory' && !this.taskForm.control_description) {
          this.error += ' ' + this.$t('tasks.modal.control_description_error_message');
        }

        if (this.selectedTask.add_notes === 'Mandatory' && !this.taskForm.notes) {
          this.error += ' ' + this.$t('tasks.modal.notes_error_message');
        }

        if (this.selectedTask.add_performed_text === 'Mandatory' && !this.taskForm.performed_text) {
          this.error += ' ' + this.$t('tasks.modal.performed_test_error_message');
        }

        if (
          this.selectedTask.add_response === 'Mandatory' &&
          (
            !this.selectedAnswer ||
            !this.selectedAnswer.title
          )
        ) {
          this.error += ' ' + this.$t('tasks.modal.response_error_message');
        }

        // 🔴 DOC response error (NEW)
        if (
          this.selectedTask.add_response_doc === 'Auditor' &&
          (
            (this.selectedTask.response_type_doc !== 'Datepicker' &&
              (!this.selectedAnswerDoc || !this.selectedAnswerDoc.title)
            ) ||
            (this.selectedTask.response_type_doc === 'Datepicker' &&
              (!this.selectedDateDoc || this.selectedDateDoc === '')
            )
          )
        ) {
          this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message');
        }

        if (this.selectedTask.add_description === 'Mandatory' && !this.taskForm.remarks) {
          this.error += ' ' + this.$t('tasks.modal.conclusion_error_message');
        }

        if (
          this.selectedTask.add_attachments === 'Mandatory' &&
          (!this.selectedTask.media || !this.selectedTask.media.length) &&
          (!this.selectedTask.links || !this.selectedTask.links.length)
        ) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }
      }
    },
    reOpenTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'pending'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    completeDataTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      if (
        ((this.selectedTask && this.selectedTask.data_collection_add_attachments == 'Mandatory' && ((this.getMedia('data_documents') && this.getMedia('data_documents').length) || (this.getLinks('data_documents') && this.getLinks('data_documents').length))) ||
          (this.selectedTask && this.selectedTask.data_collection_add_attachments != 'Mandatory')) &&
        ((this.selectedTask && this.selectedTask.data_collection_add_description == 'Mandatory' && this.taskForm.data_remarks) ||
          (this.selectedTask && this.selectedTask.data_collection_add_description != 'Mandatory'))
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_remarks: this.taskForm.data_remarks,
          data_status: 'completed'
        }).then(function (response) {
          self.buttonDisabled = false;
          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            });
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.$store.commit('storeTaskToolbarState', false);
            if (self.isOwner(self.selectedTask)) {
              self.currentView = 'default';
              self.loadTaskById(self.selectedTask.id);
            } else {
              self.hideTaskModal();
            }
            self.$emit('reloadContent');
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (this.selectedTask.data_collection_add_description == 'Mandatory' && !this.taskForm.data_remarks) {
          this.error += ' ' + this.$t('tasks.modal.comment_error_message');
        }
        if ((this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getMedia('data_documents') && !this.getMedia('data_documents').length) && (this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getLinks('data_documents') && !this.getLinks('data_documents').length)) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }

      }
    },
    saveDataTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      if (
        ((this.selectedTask && this.selectedTask.data_collection_add_attachments == 'Mandatory' && ((this.getMedia('data_documents') && this.getMedia('data_documents').length) || (this.getLinks('data_documents') && this.getLinks('data_documents').length))) ||
          (this.selectedTask && this.selectedTask.data_collection_add_attachments != 'Mandatory')) &&
        ((this.selectedTask && this.selectedTask.data_collection_add_description == 'Mandatory' && this.taskForm.data_remarks) ||
          (this.selectedTask && this.selectedTask.data_collection_add_description != 'Mandatory'))
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_remarks: this.taskForm.data_remarks
        }).then(function (response) {
          self.buttonDisabled = false;
          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            });
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.$store.commit('storeTaskToolbarState', false);
            if (self.isOwner(self.selectedTask)) {
              self.currentView = 'default';
              self.loadTaskById(self.selectedTask.id);
            } else {
              self.hideTaskModal();
            }
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (this.selectedTask.data_collection_add_description == 'Mandatory' && !this.taskForm.data_remarks) {
          this.error += ' ' + this.$t('tasks.modal.comment_error_message');
        }
        if ((this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getMedia('data_documents') && !this.getMedia('data_documents').length) && (this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getLinks('data_documents') && !this.getLinks('data_documents').length)) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }

      }
    },
    reOpenDataTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        data_status: 'pending'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    completeSystemRiskTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      this.error = '';

      if (
        this.taskForm.remarks != '' &&
        this.selectedConfidentialityImpact && this.selectedConfidentialityImpact.value &&
        this.selectedIntegrityImpact && this.selectedIntegrityImpact.value &&
        this.selectedAvailabilityImpact && this.selectedAvailabilityImpact.value &&
        this.taskForm.rto != '' &&
        this.taskForm.rpo != '' &&
        this.rtoInterval && this.rtoInterval.value &&
        this.rpoInterval && this.rpoInterval.value
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          status: 'completed'
        }).then(function (response) {
          self.$toastr('success', self.$t('tasks.modal.success'));
          self.buttonDisabled = false;

          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            })
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.$refs['task-modal'].hide();
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        this.error = this.$t('tasks.modal.all_fields_error_message');
      }
    },
    saveTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      let responseAnswer = '';
      let responseAnswerDoc = '';
      if (this.selectedTask.response_type != 'Datepicker') {
        responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : '';
      } else {
        responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : '';
      }

      if (this.selectedTask.response_type_doc != 'Datepicker') {
        responseAnswerDoc = this.selectedAnswerDoc && this.selectedAnswerDoc.title ? this.selectedAnswerDoc.title : '';
      } else {
        responseAnswerDoc = this.selectedDateDoc ? moment(this.selectedDateDoc).format('YYYY-MM-DD') : '';
      }

      let selectedMediaIds = this.selectedLinkedMedia.map(media => media.id);
      let selectedDataMediaIds = this.selectedLinkedDataMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        data_remarks: this.taskForm.data_remarks,
        remarks: this.taskForm.remarks,
        performed_text: this.taskForm.performed_text,
        control_description: this.taskForm.control_description,
        notes: this.taskForm.notes,
        testing_notes: this.taskForm.testing_notes,
        confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
        integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
        availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
        rto_number: this.taskForm.rto,
        rto_type: this.rtoInterval ? this.rtoInterval.value : '',
        rpo_number: this.taskForm.rpo,
        rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
        response: responseAnswer,
        response_doc: responseAnswerDoc,
        data_response: this.selectedDataCollectionAnswer && this.selectedDataCollectionAnswer.length ? this.selectedDataCollectionAnswer : '',
        linked_media: selectedMediaIds,
        linked_data_media: selectedDataMediaIds
      }).then(function (response) {
        self.buttonDisabled = false;
        self.$emit('reloadContent', response.data);
        self.hideTaskModal();
        self.$toastr('success', self.$t('tasks.modal.success'))
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })

    },
    updateLinkedMedia() {
      let self = this;
      let selectedMediaIds = this.selectedLinkedMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        linked_media: selectedMediaIds,
      }).then(function (response) {
        self.loadTaskById(self.selectedTask.id, true);
        self.$emit('reloadContent', response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    updateLinkedDataMedia() {
      let self = this;
      let selectedMediaIds = this.selectedLinkedDataMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        linked_data_media: selectedMediaIds,
      }).then(function (response) {
        self.loadTaskById(self.selectedTask.id, true);
        self.$emit('reloadContent', response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    updateControlDescription() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        control_description: this.taskForm.control_description,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeControlDescription = false
    },
    discardControlDescription() {

      this.taskForm.control_description = this.selectedTask.control_description
      this.editModeControlDescription = false
    },
    updateDataRemarks() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        data_remarks: this.taskForm.data_remarks,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeControlDescriptionDocumentationCollection = false
    },
    discardDataRemarks() {

      this.taskForm.data_remarks = this.selectedTask.data_remarks
      this.editModeControlDescriptionDocumentationCollection = false
    },
    updatePerformedTest() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        performed_text: this.taskForm.performed_text,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModePerformedTest = false
    },
    discardPerformedTest() {

      this.taskForm.performed_text = this.selectedTask.performed_text
      this.editModePerformedTest = false
    },
    updateTestingNotes() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        testing_notes: this.taskForm.testing_notes,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeTestingNotes = false
    },
    discardTestingNotes() {

      this.taskForm.testing_notes = this.selectedTask.testing_notes
      this.editModeTestingNotes = false
    },
    updateNotes() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        notes: this.taskForm.notes,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeNotes = false
    },
    discardNotes() {

      this.taskForm.notes = this.selectedTask.notes
      this.editModeNotes = false
    },
    updateResponse() {
      const self = this;
      var moment = require('moment');
      let responseAnswer = '';
      if (this.selectedTask.response_type != 'Datepicker') {
        responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : '';
      } else {
        responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : '';
      }

      piincHttp.put('tasks/' + this.selectedTask.id, {
        response: responseAnswer,
      }).then(function (response) {
        self.selectedTask = response.data;
        self.getIcon(response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeResponse = false
    },
    discardResponse() {
      const self = this;

      this.taskForm.response = this.selectedTask.response;

      if (self.selectedTask && self.selectedTask.response_type_options) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options);
      } else {
        self.allAnswers = []
      }

      self.selectedAnswer = [];
      if (self.selectedTask.response) {
        if (self.selectedTask.response_type != 'Datepicker') {
          self.selectedAnswer = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response) {
              return self.selectedTask.response;
            }
          });
        } else {
          self.selectedDate = self.selectedTask.response;
        }
      }

      this.editModeResponse = false;
    },
    updateResponseDoc() {
      const self = this;

      let responseAnswer = '';
      if (this.selectedTask.response_type_doc != 'Datepicker') {
        responseAnswer = this.selectedAnswerDoc && this.selectedAnswerDoc.title ? this.selectedAnswerDoc.title : '';
      } else {
        responseAnswer = this.selectedDateDoc ? moment(this.selectedDateDoc).format('YYYY-MM-DD') : '';
      }

      piincHttp.put('tasks/' + this.selectedTask.id, {
        response_doc: responseAnswer,
      }).then(function (response) {
        self.selectedTask = response.data;
        self.getIcon(response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeResponseDoc = false
      this.editModeResponseDocMain = false
    },
    discardResponseDoc() {
      const self = this;

      this.taskForm.response_doc = this.selectedTask.response_doc;

      if (self.selectedTask && self.selectedTask.response_type_options_doc) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options_doc);
      } else {
        self.allAnswers = []
      }

      self.selectedAnswerDoc = [];
      if (self.selectedTask.response_doc) {
        if (self.selectedTask.response_type_doc != 'Datepicker') {
          self.selectedAnswerDoc = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response_doc) {
              return self.selectedTask.response_doc;
            }
          });
        } else {
          self.selectedDateDoc = self.selectedTask.response_doc;
        }
      }

      this.editModeResponseDoc = false;
      this.editModeResponseDocMain = false;
    },
    updateConclusion() {
      const self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        remarks: this.taskForm.remarks,
      }).then(function (response) {
        self.selectedTask = response.data;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeConclusion = false
    },
    discardConclusion() {
      this.taskForm.remarks = this.selectedTask.remarks;
      this.editModeConclusion = false;
    },

    openDeleteAttachmentModal(object) {
      this.selectedFile = object;
      this.showDeleteAttachmentModal = true;
    },
    closeDeleteAttachmentModal() {
      this.selectedFile = {};
      this.showDeleteAttachmentModal = false;
      this.loadTaskById(this.selectedTask.id, true);
      if (this.selectedTest && this.selectedTest.id) {
        this.loadTest(this.selectedTest.id);
      }

    },
    openDeleteLinkedAttachmentModal(object) {
      this.selectedFile = object;
      this.showDeleteLinkedAttachmentModal = true;
    },
    closeDeleteLinkedAttachmentModal() {
      this.selectedFile = {};
      this.showDeleteLinkedAttachmentModal = false;
      this.loadTaskById(this.selectedTask.id, true);

    },
    openDeleteLinkModal(object) {
      this.selectedLink = object;
      this.showDeleteLinkModal = true;
    },
    closeDeleteLinkModal() {
      this.selectedLink = {};
      this.showDeleteLinkModal = false;
      this.loadTaskById(this.selectedTask.id, true);
    },
    openDeleteCommentModal(object) {
      this.selectedComment = object;
      this.showDeleteCommentModal = true;
    },
    closeDeleteCommentModal() {
      this.selectedComment = {};
      this.showDeleteCommentModal = false;
      this.loadComments();
    },
    handleLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink;
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("collection", "task");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      piincHttp.post('links', formData).then(function () {
        self.inputLink = '';
        self.inputLinkName = '';
        self.hideCreateLinkModal();
        self.loadTaskById(self.selectedTask.id, true);
        self.showInput = false;
      }, function () {
      })
    },
    handleDataCollectionLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink;
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      piincHttp.post('links', formData).then(function () {
        self.inputLink = '';
        self.inputLinkName = '';
        self.loadTaskById(self.selectedTask.id, true);
        self.showDataCollectionLinksSection = false;
      }, function () {
      })
    },
    downloadMedia(object) {
      piincHttp.get('documents/' + object.id + '/download', {
        responseType: 'blob',
        params: {
          task: this.selectedTask.id
        }
      }).then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }, function () {
      });
    },
    loadTaskById(id, ignorePopulate) {
      let self = this;
      piincHttp.get('tasks/' + id).then(function (response) {
        self.selectedTask = response.data;
        if (self.isOwner(self.selectedTask)) {
          self.loadObservations(self.selectedTask.id);
        }
        self.loadLinkedControls();
        self.loadTests();
        self.loadQaComments();
        self.project_progress = self.selectedTask.project.user_progress.progress;
        if (!ignorePopulate) {
          self.populateForm();
          // Checking the type of the users so the right view is displayed
          if (self.isOwner(self.selectedTask)) {
            self.switchCurrentView('default');
            if (self.selectedTask.code == 'update_measures') {
              self.loadGuidesSystem('system_description_task');
            } else {
              self.loadGuides('assessment_task');
            }
          } else {
            if (self.isDataOwner(self.selectedTask)) {
              self.switchCurrentView('data_collection');
            }
          }
        }
      }, function () {
      });
    },
    onFileChangeEdit(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.files[i].file);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.sizeError = this.$t('system.file_size_30');
        this.files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.sizeError = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }
    },
    onTestFileChange(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.test_files.length; i++) {
        // Equal to 10 MB
        if (this.test_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.test_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "documents");
      formData.append("model_type", this.selectedTest.who_am_i);
      formData.append("model_id", this.selectedTest.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.test_files = [];
      } else {
        piincHttp
          .post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(() => {
            this.error = '';
            this.loadTest(this.selectedTest.id);
            this.test_files = [];
          })
          .catch((error) => {
            this.error = error.data.message;
            if (error.data.errors['document.0']) {
              this.error += ' ' + error.data.errors['document.0'][0];
            }
          });
      }
    },
    onDataFileChange(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }
    },
    loadObservations(task_id) {
      let self = this;

      // If page is not defined, set page to default 1
      let pageNumber = 1;

      this.loadingObservations = true;

      piincHttp.get('projects/' + self.selectedTask.project.slug + '/observations', {
        params:
        {
          page: pageNumber,
          client: this.getClient.slug,
          task_id: task_id
        }
      }).then(function (response) {
        if (response.data && response.data.items) {
          self.sTableItems = response.data.items;
        }
        // Set number of total items
        self.totalRows = response.data.total_count;
        self.loadingObservations = false;
      }, function () {
      });
    },
    deleteObservation(observation) {
      let self = this;

      self.loadingObservations = true;

      piincHttp.delete(
        'projects/' + self.selectedTask.project.slug + '/observations/' + observation.id
      )
        .then(function () {
          // Refresh the list after deletion
          self.loadObservations(self.selectedTask.id);
          self.hideSConfirmDeleteModal();
        })
        .catch(function (error) {
          console.error('Error deleting observation:', error);
          self.loadingObservations = false;
        });
    },
    showEditModal(object) {
      let self = this;
      this.error = '';
      this.selectedS = object

      this.editForm.name = object.name
      this.editForm.description = object.description

      if (this.selectedTask.project.type != 'control_assessment') {
        this.selectedScope = []
        if (object.scope && object.scope.id) {
          this.selectedScope = _.find(this.scopeItems, function (item) {
            return item.id === object.scope.id;
          });
        }
      } else {

      }

      this.selectedImpact = []
      if (object.impact_assessment) {
        this.selectedImpact = _.find(this.impactItems, function (item) {
          return item.value === object.impact_assessment;
        });
      }

      this.$refs['edit-observation'].show()
    },
    editObservationFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      this.editForm.impact_assessment = this.selectedImpact ? this.selectedImpact.value : '';

      if (this.activity && this.activity.type == 'control_assessment') {
        if (this.selectedTask && this.selectedTask.id) {
          this.editForm.scope_id = this.selectedTask ? this.selectedTask.id : '';
        }
      } else {
        this.editForm.scope_id = this.selectedScope ? this.selectedScope.id : '';
      }

      if (this.selectedImpact && this.selectedImpact.value) {
        piincHttp.put('projects/' + this.$route.params.slug + '/observations/' + this.selectedS.id, this.editForm).then(function (response) {
          self.hideEditModal();
          self.loadObservations(self.selectedTask.id);
          self.$toastr('success', self.$t('projects.observations.update.success'))
          self.buttonDisabled = false;
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.users) {
              self.error += ' ' + error.data.errors.users[0]
            }
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (!this.selectedScope || (this.selectedScope && !this.selectedScope.id)) {
          this.error += this.$t('projects.observations.create.scope_error_message')
        }
        if (!this.selectedImpact || (this.selectedImpact && !this.selectedImpact.value)) {
          this.error += ' ' + this.$t('projects.observations.create.impact_error_message')
        }
      }
    },
    hideEditModal() {
      this.selectedS = {}
      this.$refs['edit-observation'].hide()
    },
    hideEditTestModal() {
      this.selectedS = {}
      this.$refs['create-test'].hide()
    },
    hideUpdateTestModal() {
      this.selectedS = {}
      this.$refs['update-test'].hide()
    },
    hideShowTestModal() {
      this.selectedS = {}
      this.$refs['show-test'].hide()
    },
    showSConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-observation'].show()
    },
    showTestConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-test'].show()
    },
    hideSConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-observation'].hide()
    },
    hideTestConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-test'].hide()
    },
    handleCloseViewModal() {
      this.loadObservations(this.selectedTask.id);
      this.viewObservationModal = false;
      this.selectedObservation = []
    },
    openViewModal(object) {
      this.selectedObservation = object
      this.viewObservationModal = true
    },
    onDragOver(event) {
      // Optional: You can handle visual cues when dragging over the area.
    },
    processFiles(fileList) {
      // Process the list of files
      for (let i = 0; i < fileList.length; i++) {
        this.files.push(fileList[i]);
      }

      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.files[i]);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.sizeError = this.$t('system.file_size_30');
        this.files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.sizeError = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }

    },

    processFilesDocumentation(fileList) {
      // Process the list of files
      for (let i = 0; i < fileList.length; i++) {
        this.data_collection_files.push(fileList[i]);
      }

      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i]);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }

    },
    onFileDrop(event) {
      // Handle the file drop, prevent default to stop the default behavior
    },
    handleDrop(event) {
      event.preventDefault(); // Prevent the default file-open behavior
      const files = event.dataTransfer.files; // Get the dropped files
      if (files.length) {
        this.processFiles(files); // Call a custom method to handle the files
      }
    },
    handleDropDocumentation(event) {
      event.preventDefault(); // Prevent the default file-open behavior
      const data_collection_files = event.dataTransfer.files; // Get the dropped files
      if (data_collection_files.length) {
        this.processFilesDocumentation(data_collection_files); // Call a custom method to handle the files
      }
    },
    hideDropActiveFunction() {
      // Handle when drop area becomes inactive
    },
  },
  created() {
    // this.loadTaskById(this.task.id);
  }
}
</script>
<style scoped>
.b-modal .modal-title {
  text-align: center;
  width: 100%;
  /* Ensures full width for proper centering */
  margin: 0 auto;
  /* Centers the title */
}
</style>
